(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3558"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3558"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lPUkq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a0b31aa5542ced95$var$Search;

var $l47u5 = parcelRequire("l47u5");

var $a0b31aa5542ced95$var$_searchRESTApi = $a0b31aa5542ced95$var$_interopRequireDefault((parcelRequire("c3rYm")));

var $iD6GO = parcelRequire("iD6GO");

var $a0b31aa5542ced95$var$_NewTabIcon = $a0b31aa5542ced95$var$_interopRequireDefault((parcelRequire("3k97u")));
function $a0b31aa5542ced95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $a0b31aa5542ced95$var$_extends() {
    return $a0b31aa5542ced95$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a0b31aa5542ced95$var$_extends.apply(null, arguments);
}
const $a0b31aa5542ced95$var$React = window.React || null;
const { useEffect: $a0b31aa5542ced95$var$useEffect, useCallback: $a0b31aa5542ced95$var$useCallback } = $a0b31aa5542ced95$var$React;
function $a0b31aa5542ced95$var$Search({ onClose: onClose }) {
    const refSearchEl = $a0b31aa5542ced95$var$React.useRef(null);
    const refForm = $a0b31aa5542ced95$var$React.useRef(null);
    const refGlow = $a0b31aa5542ced95$var$React.useRef(null);
    const handleSubmit = $a0b31aa5542ced95$var$useCallback((event)=>{
        event.preventDefault();
        const formData = new FormData(event.target);
        const searchTerm = formData.get('s');
        if (searchTerm) {
            const searchUrl = `/?s=${encodeURIComponent(searchTerm)}`;
            window.open(searchUrl, '_blank');
        }
        onClose?.();
    }, [
        onClose
    ]);
    const SearchInput = $a0b31aa5542ced95$var$React.memo(()=>{
        $a0b31aa5542ced95$var$useEffect(()=>{
            if (typeof anime === 'function' && refSearchEl.current) anime({
                targets: refSearchEl.current,
                opacity: [
                    0,
                    1
                ],
                duration: 300,
                easing: 'easeInOutQuad',
                delay: 100
            });
        }, []);
        return /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("input", {
            type: "search",
            placeholder: "Search...",
            "aria-label": "Search",
            className: "form-control form-control border-0 rounded-0 px-3 rounded-pill adw-search",
            ref: refSearchEl,
            name: "s"
        });
    });
    return /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("div", {
        className: "position-relative"
    }, /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("div", {
        ref: refGlow,
        className: "search-form-glow"
    }), /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("form", {
        onSubmit: handleSubmit,
        className: "d-flex rounded-pill border gap-2 py-2 ps-2 pe-3 z-1 position-relative align-items-center",
        method: "GET",
        action: "/",
        target: "_blank",
        ref: refForm,
        style: {
            backgroundColor: 'var(--bs-light-bg-subtle)'
        }
    }, /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("div", {
        className: "flex-grow-1"
    }, /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("label", {
        htmlFor: "s",
        className: "visually-hidden"
    }, "Search"), /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement(SearchInput, null)), /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("button", {
        className: "btn btn-link border-0 p-0 text-hover-primary",
        type: "submit"
    }, /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement($a0b31aa5542ced95$var$SearchIcon, null))), /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement($a0b31aa5542ced95$var$SearchResults, {
        refSearchEl: refSearchEl,
        refForm: refForm,
        refGlow: refGlow
    }));
}
const $a0b31aa5542ced95$var$SearchIcon = (props)=>{
    return /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("svg", $a0b31aa5542ced95$var$_extends({}, props, {
        style: {
            transform: 'rotate(-18deg)'
        },
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }), /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("path", {
        d: "M19.6162 26.7015L16.1375 19.4884C14.8806 19.7553 13.5371 19.6991 12.2382 19.2424C8.57158 17.9535 6.67425 14.0194 7.99991 10.4544C9.32557 6.88943 13.3718 5.04468 17.0384 6.3336C20.705 7.62253 22.6024 11.5566 21.2767 15.1216C20.8071 16.3845 19.9914 17.4253 18.9776 18.1936L22.4563 25.4066L19.6162 26.7015ZM12.7715 17.8081C15.6179 18.8087 18.7721 17.3713 19.8015 14.603C20.8309 11.8348 19.3514 8.76851 16.5051 7.76792C13.6587 6.76732 10.5045 8.20477 9.47511 10.973C8.44572 13.7412 9.92515 16.8075 12.7715 17.8081Z"
    }));
};
const $a0b31aa5542ced95$var$SearchResults = ({ refSearchEl: refSearchEl, refForm: refForm, refGlow: refGlow })=>{
    const refPlaceholderList = $a0b31aa5542ced95$var$React.useRef(null);
    const [searchResults, setSearchResults] = $a0b31aa5542ced95$var$React.useState([]);
    const [resultsTotalPages, setResultsTotalPages] = $a0b31aa5542ced95$var$React.useState(0);
    const [isSearching, setIsSearching] = $a0b31aa5542ced95$var$React.useState(false);
    const [searchTerm, setSearchTerm] = $a0b31aa5542ced95$var$React.useState(''); // Search Term
    const abortController = new AbortController();
    function handleSearchChange(event) {
        const target = event.target;
        setSearchTerm(target.value);
    }
    $a0b31aa5542ced95$var$useEffect(()=>{
        async function fetchSearchResults() {
            try {
                setIsSearching(true);
                const res = await (0, $a0b31aa5542ced95$var$_searchRESTApi.default)({
                    searchString: searchTerm,
                    signal: abortController.signal
                });
                if (res && Array.isArray(res.results)) {
                    setSearchResults(res.results);
                    setResultsTotalPages(Number(res.totalPages || 0));
                } else {
                    setSearchResults([]);
                    setResultsTotalPages(0);
                }
            } catch (error) {
                console.error(error);
                setSearchResults([]);
                setResultsTotalPages(0);
            } finally{
                setIsSearching(false);
            }
        }
        if (searchTerm.length >= 3) {
            const debounceSearch = (0, $iD6GO.debounce)(400, ()=>{
                fetchSearchResults();
            });
            debounceSearch();
        }
        return ()=>{
            abortController.abort();
        };
    }, [
        searchTerm
    ]);
    $a0b31aa5542ced95$var$useEffect(()=>{
        refSearchEl.current?.addEventListener('input', handleSearchChange, {
            passive: true
        });
        return ()=>{
            refSearchEl.current?.removeEventListener('input', handleSearchChange);
        };
    }, []);
    const clearSearch = ()=>{
        setSearchTerm('');
        setSearchResults([]);
        setResultsTotalPages(0);
        if (refSearchEl.current) refSearchEl.current.value = '';
    };
    $a0b31aa5542ced95$var$useEffect(()=>{
        if (searchTerm?.length > 0 && isSearching) {
            refForm.current?.classList.add('border-animate');
            refGlow.current?.classList.add('is-active');
        } else {
            refForm.current?.classList.remove('border-animate');
            refGlow.current?.classList.remove('is-active');
        }
    }, [
        refForm,
        refGlow,
        searchTerm,
        isSearching
    ]);
    // Animate list item widths using transform
    $a0b31aa5542ced95$var$useEffect(()=>{
        if (refPlaceholderList.current) {
            const listItems = refPlaceholderList.current.querySelectorAll('.placeholder');
            listItems.forEach((item)=>{
                // Use anime with reverse true to animate from width random width to original width using transform and scaleX
                if ('function' === typeof anime) {
                    anime.set(item, {
                        transformOrigin: 'left center'
                    });
                    anime({
                        targets: item,
                        scaleX: [
                            Math.random() + 0.5,
                            1
                        ],
                        duration: 5000,
                        easing: 'easeInOutQuad',
                        delay: anime.stagger(200),
                        loop: true,
                        direction: 'alternate'
                    });
                }
            });
        }
    }, [
        isSearching,
        refPlaceholderList
    ]);
    const UnstyledList = ({ children: children, ref: ref, ...props })=>/*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("ul", $a0b31aa5542ced95$var$_extends({}, props, {
            ref: ref,
            className: "list-unstyled mb-0 d-flex flex-column gap-3 gap-lg-4 my-lg-4"
        }), children);
    return /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("div", {
        className: "position-relative"
    }, searchTerm?.length > 0 && /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("div", {
        className: "position-absolute z-1 w-100 px-3 px-lg-4 py-3 mt-4 border rounded-4",
        style: {
            overflowY: 'auto',
            backgroundColor: 'var(--bs-body-bg)',
            boxShadow: 'rgba(0, 0, 0, 0.15) 0em 20px 32px 5px'
        }
    }, /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("div", {
        className: "placeholder-glow",
        role: "status"
    }, isSearching && /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement($a0b31aa5542ced95$var$React.Fragment, null, /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("div", {
        className: "mb-2"
    }, "Searching..."), /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement(UnstyledList, {
        ref: refPlaceholderList,
        style: {
            maxWidth: '800px'
        }
    }, /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("li", {
        className: "placeholder my-2 col-6"
    }), /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("li", {
        className: "placeholder my-2 col-10"
    }), /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("li", {
        className: "placeholder my-2 col-6"
    }), /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("li", {
        className: "placeholder my-2 col-9"
    }), /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("li", {
        className: "placeholder my-2 col-8"
    }), /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("li", {
        className: "placeholder my-2 col-11"
    })))), searchResults.length === 0 && !isSearching && /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("p", {
        className: "my-4 text-primary fw-semibold"
    }, "No results found."), searchResults?.length > 0 && !isSearching && /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement($a0b31aa5542ced95$var$React.Fragment, null, /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("div", {
        className: "d-flex align-items-center justify-content-between pb-2 mb-3 border-bottom fw-semibold"
    }, /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("p", {
        className: "d-flex mb-0"
    }, "Showing results for: ", /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("span", {
        className: "fw-bold text-primary"
    }, "\xA0", searchTerm)), /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("a", {
        href: "#",
        className: "opacity-75 fs-7",
        onClick: clearSearch
    }, "Clear Search")), /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("div", null, /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement(UnstyledList, null, searchResults.map((result)=>{
        const titleStr = (0, $l47u5.decode)(result.title);
        return /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("li", {
            key: result.id,
            className: ""
        }, /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("a", {
            className: "d-block text-decoration-none text-hover-primary",
            href: result.url
        }, titleStr));
    })), resultsTotalPages > 1 && /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("div", {
        className: "mt-3 mx-n3 mx-lg-n4 mb-n3"
    }, /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("a", {
        className: "btn btn-link d-flex rounded-0 justify-content-center border-top w-100 text-center align-items-center gap-1",
        href: `/?s=${encodeURIComponent(searchTerm)}`,
        target: "_blank",
        rel: "noopener noreferrer"
    }, /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement("span", null, "View All"), /*#__PURE__*/ $a0b31aa5542ced95$var$React.createElement($a0b31aa5542ced95$var$_NewTabIcon.default, {
        className: "fs-8"
    })))))));
};

});
parcelRegister("l47u5", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $f55fc6ebd35f6bf8$export$2f872c0f2117be69; });

var $4EgQc = parcelRequire("4EgQc");

var $b2S6k = parcelRequire("b2S6k");

var $3LYBZ = parcelRequire("3LYBZ");
var $f55fc6ebd35f6bf8$var$__assign = undefined && undefined.__assign || function() {
    $f55fc6ebd35f6bf8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f55fc6ebd35f6bf8$var$__assign.apply(this, arguments);
};
var $f55fc6ebd35f6bf8$var$allNamedReferences = $f55fc6ebd35f6bf8$var$__assign($f55fc6ebd35f6bf8$var$__assign({}, (0, $4EgQc.namedReferences)), {
    all: (0, $4EgQc.namedReferences).html5
});
var $f55fc6ebd35f6bf8$var$encodeRegExps = {
    specialChars: /[<>'"&]/g,
    nonAscii: /[<>'"&\u0080-\uD7FF\uE000-\uFFFF\uDC00-\uDFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]?/g,
    nonAsciiPrintable: /[<>'"&\x01-\x08\x11-\x15\x17-\x1F\x7f-\uD7FF\uE000-\uFFFF\uDC00-\uDFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]?/g,
    nonAsciiPrintableOnly: /[\x01-\x08\x11-\x15\x17-\x1F\x7f-\uD7FF\uE000-\uFFFF\uDC00-\uDFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]?/g,
    extensive: /[\x01-\x0c\x0e-\x1f\x21-\x2c\x2e-\x2f\x3a-\x40\x5b-\x60\x7b-\x7d\x7f-\uD7FF\uE000-\uFFFF\uDC00-\uDFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]?/g
};
var $f55fc6ebd35f6bf8$var$defaultEncodeOptions = {
    mode: 'specialChars',
    level: 'all',
    numeric: 'decimal'
};
function $f55fc6ebd35f6bf8$export$c564cdbbe6da493(text, _a) {
    var _b = _a === void 0 ? $f55fc6ebd35f6bf8$var$defaultEncodeOptions : _a, _c = _b.mode, mode = _c === void 0 ? 'specialChars' : _c, _d = _b.numeric, numeric = _d === void 0 ? 'decimal' : _d, _e = _b.level, level = _e === void 0 ? 'all' : _e;
    if (!text) return '';
    var encodeRegExp = $f55fc6ebd35f6bf8$var$encodeRegExps[mode];
    var references = $f55fc6ebd35f6bf8$var$allNamedReferences[level].characters;
    var isHex = numeric === 'hexadecimal';
    return String.prototype.replace.call(text, encodeRegExp, function(input) {
        var result = references[input];
        if (!result) {
            var code = input.length > 1 ? (0, $3LYBZ.getCodePoint)(input, 0) : input.charCodeAt(0);
            result = (isHex ? '&#x' + code.toString(16) : '&#' + code) + ';';
        }
        return result;
    });
}
var $f55fc6ebd35f6bf8$var$defaultDecodeOptions = {
    scope: 'body',
    level: 'all'
};
var $f55fc6ebd35f6bf8$var$strict = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);/g;
var $f55fc6ebd35f6bf8$var$attribute = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+)[;=]?/g;
var $f55fc6ebd35f6bf8$var$baseDecodeRegExps = {
    xml: {
        strict: $f55fc6ebd35f6bf8$var$strict,
        attribute: $f55fc6ebd35f6bf8$var$attribute,
        body: (0, $4EgQc.bodyRegExps).xml
    },
    html4: {
        strict: $f55fc6ebd35f6bf8$var$strict,
        attribute: $f55fc6ebd35f6bf8$var$attribute,
        body: (0, $4EgQc.bodyRegExps).html4
    },
    html5: {
        strict: $f55fc6ebd35f6bf8$var$strict,
        attribute: $f55fc6ebd35f6bf8$var$attribute,
        body: (0, $4EgQc.bodyRegExps).html5
    }
};
var $f55fc6ebd35f6bf8$var$decodeRegExps = $f55fc6ebd35f6bf8$var$__assign($f55fc6ebd35f6bf8$var$__assign({}, $f55fc6ebd35f6bf8$var$baseDecodeRegExps), {
    all: $f55fc6ebd35f6bf8$var$baseDecodeRegExps.html5
});
var $f55fc6ebd35f6bf8$var$fromCharCode = String.fromCharCode;
var $f55fc6ebd35f6bf8$var$outOfBoundsChar = $f55fc6ebd35f6bf8$var$fromCharCode(65533);
var $f55fc6ebd35f6bf8$var$defaultDecodeEntityOptions = {
    level: 'all'
};
function $f55fc6ebd35f6bf8$var$getDecodedEntity(entity, references, isAttribute, isStrict) {
    var decodeResult = entity;
    var decodeEntityLastChar = entity[entity.length - 1];
    if (isAttribute && decodeEntityLastChar === '=') decodeResult = entity;
    else if (isStrict && decodeEntityLastChar !== ';') decodeResult = entity;
    else {
        var decodeResultByReference = references[entity];
        if (decodeResultByReference) decodeResult = decodeResultByReference;
        else if (entity[0] === '&' && entity[1] === '#') {
            var decodeSecondChar = entity[2];
            var decodeCode = decodeSecondChar == 'x' || decodeSecondChar == 'X' ? parseInt(entity.substr(3), 16) : parseInt(entity.substr(2));
            decodeResult = decodeCode >= 0x10ffff ? $f55fc6ebd35f6bf8$var$outOfBoundsChar : decodeCode > 65535 ? (0, $3LYBZ.fromCodePoint)(decodeCode) : $f55fc6ebd35f6bf8$var$fromCharCode((0, $b2S6k.numericUnicodeMap)[decodeCode] || decodeCode);
        }
    }
    return decodeResult;
}
function $f55fc6ebd35f6bf8$export$3fc0912547321ab3(entity, _a) {
    var _b = _a === void 0 ? $f55fc6ebd35f6bf8$var$defaultDecodeEntityOptions : _a, _c = _b.level, level = _c === void 0 ? 'all' : _c;
    if (!entity) return '';
    return $f55fc6ebd35f6bf8$var$getDecodedEntity(entity, $f55fc6ebd35f6bf8$var$allNamedReferences[level].entities, false, false);
}
function $f55fc6ebd35f6bf8$export$2f872c0f2117be69(text, _a) {
    var _b = _a === void 0 ? $f55fc6ebd35f6bf8$var$defaultDecodeOptions : _a, _c = _b.level, level = _c === void 0 ? 'all' : _c, _d = _b.scope, scope = _d === void 0 ? level === 'xml' ? 'strict' : 'body' : _d;
    if (!text) return '';
    var decodeRegExp = $f55fc6ebd35f6bf8$var$decodeRegExps[level][scope];
    var references = $f55fc6ebd35f6bf8$var$allNamedReferences[level].entities;
    var isAttribute = scope === 'attribute';
    var isStrict = scope === 'strict';
    return text.replace(decodeRegExp, function(entity) {
        return $f55fc6ebd35f6bf8$var$getDecodedEntity(entity, references, isAttribute, isStrict);
    });
}

});
parcelRegister("4EgQc", function(module, exports) {

$parcel$export(module.exports, "bodyRegExps", function () { return $3627f61c8f79bb4a$export$a63c3bb049c156df; });
$parcel$export(module.exports, "namedReferences", function () { return $3627f61c8f79bb4a$export$e7660db2439a79f4; });
var $3627f61c8f79bb4a$var$__assign = undefined && undefined.__assign || function() {
    $3627f61c8f79bb4a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3627f61c8f79bb4a$var$__assign.apply(this, arguments);
};
// This file is autogenerated by tools/process-named-references.ts
var $3627f61c8f79bb4a$var$pairDivider = "~";
var $3627f61c8f79bb4a$var$blockDivider = "~~";
function $3627f61c8f79bb4a$var$generateNamedReferences(input, prev) {
    var entities = {};
    var characters = {};
    var blocks = input.split($3627f61c8f79bb4a$var$blockDivider);
    var isOptionalBlock = false;
    for(var i = 0; blocks.length > i; i++){
        var entries = blocks[i].split($3627f61c8f79bb4a$var$pairDivider);
        for(var j = 0; j < entries.length; j += 2){
            var entity = entries[j];
            var character = entries[j + 1];
            var fullEntity = '&' + entity + ';';
            entities[fullEntity] = character;
            if (isOptionalBlock) entities['&' + entity] = character;
            characters[character] = fullEntity;
        }
        isOptionalBlock = true;
    }
    return prev ? {
        entities: $3627f61c8f79bb4a$var$__assign($3627f61c8f79bb4a$var$__assign({}, entities), prev.entities),
        characters: $3627f61c8f79bb4a$var$__assign($3627f61c8f79bb4a$var$__assign({}, characters), prev.characters)
    } : {
        entities: entities,
        characters: characters
    };
}
var $3627f61c8f79bb4a$export$a63c3bb049c156df = {
    xml: /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,
    html4: /&notin;|&(?:nbsp|iexcl|cent|pound|curren|yen|brvbar|sect|uml|copy|ordf|laquo|not|shy|reg|macr|deg|plusmn|sup2|sup3|acute|micro|para|middot|cedil|sup1|ordm|raquo|frac14|frac12|frac34|iquest|Agrave|Aacute|Acirc|Atilde|Auml|Aring|AElig|Ccedil|Egrave|Eacute|Ecirc|Euml|Igrave|Iacute|Icirc|Iuml|ETH|Ntilde|Ograve|Oacute|Ocirc|Otilde|Ouml|times|Oslash|Ugrave|Uacute|Ucirc|Uuml|Yacute|THORN|szlig|agrave|aacute|acirc|atilde|auml|aring|aelig|ccedil|egrave|eacute|ecirc|euml|igrave|iacute|icirc|iuml|eth|ntilde|ograve|oacute|ocirc|otilde|ouml|divide|oslash|ugrave|uacute|ucirc|uuml|yacute|thorn|yuml|quot|amp|lt|gt|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,
    html5: /&centerdot;|&copysr;|&divideontimes;|&gtcc;|&gtcir;|&gtdot;|&gtlPar;|&gtquest;|&gtrapprox;|&gtrarr;|&gtrdot;|&gtreqless;|&gtreqqless;|&gtrless;|&gtrsim;|&ltcc;|&ltcir;|&ltdot;|&lthree;|&ltimes;|&ltlarr;|&ltquest;|&ltrPar;|&ltri;|&ltrie;|&ltrif;|&notin;|&notinE;|&notindot;|&notinva;|&notinvb;|&notinvc;|&notni;|&notniva;|&notnivb;|&notnivc;|&parallel;|&timesb;|&timesbar;|&timesd;|&(?:AElig|AMP|Aacute|Acirc|Agrave|Aring|Atilde|Auml|COPY|Ccedil|ETH|Eacute|Ecirc|Egrave|Euml|GT|Iacute|Icirc|Igrave|Iuml|LT|Ntilde|Oacute|Ocirc|Ograve|Oslash|Otilde|Ouml|QUOT|REG|THORN|Uacute|Ucirc|Ugrave|Uuml|Yacute|aacute|acirc|acute|aelig|agrave|amp|aring|atilde|auml|brvbar|ccedil|cedil|cent|copy|curren|deg|divide|eacute|ecirc|egrave|eth|euml|frac12|frac14|frac34|gt|iacute|icirc|iexcl|igrave|iquest|iuml|laquo|lt|macr|micro|middot|nbsp|not|ntilde|oacute|ocirc|ograve|ordf|ordm|oslash|otilde|ouml|para|plusmn|pound|quot|raquo|reg|sect|shy|sup1|sup2|sup3|szlig|thorn|times|uacute|ucirc|ugrave|uml|uuml|yacute|yen|yuml|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g
};
var $3627f61c8f79bb4a$export$e7660db2439a79f4 = {};
$3627f61c8f79bb4a$export$e7660db2439a79f4['xml'] = $3627f61c8f79bb4a$var$generateNamedReferences("lt~<~gt~>~quot~\"~apos~'~amp~&");
$3627f61c8f79bb4a$export$e7660db2439a79f4['html4'] = $3627f61c8f79bb4a$var$generateNamedReferences("apos~'~OElig~\u0152~oelig~\u0153~Scaron~\u0160~scaron~\u0161~Yuml~\u0178~circ~\u02C6~tilde~\u02DC~ensp~\u2002~emsp~\u2003~thinsp~\u2009~zwnj~\u200C~zwj~\u200D~lrm~\u200E~rlm~\u200F~ndash~\u2013~mdash~\u2014~lsquo~\u2018~rsquo~\u2019~sbquo~\u201A~ldquo~\u201C~rdquo~\u201D~bdquo~\u201E~dagger~\u2020~Dagger~\u2021~permil~\u2030~lsaquo~\u2039~rsaquo~\u203A~euro~\u20AC~fnof~\u0192~Alpha~\u0391~Beta~\u0392~Gamma~\u0393~Delta~\u0394~Epsilon~\u0395~Zeta~\u0396~Eta~\u0397~Theta~\u0398~Iota~\u0399~Kappa~\u039A~Lambda~\u039B~Mu~\u039C~Nu~\u039D~Xi~\u039E~Omicron~\u039F~Pi~\u03A0~Rho~\u03A1~Sigma~\u03A3~Tau~\u03A4~Upsilon~\u03A5~Phi~\u03A6~Chi~\u03A7~Psi~\u03A8~Omega~\u03A9~alpha~\u03B1~beta~\u03B2~gamma~\u03B3~delta~\u03B4~epsilon~\u03B5~zeta~\u03B6~eta~\u03B7~theta~\u03B8~iota~\u03B9~kappa~\u03BA~lambda~\u03BB~mu~\u03BC~nu~\u03BD~xi~\u03BE~omicron~\u03BF~pi~\u03C0~rho~\u03C1~sigmaf~\u03C2~sigma~\u03C3~tau~\u03C4~upsilon~\u03C5~phi~\u03C6~chi~\u03C7~psi~\u03C8~omega~\u03C9~thetasym~\u03D1~upsih~\u03D2~piv~\u03D6~bull~\u2022~hellip~\u2026~prime~\u2032~Prime~\u2033~oline~\u203E~frasl~\u2044~weierp~\u2118~image~\u2111~real~\u211C~trade~\u2122~alefsym~\u2135~larr~\u2190~uarr~\u2191~rarr~\u2192~darr~\u2193~harr~\u2194~crarr~\u21B5~lArr~\u21D0~uArr~\u21D1~rArr~\u21D2~dArr~\u21D3~hArr~\u21D4~forall~\u2200~part~\u2202~exist~\u2203~empty~\u2205~nabla~\u2207~isin~\u2208~notin~\u2209~ni~\u220B~prod~\u220F~sum~\u2211~minus~\u2212~lowast~\u2217~radic~\u221A~prop~\u221D~infin~\u221E~ang~\u2220~and~\u2227~or~\u2228~cap~\u2229~cup~\u222A~int~\u222B~there4~\u2234~sim~\u223C~cong~\u2245~asymp~\u2248~ne~\u2260~equiv~\u2261~le~\u2264~ge~\u2265~sub~\u2282~sup~\u2283~nsub~\u2284~sube~\u2286~supe~\u2287~oplus~\u2295~otimes~\u2297~perp~\u22A5~sdot~\u22C5~lceil~\u2308~rceil~\u2309~lfloor~\u230A~rfloor~\u230B~lang~\u2329~rang~\u232A~loz~\u25CA~spades~\u2660~clubs~\u2663~hearts~\u2665~diams~\u2666~~nbsp~\xa0~iexcl~\xa1~cent~\xa2~pound~\xa3~curren~\xa4~yen~\xa5~brvbar~\xa6~sect~\xa7~uml~\xa8~copy~\xa9~ordf~\xaa~laquo~\xab~not~\xac~shy~\xad~reg~\xae~macr~\xaf~deg~\xb0~plusmn~\xb1~sup2~\xb2~sup3~\xb3~acute~\xb4~micro~\xb5~para~\xb6~middot~\xb7~cedil~\xb8~sup1~\xb9~ordm~\xba~raquo~\xbb~frac14~\xbc~frac12~\xbd~frac34~\xbe~iquest~\xbf~Agrave~\xc0~Aacute~\xc1~Acirc~\xc2~Atilde~\xc3~Auml~\xc4~Aring~\xc5~AElig~\xc6~Ccedil~\xc7~Egrave~\xc8~Eacute~\xc9~Ecirc~\xca~Euml~\xcb~Igrave~\xcc~Iacute~\xcd~Icirc~\xce~Iuml~\xcf~ETH~\xd0~Ntilde~\xd1~Ograve~\xd2~Oacute~\xd3~Ocirc~\xd4~Otilde~\xd5~Ouml~\xd6~times~\xd7~Oslash~\xd8~Ugrave~\xd9~Uacute~\xda~Ucirc~\xdb~Uuml~\xdc~Yacute~\xdd~THORN~\xde~szlig~\xdf~agrave~\xe0~aacute~\xe1~acirc~\xe2~atilde~\xe3~auml~\xe4~aring~\xe5~aelig~\xe6~ccedil~\xe7~egrave~\xe8~eacute~\xe9~ecirc~\xea~euml~\xeb~igrave~\xec~iacute~\xed~icirc~\xee~iuml~\xef~eth~\xf0~ntilde~\xf1~ograve~\xf2~oacute~\xf3~ocirc~\xf4~otilde~\xf5~ouml~\xf6~divide~\xf7~oslash~\xf8~ugrave~\xf9~uacute~\xfa~ucirc~\xfb~uuml~\xfc~yacute~\xfd~thorn~\xfe~yuml~\xff~quot~\"~amp~&~lt~<~gt~>");
$3627f61c8f79bb4a$export$e7660db2439a79f4['html5'] = $3627f61c8f79bb4a$var$generateNamedReferences('Abreve~\u0102~Acy~\u0410~Afr~\uD835\uDD04~Amacr~\u0100~And~\u2A53~Aogon~\u0104~Aopf~\uD835\uDD38~ApplyFunction~\u2061~Ascr~\uD835\uDC9C~Assign~\u2254~Backslash~\u2216~Barv~\u2AE7~Barwed~\u2306~Bcy~\u0411~Because~\u2235~Bernoullis~\u212C~Bfr~\uD835\uDD05~Bopf~\uD835\uDD39~Breve~\u02D8~Bscr~\u212C~Bumpeq~\u224E~CHcy~\u0427~Cacute~\u0106~Cap~\u22D2~CapitalDifferentialD~\u2145~Cayleys~\u212D~Ccaron~\u010C~Ccirc~\u0108~Cconint~\u2230~Cdot~\u010A~Cedilla~\xb8~CenterDot~\xb7~Cfr~\u212D~CircleDot~\u2299~CircleMinus~\u2296~CirclePlus~\u2295~CircleTimes~\u2297~ClockwiseContourIntegral~\u2232~CloseCurlyDoubleQuote~\u201D~CloseCurlyQuote~\u2019~Colon~\u2237~Colone~\u2A74~Congruent~\u2261~Conint~\u222F~ContourIntegral~\u222E~Copf~\u2102~Coproduct~\u2210~CounterClockwiseContourIntegral~\u2233~Cross~\u2A2F~Cscr~\uD835\uDC9E~Cup~\u22D3~CupCap~\u224D~DD~\u2145~DDotrahd~\u2911~DJcy~\u0402~DScy~\u0405~DZcy~\u040F~Darr~\u21A1~Dashv~\u2AE4~Dcaron~\u010E~Dcy~\u0414~Del~\u2207~Dfr~\uD835\uDD07~DiacriticalAcute~\xb4~DiacriticalDot~\u02D9~DiacriticalDoubleAcute~\u02DD~DiacriticalGrave~`~DiacriticalTilde~\u02DC~Diamond~\u22C4~DifferentialD~\u2146~Dopf~\uD835\uDD3B~Dot~\xa8~DotDot~\u20DC~DotEqual~\u2250~DoubleContourIntegral~\u222F~DoubleDot~\xa8~DoubleDownArrow~\u21D3~DoubleLeftArrow~\u21D0~DoubleLeftRightArrow~\u21D4~DoubleLeftTee~\u2AE4~DoubleLongLeftArrow~\u27F8~DoubleLongLeftRightArrow~\u27FA~DoubleLongRightArrow~\u27F9~DoubleRightArrow~\u21D2~DoubleRightTee~\u22A8~DoubleUpArrow~\u21D1~DoubleUpDownArrow~\u21D5~DoubleVerticalBar~\u2225~DownArrow~\u2193~DownArrowBar~\u2913~DownArrowUpArrow~\u21F5~DownBreve~\u0311~DownLeftRightVector~\u2950~DownLeftTeeVector~\u295E~DownLeftVector~\u21BD~DownLeftVectorBar~\u2956~DownRightTeeVector~\u295F~DownRightVector~\u21C1~DownRightVectorBar~\u2957~DownTee~\u22A4~DownTeeArrow~\u21A7~Downarrow~\u21D3~Dscr~\uD835\uDC9F~Dstrok~\u0110~ENG~\u014A~Ecaron~\u011A~Ecy~\u042D~Edot~\u0116~Efr~\uD835\uDD08~Element~\u2208~Emacr~\u0112~EmptySmallSquare~\u25FB~EmptyVerySmallSquare~\u25AB~Eogon~\u0118~Eopf~\uD835\uDD3C~Equal~\u2A75~EqualTilde~\u2242~Equilibrium~\u21CC~Escr~\u2130~Esim~\u2A73~Exists~\u2203~ExponentialE~\u2147~Fcy~\u0424~Ffr~\uD835\uDD09~FilledSmallSquare~\u25FC~FilledVerySmallSquare~\u25AA~Fopf~\uD835\uDD3D~ForAll~\u2200~Fouriertrf~\u2131~Fscr~\u2131~GJcy~\u0403~Gammad~\u03DC~Gbreve~\u011E~Gcedil~\u0122~Gcirc~\u011C~Gcy~\u0413~Gdot~\u0120~Gfr~\uD835\uDD0A~Gg~\u22D9~Gopf~\uD835\uDD3E~GreaterEqual~\u2265~GreaterEqualLess~\u22DB~GreaterFullEqual~\u2267~GreaterGreater~\u2AA2~GreaterLess~\u2277~GreaterSlantEqual~\u2A7E~GreaterTilde~\u2273~Gscr~\uD835\uDCA2~Gt~\u226B~HARDcy~\u042A~Hacek~\u02C7~Hat~^~Hcirc~\u0124~Hfr~\u210C~HilbertSpace~\u210B~Hopf~\u210D~HorizontalLine~\u2500~Hscr~\u210B~Hstrok~\u0126~HumpDownHump~\u224E~HumpEqual~\u224F~IEcy~\u0415~IJlig~\u0132~IOcy~\u0401~Icy~\u0418~Idot~\u0130~Ifr~\u2111~Im~\u2111~Imacr~\u012A~ImaginaryI~\u2148~Implies~\u21D2~Int~\u222C~Integral~\u222B~Intersection~\u22C2~InvisibleComma~\u2063~InvisibleTimes~\u2062~Iogon~\u012E~Iopf~\uD835\uDD40~Iscr~\u2110~Itilde~\u0128~Iukcy~\u0406~Jcirc~\u0134~Jcy~\u0419~Jfr~\uD835\uDD0D~Jopf~\uD835\uDD41~Jscr~\uD835\uDCA5~Jsercy~\u0408~Jukcy~\u0404~KHcy~\u0425~KJcy~\u040C~Kcedil~\u0136~Kcy~\u041A~Kfr~\uD835\uDD0E~Kopf~\uD835\uDD42~Kscr~\uD835\uDCA6~LJcy~\u0409~Lacute~\u0139~Lang~\u27EA~Laplacetrf~\u2112~Larr~\u219E~Lcaron~\u013D~Lcedil~\u013B~Lcy~\u041B~LeftAngleBracket~\u27E8~LeftArrow~\u2190~LeftArrowBar~\u21E4~LeftArrowRightArrow~\u21C6~LeftCeiling~\u2308~LeftDoubleBracket~\u27E6~LeftDownTeeVector~\u2961~LeftDownVector~\u21C3~LeftDownVectorBar~\u2959~LeftFloor~\u230A~LeftRightArrow~\u2194~LeftRightVector~\u294E~LeftTee~\u22A3~LeftTeeArrow~\u21A4~LeftTeeVector~\u295A~LeftTriangle~\u22B2~LeftTriangleBar~\u29CF~LeftTriangleEqual~\u22B4~LeftUpDownVector~\u2951~LeftUpTeeVector~\u2960~LeftUpVector~\u21BF~LeftUpVectorBar~\u2958~LeftVector~\u21BC~LeftVectorBar~\u2952~Leftarrow~\u21D0~Leftrightarrow~\u21D4~LessEqualGreater~\u22DA~LessFullEqual~\u2266~LessGreater~\u2276~LessLess~\u2AA1~LessSlantEqual~\u2A7D~LessTilde~\u2272~Lfr~\uD835\uDD0F~Ll~\u22D8~Lleftarrow~\u21DA~Lmidot~\u013F~LongLeftArrow~\u27F5~LongLeftRightArrow~\u27F7~LongRightArrow~\u27F6~Longleftarrow~\u27F8~Longleftrightarrow~\u27FA~Longrightarrow~\u27F9~Lopf~\uD835\uDD43~LowerLeftArrow~\u2199~LowerRightArrow~\u2198~Lscr~\u2112~Lsh~\u21B0~Lstrok~\u0141~Lt~\u226A~Map~\u2905~Mcy~\u041C~MediumSpace~\u205F~Mellintrf~\u2133~Mfr~\uD835\uDD10~MinusPlus~\u2213~Mopf~\uD835\uDD44~Mscr~\u2133~NJcy~\u040A~Nacute~\u0143~Ncaron~\u0147~Ncedil~\u0145~Ncy~\u041D~NegativeMediumSpace~\u200B~NegativeThickSpace~\u200B~NegativeThinSpace~\u200B~NegativeVeryThinSpace~\u200B~NestedGreaterGreater~\u226B~NestedLessLess~\u226A~NewLine~\n~Nfr~\uD835\uDD11~NoBreak~\u2060~NonBreakingSpace~\xa0~Nopf~\u2115~Not~\u2AEC~NotCongruent~\u2262~NotCupCap~\u226D~NotDoubleVerticalBar~\u2226~NotElement~\u2209~NotEqual~\u2260~NotEqualTilde~\u2242\u0338~NotExists~\u2204~NotGreater~\u226F~NotGreaterEqual~\u2271~NotGreaterFullEqual~\u2267\u0338~NotGreaterGreater~\u226B\u0338~NotGreaterLess~\u2279~NotGreaterSlantEqual~\u2A7E\u0338~NotGreaterTilde~\u2275~NotHumpDownHump~\u224E\u0338~NotHumpEqual~\u224F\u0338~NotLeftTriangle~\u22EA~NotLeftTriangleBar~\u29CF\u0338~NotLeftTriangleEqual~\u22EC~NotLess~\u226E~NotLessEqual~\u2270~NotLessGreater~\u2278~NotLessLess~\u226A\u0338~NotLessSlantEqual~\u2A7D\u0338~NotLessTilde~\u2274~NotNestedGreaterGreater~\u2AA2\u0338~NotNestedLessLess~\u2AA1\u0338~NotPrecedes~\u2280~NotPrecedesEqual~\u2AAF\u0338~NotPrecedesSlantEqual~\u22E0~NotReverseElement~\u220C~NotRightTriangle~\u22EB~NotRightTriangleBar~\u29D0\u0338~NotRightTriangleEqual~\u22ED~NotSquareSubset~\u228F\u0338~NotSquareSubsetEqual~\u22E2~NotSquareSuperset~\u2290\u0338~NotSquareSupersetEqual~\u22E3~NotSubset~\u2282\u20D2~NotSubsetEqual~\u2288~NotSucceeds~\u2281~NotSucceedsEqual~\u2AB0\u0338~NotSucceedsSlantEqual~\u22E1~NotSucceedsTilde~\u227F\u0338~NotSuperset~\u2283\u20D2~NotSupersetEqual~\u2289~NotTilde~\u2241~NotTildeEqual~\u2244~NotTildeFullEqual~\u2247~NotTildeTilde~\u2249~NotVerticalBar~\u2224~Nscr~\uD835\uDCA9~Ocy~\u041E~Odblac~\u0150~Ofr~\uD835\uDD12~Omacr~\u014C~Oopf~\uD835\uDD46~OpenCurlyDoubleQuote~\u201C~OpenCurlyQuote~\u2018~Or~\u2A54~Oscr~\uD835\uDCAA~Otimes~\u2A37~OverBar~\u203E~OverBrace~\u23DE~OverBracket~\u23B4~OverParenthesis~\u23DC~PartialD~\u2202~Pcy~\u041F~Pfr~\uD835\uDD13~PlusMinus~\xb1~Poincareplane~\u210C~Popf~\u2119~Pr~\u2ABB~Precedes~\u227A~PrecedesEqual~\u2AAF~PrecedesSlantEqual~\u227C~PrecedesTilde~\u227E~Product~\u220F~Proportion~\u2237~Proportional~\u221D~Pscr~\uD835\uDCAB~Qfr~\uD835\uDD14~Qopf~\u211A~Qscr~\uD835\uDCAC~RBarr~\u2910~Racute~\u0154~Rang~\u27EB~Rarr~\u21A0~Rarrtl~\u2916~Rcaron~\u0158~Rcedil~\u0156~Rcy~\u0420~Re~\u211C~ReverseElement~\u220B~ReverseEquilibrium~\u21CB~ReverseUpEquilibrium~\u296F~Rfr~\u211C~RightAngleBracket~\u27E9~RightArrow~\u2192~RightArrowBar~\u21E5~RightArrowLeftArrow~\u21C4~RightCeiling~\u2309~RightDoubleBracket~\u27E7~RightDownTeeVector~\u295D~RightDownVector~\u21C2~RightDownVectorBar~\u2955~RightFloor~\u230B~RightTee~\u22A2~RightTeeArrow~\u21A6~RightTeeVector~\u295B~RightTriangle~\u22B3~RightTriangleBar~\u29D0~RightTriangleEqual~\u22B5~RightUpDownVector~\u294F~RightUpTeeVector~\u295C~RightUpVector~\u21BE~RightUpVectorBar~\u2954~RightVector~\u21C0~RightVectorBar~\u2953~Rightarrow~\u21D2~Ropf~\u211D~RoundImplies~\u2970~Rrightarrow~\u21DB~Rscr~\u211B~Rsh~\u21B1~RuleDelayed~\u29F4~SHCHcy~\u0429~SHcy~\u0428~SOFTcy~\u042C~Sacute~\u015A~Sc~\u2ABC~Scedil~\u015E~Scirc~\u015C~Scy~\u0421~Sfr~\uD835\uDD16~ShortDownArrow~\u2193~ShortLeftArrow~\u2190~ShortRightArrow~\u2192~ShortUpArrow~\u2191~SmallCircle~\u2218~Sopf~\uD835\uDD4A~Sqrt~\u221A~Square~\u25A1~SquareIntersection~\u2293~SquareSubset~\u228F~SquareSubsetEqual~\u2291~SquareSuperset~\u2290~SquareSupersetEqual~\u2292~SquareUnion~\u2294~Sscr~\uD835\uDCAE~Star~\u22C6~Sub~\u22D0~Subset~\u22D0~SubsetEqual~\u2286~Succeeds~\u227B~SucceedsEqual~\u2AB0~SucceedsSlantEqual~\u227D~SucceedsTilde~\u227F~SuchThat~\u220B~Sum~\u2211~Sup~\u22D1~Superset~\u2283~SupersetEqual~\u2287~Supset~\u22D1~TRADE~\u2122~TSHcy~\u040B~TScy~\u0426~Tab~	~Tcaron~\u0164~Tcedil~\u0162~Tcy~\u0422~Tfr~\uD835\uDD17~Therefore~\u2234~ThickSpace~\u205F\u200A~ThinSpace~\u2009~Tilde~\u223C~TildeEqual~\u2243~TildeFullEqual~\u2245~TildeTilde~\u2248~Topf~\uD835\uDD4B~TripleDot~\u20DB~Tscr~\uD835\uDCAF~Tstrok~\u0166~Uarr~\u219F~Uarrocir~\u2949~Ubrcy~\u040E~Ubreve~\u016C~Ucy~\u0423~Udblac~\u0170~Ufr~\uD835\uDD18~Umacr~\u016A~UnderBar~_~UnderBrace~\u23DF~UnderBracket~\u23B5~UnderParenthesis~\u23DD~Union~\u22C3~UnionPlus~\u228E~Uogon~\u0172~Uopf~\uD835\uDD4C~UpArrow~\u2191~UpArrowBar~\u2912~UpArrowDownArrow~\u21C5~UpDownArrow~\u2195~UpEquilibrium~\u296E~UpTee~\u22A5~UpTeeArrow~\u21A5~Uparrow~\u21D1~Updownarrow~\u21D5~UpperLeftArrow~\u2196~UpperRightArrow~\u2197~Upsi~\u03D2~Uring~\u016E~Uscr~\uD835\uDCB0~Utilde~\u0168~VDash~\u22AB~Vbar~\u2AEB~Vcy~\u0412~Vdash~\u22A9~Vdashl~\u2AE6~Vee~\u22C1~Verbar~\u2016~Vert~\u2016~VerticalBar~\u2223~VerticalLine~|~VerticalSeparator~\u2758~VerticalTilde~\u2240~VeryThinSpace~\u200A~Vfr~\uD835\uDD19~Vopf~\uD835\uDD4D~Vscr~\uD835\uDCB1~Vvdash~\u22AA~Wcirc~\u0174~Wedge~\u22C0~Wfr~\uD835\uDD1A~Wopf~\uD835\uDD4E~Wscr~\uD835\uDCB2~Xfr~\uD835\uDD1B~Xopf~\uD835\uDD4F~Xscr~\uD835\uDCB3~YAcy~\u042F~YIcy~\u0407~YUcy~\u042E~Ycirc~\u0176~Ycy~\u042B~Yfr~\uD835\uDD1C~Yopf~\uD835\uDD50~Yscr~\uD835\uDCB4~ZHcy~\u0416~Zacute~\u0179~Zcaron~\u017D~Zcy~\u0417~Zdot~\u017B~ZeroWidthSpace~\u200B~Zfr~\u2128~Zopf~\u2124~Zscr~\uD835\uDCB5~abreve~\u0103~ac~\u223E~acE~\u223E\u0333~acd~\u223F~acy~\u0430~af~\u2061~afr~\uD835\uDD1E~aleph~\u2135~amacr~\u0101~amalg~\u2A3F~andand~\u2A55~andd~\u2A5C~andslope~\u2A58~andv~\u2A5A~ange~\u29A4~angle~\u2220~angmsd~\u2221~angmsdaa~\u29A8~angmsdab~\u29A9~angmsdac~\u29AA~angmsdad~\u29AB~angmsdae~\u29AC~angmsdaf~\u29AD~angmsdag~\u29AE~angmsdah~\u29AF~angrt~\u221F~angrtvb~\u22BE~angrtvbd~\u299D~angsph~\u2222~angst~\xc5~angzarr~\u237C~aogon~\u0105~aopf~\uD835\uDD52~ap~\u2248~apE~\u2A70~apacir~\u2A6F~ape~\u224A~apid~\u224B~approx~\u2248~approxeq~\u224A~ascr~\uD835\uDCB6~ast~*~asympeq~\u224D~awconint~\u2233~awint~\u2A11~bNot~\u2AED~backcong~\u224C~backepsilon~\u03F6~backprime~\u2035~backsim~\u223D~backsimeq~\u22CD~barvee~\u22BD~barwed~\u2305~barwedge~\u2305~bbrk~\u23B5~bbrktbrk~\u23B6~bcong~\u224C~bcy~\u0431~becaus~\u2235~because~\u2235~bemptyv~\u29B0~bepsi~\u03F6~bernou~\u212C~beth~\u2136~between~\u226C~bfr~\uD835\uDD1F~bigcap~\u22C2~bigcirc~\u25EF~bigcup~\u22C3~bigodot~\u2A00~bigoplus~\u2A01~bigotimes~\u2A02~bigsqcup~\u2A06~bigstar~\u2605~bigtriangledown~\u25BD~bigtriangleup~\u25B3~biguplus~\u2A04~bigvee~\u22C1~bigwedge~\u22C0~bkarow~\u290D~blacklozenge~\u29EB~blacksquare~\u25AA~blacktriangle~\u25B4~blacktriangledown~\u25BE~blacktriangleleft~\u25C2~blacktriangleright~\u25B8~blank~\u2423~blk12~\u2592~blk14~\u2591~blk34~\u2593~block~\u2588~bne~=\u20E5~bnequiv~\u2261\u20E5~bnot~\u2310~bopf~\uD835\uDD53~bot~\u22A5~bottom~\u22A5~bowtie~\u22C8~boxDL~\u2557~boxDR~\u2554~boxDl~\u2556~boxDr~\u2553~boxH~\u2550~boxHD~\u2566~boxHU~\u2569~boxHd~\u2564~boxHu~\u2567~boxUL~\u255D~boxUR~\u255A~boxUl~\u255C~boxUr~\u2559~boxV~\u2551~boxVH~\u256C~boxVL~\u2563~boxVR~\u2560~boxVh~\u256B~boxVl~\u2562~boxVr~\u255F~boxbox~\u29C9~boxdL~\u2555~boxdR~\u2552~boxdl~\u2510~boxdr~\u250C~boxh~\u2500~boxhD~\u2565~boxhU~\u2568~boxhd~\u252C~boxhu~\u2534~boxminus~\u229F~boxplus~\u229E~boxtimes~\u22A0~boxuL~\u255B~boxuR~\u2558~boxul~\u2518~boxur~\u2514~boxv~\u2502~boxvH~\u256A~boxvL~\u2561~boxvR~\u255E~boxvh~\u253C~boxvl~\u2524~boxvr~\u251C~bprime~\u2035~breve~\u02D8~bscr~\uD835\uDCB7~bsemi~\u204F~bsim~\u223D~bsime~\u22CD~bsol~\\~bsolb~\u29C5~bsolhsub~\u27C8~bullet~\u2022~bump~\u224E~bumpE~\u2AAE~bumpe~\u224F~bumpeq~\u224F~cacute~\u0107~capand~\u2A44~capbrcup~\u2A49~capcap~\u2A4B~capcup~\u2A47~capdot~\u2A40~caps~\u2229\uFE00~caret~\u2041~caron~\u02C7~ccaps~\u2A4D~ccaron~\u010D~ccirc~\u0109~ccups~\u2A4C~ccupssm~\u2A50~cdot~\u010B~cemptyv~\u29B2~centerdot~\xb7~cfr~\uD835\uDD20~chcy~\u0447~check~\u2713~checkmark~\u2713~cir~\u25CB~cirE~\u29C3~circeq~\u2257~circlearrowleft~\u21BA~circlearrowright~\u21BB~circledR~\xae~circledS~\u24C8~circledast~\u229B~circledcirc~\u229A~circleddash~\u229D~cire~\u2257~cirfnint~\u2A10~cirmid~\u2AEF~cirscir~\u29C2~clubsuit~\u2663~colon~:~colone~\u2254~coloneq~\u2254~comma~,~commat~@~comp~\u2201~compfn~\u2218~complement~\u2201~complexes~\u2102~congdot~\u2A6D~conint~\u222E~copf~\uD835\uDD54~coprod~\u2210~copysr~\u2117~cross~\u2717~cscr~\uD835\uDCB8~csub~\u2ACF~csube~\u2AD1~csup~\u2AD0~csupe~\u2AD2~ctdot~\u22EF~cudarrl~\u2938~cudarrr~\u2935~cuepr~\u22DE~cuesc~\u22DF~cularr~\u21B6~cularrp~\u293D~cupbrcap~\u2A48~cupcap~\u2A46~cupcup~\u2A4A~cupdot~\u228D~cupor~\u2A45~cups~\u222A\uFE00~curarr~\u21B7~curarrm~\u293C~curlyeqprec~\u22DE~curlyeqsucc~\u22DF~curlyvee~\u22CE~curlywedge~\u22CF~curvearrowleft~\u21B6~curvearrowright~\u21B7~cuvee~\u22CE~cuwed~\u22CF~cwconint~\u2232~cwint~\u2231~cylcty~\u232D~dHar~\u2965~daleth~\u2138~dash~\u2010~dashv~\u22A3~dbkarow~\u290F~dblac~\u02DD~dcaron~\u010F~dcy~\u0434~dd~\u2146~ddagger~\u2021~ddarr~\u21CA~ddotseq~\u2A77~demptyv~\u29B1~dfisht~\u297F~dfr~\uD835\uDD21~dharl~\u21C3~dharr~\u21C2~diam~\u22C4~diamond~\u22C4~diamondsuit~\u2666~die~\xa8~digamma~\u03DD~disin~\u22F2~div~\xf7~divideontimes~\u22C7~divonx~\u22C7~djcy~\u0452~dlcorn~\u231E~dlcrop~\u230D~dollar~$~dopf~\uD835\uDD55~dot~\u02D9~doteq~\u2250~doteqdot~\u2251~dotminus~\u2238~dotplus~\u2214~dotsquare~\u22A1~doublebarwedge~\u2306~downarrow~\u2193~downdownarrows~\u21CA~downharpoonleft~\u21C3~downharpoonright~\u21C2~drbkarow~\u2910~drcorn~\u231F~drcrop~\u230C~dscr~\uD835\uDCB9~dscy~\u0455~dsol~\u29F6~dstrok~\u0111~dtdot~\u22F1~dtri~\u25BF~dtrif~\u25BE~duarr~\u21F5~duhar~\u296F~dwangle~\u29A6~dzcy~\u045F~dzigrarr~\u27FF~eDDot~\u2A77~eDot~\u2251~easter~\u2A6E~ecaron~\u011B~ecir~\u2256~ecolon~\u2255~ecy~\u044D~edot~\u0117~ee~\u2147~efDot~\u2252~efr~\uD835\uDD22~eg~\u2A9A~egs~\u2A96~egsdot~\u2A98~el~\u2A99~elinters~\u23E7~ell~\u2113~els~\u2A95~elsdot~\u2A97~emacr~\u0113~emptyset~\u2205~emptyv~\u2205~emsp13~\u2004~emsp14~\u2005~eng~\u014B~eogon~\u0119~eopf~\uD835\uDD56~epar~\u22D5~eparsl~\u29E3~eplus~\u2A71~epsi~\u03B5~epsiv~\u03F5~eqcirc~\u2256~eqcolon~\u2255~eqsim~\u2242~eqslantgtr~\u2A96~eqslantless~\u2A95~equals~=~equest~\u225F~equivDD~\u2A78~eqvparsl~\u29E5~erDot~\u2253~erarr~\u2971~escr~\u212F~esdot~\u2250~esim~\u2242~excl~!~expectation~\u2130~exponentiale~\u2147~fallingdotseq~\u2252~fcy~\u0444~female~\u2640~ffilig~\uFB03~fflig~\uFB00~ffllig~\uFB04~ffr~\uD835\uDD23~filig~\uFB01~fjlig~fj~flat~\u266D~fllig~\uFB02~fltns~\u25B1~fopf~\uD835\uDD57~fork~\u22D4~forkv~\u2AD9~fpartint~\u2A0D~frac13~\u2153~frac15~\u2155~frac16~\u2159~frac18~\u215B~frac23~\u2154~frac25~\u2156~frac35~\u2157~frac38~\u215C~frac45~\u2158~frac56~\u215A~frac58~\u215D~frac78~\u215E~frown~\u2322~fscr~\uD835\uDCBB~gE~\u2267~gEl~\u2A8C~gacute~\u01F5~gammad~\u03DD~gap~\u2A86~gbreve~\u011F~gcirc~\u011D~gcy~\u0433~gdot~\u0121~gel~\u22DB~geq~\u2265~geqq~\u2267~geqslant~\u2A7E~ges~\u2A7E~gescc~\u2AA9~gesdot~\u2A80~gesdoto~\u2A82~gesdotol~\u2A84~gesl~\u22DB\uFE00~gesles~\u2A94~gfr~\uD835\uDD24~gg~\u226B~ggg~\u22D9~gimel~\u2137~gjcy~\u0453~gl~\u2277~glE~\u2A92~gla~\u2AA5~glj~\u2AA4~gnE~\u2269~gnap~\u2A8A~gnapprox~\u2A8A~gne~\u2A88~gneq~\u2A88~gneqq~\u2269~gnsim~\u22E7~gopf~\uD835\uDD58~grave~`~gscr~\u210A~gsim~\u2273~gsime~\u2A8E~gsiml~\u2A90~gtcc~\u2AA7~gtcir~\u2A7A~gtdot~\u22D7~gtlPar~\u2995~gtquest~\u2A7C~gtrapprox~\u2A86~gtrarr~\u2978~gtrdot~\u22D7~gtreqless~\u22DB~gtreqqless~\u2A8C~gtrless~\u2277~gtrsim~\u2273~gvertneqq~\u2269\uFE00~gvnE~\u2269\uFE00~hairsp~\u200A~half~\xbd~hamilt~\u210B~hardcy~\u044A~harrcir~\u2948~harrw~\u21AD~hbar~\u210F~hcirc~\u0125~heartsuit~\u2665~hercon~\u22B9~hfr~\uD835\uDD25~hksearow~\u2925~hkswarow~\u2926~hoarr~\u21FF~homtht~\u223B~hookleftarrow~\u21A9~hookrightarrow~\u21AA~hopf~\uD835\uDD59~horbar~\u2015~hscr~\uD835\uDCBD~hslash~\u210F~hstrok~\u0127~hybull~\u2043~hyphen~\u2010~ic~\u2063~icy~\u0438~iecy~\u0435~iff~\u21D4~ifr~\uD835\uDD26~ii~\u2148~iiiint~\u2A0C~iiint~\u222D~iinfin~\u29DC~iiota~\u2129~ijlig~\u0133~imacr~\u012B~imagline~\u2110~imagpart~\u2111~imath~\u0131~imof~\u22B7~imped~\u01B5~in~\u2208~incare~\u2105~infintie~\u29DD~inodot~\u0131~intcal~\u22BA~integers~\u2124~intercal~\u22BA~intlarhk~\u2A17~intprod~\u2A3C~iocy~\u0451~iogon~\u012F~iopf~\uD835\uDD5A~iprod~\u2A3C~iscr~\uD835\uDCBE~isinE~\u22F9~isindot~\u22F5~isins~\u22F4~isinsv~\u22F3~isinv~\u2208~it~\u2062~itilde~\u0129~iukcy~\u0456~jcirc~\u0135~jcy~\u0439~jfr~\uD835\uDD27~jmath~\u0237~jopf~\uD835\uDD5B~jscr~\uD835\uDCBF~jsercy~\u0458~jukcy~\u0454~kappav~\u03F0~kcedil~\u0137~kcy~\u043A~kfr~\uD835\uDD28~kgreen~\u0138~khcy~\u0445~kjcy~\u045C~kopf~\uD835\uDD5C~kscr~\uD835\uDCC0~lAarr~\u21DA~lAtail~\u291B~lBarr~\u290E~lE~\u2266~lEg~\u2A8B~lHar~\u2962~lacute~\u013A~laemptyv~\u29B4~lagran~\u2112~langd~\u2991~langle~\u27E8~lap~\u2A85~larrb~\u21E4~larrbfs~\u291F~larrfs~\u291D~larrhk~\u21A9~larrlp~\u21AB~larrpl~\u2939~larrsim~\u2973~larrtl~\u21A2~lat~\u2AAB~latail~\u2919~late~\u2AAD~lates~\u2AAD\uFE00~lbarr~\u290C~lbbrk~\u2772~lbrace~{~lbrack~[~lbrke~\u298B~lbrksld~\u298F~lbrkslu~\u298D~lcaron~\u013E~lcedil~\u013C~lcub~{~lcy~\u043B~ldca~\u2936~ldquor~\u201E~ldrdhar~\u2967~ldrushar~\u294B~ldsh~\u21B2~leftarrow~\u2190~leftarrowtail~\u21A2~leftharpoondown~\u21BD~leftharpoonup~\u21BC~leftleftarrows~\u21C7~leftrightarrow~\u2194~leftrightarrows~\u21C6~leftrightharpoons~\u21CB~leftrightsquigarrow~\u21AD~leftthreetimes~\u22CB~leg~\u22DA~leq~\u2264~leqq~\u2266~leqslant~\u2A7D~les~\u2A7D~lescc~\u2AA8~lesdot~\u2A7F~lesdoto~\u2A81~lesdotor~\u2A83~lesg~\u22DA\uFE00~lesges~\u2A93~lessapprox~\u2A85~lessdot~\u22D6~lesseqgtr~\u22DA~lesseqqgtr~\u2A8B~lessgtr~\u2276~lesssim~\u2272~lfisht~\u297C~lfr~\uD835\uDD29~lg~\u2276~lgE~\u2A91~lhard~\u21BD~lharu~\u21BC~lharul~\u296A~lhblk~\u2584~ljcy~\u0459~ll~\u226A~llarr~\u21C7~llcorner~\u231E~llhard~\u296B~lltri~\u25FA~lmidot~\u0140~lmoust~\u23B0~lmoustache~\u23B0~lnE~\u2268~lnap~\u2A89~lnapprox~\u2A89~lne~\u2A87~lneq~\u2A87~lneqq~\u2268~lnsim~\u22E6~loang~\u27EC~loarr~\u21FD~lobrk~\u27E6~longleftarrow~\u27F5~longleftrightarrow~\u27F7~longmapsto~\u27FC~longrightarrow~\u27F6~looparrowleft~\u21AB~looparrowright~\u21AC~lopar~\u2985~lopf~\uD835\uDD5D~loplus~\u2A2D~lotimes~\u2A34~lowbar~_~lozenge~\u25CA~lozf~\u29EB~lpar~(~lparlt~\u2993~lrarr~\u21C6~lrcorner~\u231F~lrhar~\u21CB~lrhard~\u296D~lrtri~\u22BF~lscr~\uD835\uDCC1~lsh~\u21B0~lsim~\u2272~lsime~\u2A8D~lsimg~\u2A8F~lsqb~[~lsquor~\u201A~lstrok~\u0142~ltcc~\u2AA6~ltcir~\u2A79~ltdot~\u22D6~lthree~\u22CB~ltimes~\u22C9~ltlarr~\u2976~ltquest~\u2A7B~ltrPar~\u2996~ltri~\u25C3~ltrie~\u22B4~ltrif~\u25C2~lurdshar~\u294A~luruhar~\u2966~lvertneqq~\u2268\uFE00~lvnE~\u2268\uFE00~mDDot~\u223A~male~\u2642~malt~\u2720~maltese~\u2720~map~\u21A6~mapsto~\u21A6~mapstodown~\u21A7~mapstoleft~\u21A4~mapstoup~\u21A5~marker~\u25AE~mcomma~\u2A29~mcy~\u043C~measuredangle~\u2221~mfr~\uD835\uDD2A~mho~\u2127~mid~\u2223~midast~*~midcir~\u2AF0~minusb~\u229F~minusd~\u2238~minusdu~\u2A2A~mlcp~\u2ADB~mldr~\u2026~mnplus~\u2213~models~\u22A7~mopf~\uD835\uDD5E~mp~\u2213~mscr~\uD835\uDCC2~mstpos~\u223E~multimap~\u22B8~mumap~\u22B8~nGg~\u22D9\u0338~nGt~\u226B\u20D2~nGtv~\u226B\u0338~nLeftarrow~\u21CD~nLeftrightarrow~\u21CE~nLl~\u22D8\u0338~nLt~\u226A\u20D2~nLtv~\u226A\u0338~nRightarrow~\u21CF~nVDash~\u22AF~nVdash~\u22AE~nacute~\u0144~nang~\u2220\u20D2~nap~\u2249~napE~\u2A70\u0338~napid~\u224B\u0338~napos~\u0149~napprox~\u2249~natur~\u266E~natural~\u266E~naturals~\u2115~nbump~\u224E\u0338~nbumpe~\u224F\u0338~ncap~\u2A43~ncaron~\u0148~ncedil~\u0146~ncong~\u2247~ncongdot~\u2A6D\u0338~ncup~\u2A42~ncy~\u043D~neArr~\u21D7~nearhk~\u2924~nearr~\u2197~nearrow~\u2197~nedot~\u2250\u0338~nequiv~\u2262~nesear~\u2928~nesim~\u2242\u0338~nexist~\u2204~nexists~\u2204~nfr~\uD835\uDD2B~ngE~\u2267\u0338~nge~\u2271~ngeq~\u2271~ngeqq~\u2267\u0338~ngeqslant~\u2A7E\u0338~nges~\u2A7E\u0338~ngsim~\u2275~ngt~\u226F~ngtr~\u226F~nhArr~\u21CE~nharr~\u21AE~nhpar~\u2AF2~nis~\u22FC~nisd~\u22FA~niv~\u220B~njcy~\u045A~nlArr~\u21CD~nlE~\u2266\u0338~nlarr~\u219A~nldr~\u2025~nle~\u2270~nleftarrow~\u219A~nleftrightarrow~\u21AE~nleq~\u2270~nleqq~\u2266\u0338~nleqslant~\u2A7D\u0338~nles~\u2A7D\u0338~nless~\u226E~nlsim~\u2274~nlt~\u226E~nltri~\u22EA~nltrie~\u22EC~nmid~\u2224~nopf~\uD835\uDD5F~notinE~\u22F9\u0338~notindot~\u22F5\u0338~notinva~\u2209~notinvb~\u22F7~notinvc~\u22F6~notni~\u220C~notniva~\u220C~notnivb~\u22FE~notnivc~\u22FD~npar~\u2226~nparallel~\u2226~nparsl~\u2AFD\u20E5~npart~\u2202\u0338~npolint~\u2A14~npr~\u2280~nprcue~\u22E0~npre~\u2AAF\u0338~nprec~\u2280~npreceq~\u2AAF\u0338~nrArr~\u21CF~nrarr~\u219B~nrarrc~\u2933\u0338~nrarrw~\u219D\u0338~nrightarrow~\u219B~nrtri~\u22EB~nrtrie~\u22ED~nsc~\u2281~nsccue~\u22E1~nsce~\u2AB0\u0338~nscr~\uD835\uDCC3~nshortmid~\u2224~nshortparallel~\u2226~nsim~\u2241~nsime~\u2244~nsimeq~\u2244~nsmid~\u2224~nspar~\u2226~nsqsube~\u22E2~nsqsupe~\u22E3~nsubE~\u2AC5\u0338~nsube~\u2288~nsubset~\u2282\u20D2~nsubseteq~\u2288~nsubseteqq~\u2AC5\u0338~nsucc~\u2281~nsucceq~\u2AB0\u0338~nsup~\u2285~nsupE~\u2AC6\u0338~nsupe~\u2289~nsupset~\u2283\u20D2~nsupseteq~\u2289~nsupseteqq~\u2AC6\u0338~ntgl~\u2279~ntlg~\u2278~ntriangleleft~\u22EA~ntrianglelefteq~\u22EC~ntriangleright~\u22EB~ntrianglerighteq~\u22ED~num~#~numero~\u2116~numsp~\u2007~nvDash~\u22AD~nvHarr~\u2904~nvap~\u224D\u20D2~nvdash~\u22AC~nvge~\u2265\u20D2~nvgt~>\u20D2~nvinfin~\u29DE~nvlArr~\u2902~nvle~\u2264\u20D2~nvlt~<\u20D2~nvltrie~\u22B4\u20D2~nvrArr~\u2903~nvrtrie~\u22B5\u20D2~nvsim~\u223C\u20D2~nwArr~\u21D6~nwarhk~\u2923~nwarr~\u2196~nwarrow~\u2196~nwnear~\u2927~oS~\u24C8~oast~\u229B~ocir~\u229A~ocy~\u043E~odash~\u229D~odblac~\u0151~odiv~\u2A38~odot~\u2299~odsold~\u29BC~ofcir~\u29BF~ofr~\uD835\uDD2C~ogon~\u02DB~ogt~\u29C1~ohbar~\u29B5~ohm~\u03A9~oint~\u222E~olarr~\u21BA~olcir~\u29BE~olcross~\u29BB~olt~\u29C0~omacr~\u014D~omid~\u29B6~ominus~\u2296~oopf~\uD835\uDD60~opar~\u29B7~operp~\u29B9~orarr~\u21BB~ord~\u2A5D~order~\u2134~orderof~\u2134~origof~\u22B6~oror~\u2A56~orslope~\u2A57~orv~\u2A5B~oscr~\u2134~osol~\u2298~otimesas~\u2A36~ovbar~\u233D~par~\u2225~parallel~\u2225~parsim~\u2AF3~parsl~\u2AFD~pcy~\u043F~percnt~%~period~.~pertenk~\u2031~pfr~\uD835\uDD2D~phiv~\u03D5~phmmat~\u2133~phone~\u260E~pitchfork~\u22D4~planck~\u210F~planckh~\u210E~plankv~\u210F~plus~+~plusacir~\u2A23~plusb~\u229E~pluscir~\u2A22~plusdo~\u2214~plusdu~\u2A25~pluse~\u2A72~plussim~\u2A26~plustwo~\u2A27~pm~\xb1~pointint~\u2A15~popf~\uD835\uDD61~pr~\u227A~prE~\u2AB3~prap~\u2AB7~prcue~\u227C~pre~\u2AAF~prec~\u227A~precapprox~\u2AB7~preccurlyeq~\u227C~preceq~\u2AAF~precnapprox~\u2AB9~precneqq~\u2AB5~precnsim~\u22E8~precsim~\u227E~primes~\u2119~prnE~\u2AB5~prnap~\u2AB9~prnsim~\u22E8~profalar~\u232E~profline~\u2312~profsurf~\u2313~propto~\u221D~prsim~\u227E~prurel~\u22B0~pscr~\uD835\uDCC5~puncsp~\u2008~qfr~\uD835\uDD2E~qint~\u2A0C~qopf~\uD835\uDD62~qprime~\u2057~qscr~\uD835\uDCC6~quaternions~\u210D~quatint~\u2A16~quest~?~questeq~\u225F~rAarr~\u21DB~rAtail~\u291C~rBarr~\u290F~rHar~\u2964~race~\u223D\u0331~racute~\u0155~raemptyv~\u29B3~rangd~\u2992~range~\u29A5~rangle~\u27E9~rarrap~\u2975~rarrb~\u21E5~rarrbfs~\u2920~rarrc~\u2933~rarrfs~\u291E~rarrhk~\u21AA~rarrlp~\u21AC~rarrpl~\u2945~rarrsim~\u2974~rarrtl~\u21A3~rarrw~\u219D~ratail~\u291A~ratio~\u2236~rationals~\u211A~rbarr~\u290D~rbbrk~\u2773~rbrace~}~rbrack~]~rbrke~\u298C~rbrksld~\u298E~rbrkslu~\u2990~rcaron~\u0159~rcedil~\u0157~rcub~}~rcy~\u0440~rdca~\u2937~rdldhar~\u2969~rdquor~\u201D~rdsh~\u21B3~realine~\u211B~realpart~\u211C~reals~\u211D~rect~\u25AD~rfisht~\u297D~rfr~\uD835\uDD2F~rhard~\u21C1~rharu~\u21C0~rharul~\u296C~rhov~\u03F1~rightarrow~\u2192~rightarrowtail~\u21A3~rightharpoondown~\u21C1~rightharpoonup~\u21C0~rightleftarrows~\u21C4~rightleftharpoons~\u21CC~rightrightarrows~\u21C9~rightsquigarrow~\u219D~rightthreetimes~\u22CC~ring~\u02DA~risingdotseq~\u2253~rlarr~\u21C4~rlhar~\u21CC~rmoust~\u23B1~rmoustache~\u23B1~rnmid~\u2AEE~roang~\u27ED~roarr~\u21FE~robrk~\u27E7~ropar~\u2986~ropf~\uD835\uDD63~roplus~\u2A2E~rotimes~\u2A35~rpar~)~rpargt~\u2994~rppolint~\u2A12~rrarr~\u21C9~rscr~\uD835\uDCC7~rsh~\u21B1~rsqb~]~rsquor~\u2019~rthree~\u22CC~rtimes~\u22CA~rtri~\u25B9~rtrie~\u22B5~rtrif~\u25B8~rtriltri~\u29CE~ruluhar~\u2968~rx~\u211E~sacute~\u015B~sc~\u227B~scE~\u2AB4~scap~\u2AB8~sccue~\u227D~sce~\u2AB0~scedil~\u015F~scirc~\u015D~scnE~\u2AB6~scnap~\u2ABA~scnsim~\u22E9~scpolint~\u2A13~scsim~\u227F~scy~\u0441~sdotb~\u22A1~sdote~\u2A66~seArr~\u21D8~searhk~\u2925~searr~\u2198~searrow~\u2198~semi~;~seswar~\u2929~setminus~\u2216~setmn~\u2216~sext~\u2736~sfr~\uD835\uDD30~sfrown~\u2322~sharp~\u266F~shchcy~\u0449~shcy~\u0448~shortmid~\u2223~shortparallel~\u2225~sigmav~\u03C2~simdot~\u2A6A~sime~\u2243~simeq~\u2243~simg~\u2A9E~simgE~\u2AA0~siml~\u2A9D~simlE~\u2A9F~simne~\u2246~simplus~\u2A24~simrarr~\u2972~slarr~\u2190~smallsetminus~\u2216~smashp~\u2A33~smeparsl~\u29E4~smid~\u2223~smile~\u2323~smt~\u2AAA~smte~\u2AAC~smtes~\u2AAC\uFE00~softcy~\u044C~sol~/~solb~\u29C4~solbar~\u233F~sopf~\uD835\uDD64~spadesuit~\u2660~spar~\u2225~sqcap~\u2293~sqcaps~\u2293\uFE00~sqcup~\u2294~sqcups~\u2294\uFE00~sqsub~\u228F~sqsube~\u2291~sqsubset~\u228F~sqsubseteq~\u2291~sqsup~\u2290~sqsupe~\u2292~sqsupset~\u2290~sqsupseteq~\u2292~squ~\u25A1~square~\u25A1~squarf~\u25AA~squf~\u25AA~srarr~\u2192~sscr~\uD835\uDCC8~ssetmn~\u2216~ssmile~\u2323~sstarf~\u22C6~star~\u2606~starf~\u2605~straightepsilon~\u03F5~straightphi~\u03D5~strns~\xaf~subE~\u2AC5~subdot~\u2ABD~subedot~\u2AC3~submult~\u2AC1~subnE~\u2ACB~subne~\u228A~subplus~\u2ABF~subrarr~\u2979~subset~\u2282~subseteq~\u2286~subseteqq~\u2AC5~subsetneq~\u228A~subsetneqq~\u2ACB~subsim~\u2AC7~subsub~\u2AD5~subsup~\u2AD3~succ~\u227B~succapprox~\u2AB8~succcurlyeq~\u227D~succeq~\u2AB0~succnapprox~\u2ABA~succneqq~\u2AB6~succnsim~\u22E9~succsim~\u227F~sung~\u266A~supE~\u2AC6~supdot~\u2ABE~supdsub~\u2AD8~supedot~\u2AC4~suphsol~\u27C9~suphsub~\u2AD7~suplarr~\u297B~supmult~\u2AC2~supnE~\u2ACC~supne~\u228B~supplus~\u2AC0~supset~\u2283~supseteq~\u2287~supseteqq~\u2AC6~supsetneq~\u228B~supsetneqq~\u2ACC~supsim~\u2AC8~supsub~\u2AD4~supsup~\u2AD6~swArr~\u21D9~swarhk~\u2926~swarr~\u2199~swarrow~\u2199~swnwar~\u292A~target~\u2316~tbrk~\u23B4~tcaron~\u0165~tcedil~\u0163~tcy~\u0442~tdot~\u20DB~telrec~\u2315~tfr~\uD835\uDD31~therefore~\u2234~thetav~\u03D1~thickapprox~\u2248~thicksim~\u223C~thkap~\u2248~thksim~\u223C~timesb~\u22A0~timesbar~\u2A31~timesd~\u2A30~tint~\u222D~toea~\u2928~top~\u22A4~topbot~\u2336~topcir~\u2AF1~topf~\uD835\uDD65~topfork~\u2ADA~tosa~\u2929~tprime~\u2034~triangle~\u25B5~triangledown~\u25BF~triangleleft~\u25C3~trianglelefteq~\u22B4~triangleq~\u225C~triangleright~\u25B9~trianglerighteq~\u22B5~tridot~\u25EC~trie~\u225C~triminus~\u2A3A~triplus~\u2A39~trisb~\u29CD~tritime~\u2A3B~trpezium~\u23E2~tscr~\uD835\uDCC9~tscy~\u0446~tshcy~\u045B~tstrok~\u0167~twixt~\u226C~twoheadleftarrow~\u219E~twoheadrightarrow~\u21A0~uHar~\u2963~ubrcy~\u045E~ubreve~\u016D~ucy~\u0443~udarr~\u21C5~udblac~\u0171~udhar~\u296E~ufisht~\u297E~ufr~\uD835\uDD32~uharl~\u21BF~uharr~\u21BE~uhblk~\u2580~ulcorn~\u231C~ulcorner~\u231C~ulcrop~\u230F~ultri~\u25F8~umacr~\u016B~uogon~\u0173~uopf~\uD835\uDD66~uparrow~\u2191~updownarrow~\u2195~upharpoonleft~\u21BF~upharpoonright~\u21BE~uplus~\u228E~upsi~\u03C5~upuparrows~\u21C8~urcorn~\u231D~urcorner~\u231D~urcrop~\u230E~uring~\u016F~urtri~\u25F9~uscr~\uD835\uDCCA~utdot~\u22F0~utilde~\u0169~utri~\u25B5~utrif~\u25B4~uuarr~\u21C8~uwangle~\u29A7~vArr~\u21D5~vBar~\u2AE8~vBarv~\u2AE9~vDash~\u22A8~vangrt~\u299C~varepsilon~\u03F5~varkappa~\u03F0~varnothing~\u2205~varphi~\u03D5~varpi~\u03D6~varpropto~\u221D~varr~\u2195~varrho~\u03F1~varsigma~\u03C2~varsubsetneq~\u228A\uFE00~varsubsetneqq~\u2ACB\uFE00~varsupsetneq~\u228B\uFE00~varsupsetneqq~\u2ACC\uFE00~vartheta~\u03D1~vartriangleleft~\u22B2~vartriangleright~\u22B3~vcy~\u0432~vdash~\u22A2~vee~\u2228~veebar~\u22BB~veeeq~\u225A~vellip~\u22EE~verbar~|~vert~|~vfr~\uD835\uDD33~vltri~\u22B2~vnsub~\u2282\u20D2~vnsup~\u2283\u20D2~vopf~\uD835\uDD67~vprop~\u221D~vrtri~\u22B3~vscr~\uD835\uDCCB~vsubnE~\u2ACB\uFE00~vsubne~\u228A\uFE00~vsupnE~\u2ACC\uFE00~vsupne~\u228B\uFE00~vzigzag~\u299A~wcirc~\u0175~wedbar~\u2A5F~wedge~\u2227~wedgeq~\u2259~wfr~\uD835\uDD34~wopf~\uD835\uDD68~wp~\u2118~wr~\u2240~wreath~\u2240~wscr~\uD835\uDCCC~xcap~\u22C2~xcirc~\u25EF~xcup~\u22C3~xdtri~\u25BD~xfr~\uD835\uDD35~xhArr~\u27FA~xharr~\u27F7~xlArr~\u27F8~xlarr~\u27F5~xmap~\u27FC~xnis~\u22FB~xodot~\u2A00~xopf~\uD835\uDD69~xoplus~\u2A01~xotime~\u2A02~xrArr~\u27F9~xrarr~\u27F6~xscr~\uD835\uDCCD~xsqcup~\u2A06~xuplus~\u2A04~xutri~\u25B3~xvee~\u22C1~xwedge~\u22C0~yacy~\u044F~ycirc~\u0177~ycy~\u044B~yfr~\uD835\uDD36~yicy~\u0457~yopf~\uD835\uDD6A~yscr~\uD835\uDCCE~yucy~\u044E~zacute~\u017A~zcaron~\u017E~zcy~\u0437~zdot~\u017C~zeetrf~\u2128~zfr~\uD835\uDD37~zhcy~\u0436~zigrarr~\u21DD~zopf~\uD835\uDD6B~zscr~\uD835\uDCCF~~AMP~&~COPY~\xa9~GT~>~LT~<~QUOT~"~REG~\xae', $3627f61c8f79bb4a$export$e7660db2439a79f4['html4']);

});

parcelRegister("b2S6k", function(module, exports) {

$parcel$export(module.exports, "numericUnicodeMap", function () { return $80a9d8f5173ccbc4$export$428d7142be898042; });
var $80a9d8f5173ccbc4$export$428d7142be898042 = {
    0: 65533,
    128: 8364,
    130: 8218,
    131: 402,
    132: 8222,
    133: 8230,
    134: 8224,
    135: 8225,
    136: 710,
    137: 8240,
    138: 352,
    139: 8249,
    140: 338,
    142: 381,
    145: 8216,
    146: 8217,
    147: 8220,
    148: 8221,
    149: 8226,
    150: 8211,
    151: 8212,
    152: 732,
    153: 8482,
    154: 353,
    155: 8250,
    156: 339,
    158: 382,
    159: 376
};

});

parcelRegister("3LYBZ", function(module, exports) {

$parcel$export(module.exports, "fromCodePoint", function () { return $2bf4c7215a041d2d$export$73bfc63873071f74; });
$parcel$export(module.exports, "getCodePoint", function () { return $2bf4c7215a041d2d$export$e02688b8085d016b; });
var $2bf4c7215a041d2d$export$73bfc63873071f74 = String.fromCodePoint || function(astralCodePoint) {
    return String.fromCharCode(Math.floor((astralCodePoint - 0x10000) / 0x400) + 0xd800, (astralCodePoint - 0x10000) % 0x400 + 0xdc00);
};
var $2bf4c7215a041d2d$export$e02688b8085d016b = String.prototype.codePointAt ? function(input, position) {
    return input.codePointAt(position);
} : function(input, position) {
    return (input.charCodeAt(position) - 0xd800) * 0x400 + input.charCodeAt(position + 1) - 0xdc00 + 0x10000;
};
var $2bf4c7215a041d2d$export$4c11c7b7e9e865a1 = 0xd800;
var $2bf4c7215a041d2d$export$d934c7af91732bc0 = 0xdbff;

});


parcelRegister("c3rYm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a34eb52e171b03e$var$searchRESTApi;
async function $2a34eb52e171b03e$var$searchRESTApi({ searchString: searchString, signal: signal }) {
    // Fetch menu data from REST API
    if (!searchString?.length || searchString.length === 0) return null;
    if (!signal) {
        const controller = new AbortController();
        signal = controller.signal;
    }
    try {
        const response = await fetch(`/wp-json/wp/v2/search?search=${searchString}&type=post&subtype=post,page,adweek_event`, {
            signal: signal
        });
        const data = await response.json();
        const totalPagesHeader = response.headers.get('X-WP-TotalPages');
        const totalPages = Number(totalPagesHeader || 0);
        console.log('searchRESTApi', data);
        return {
            results: data,
            totalPages: Number.isFinite(totalPages) ? totalPages : 0
        };
    } catch (error) {
        // If the error is an abort error, we can ignore it as it's expected when the request is cancelled
        if (error?.name === 'AbortError') {
            console.log('Search request was aborted');
            return null;
        }
        console.error('Error fetching search data', error);
        return null;
    }
}

});

parcelRegister("iD6GO", function(module, exports) {

$parcel$export(module.exports, "throttle", function () { return $d9010ee870d463b5$export$de363e709c412c8a; });
$parcel$export(module.exports, "debounce", function () { return $d9010ee870d463b5$export$61fc7d43ac8f84b0; });
/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */ function $d9010ee870d463b5$export$de363e709c412c8a(delay, callback, options) {
    var _ref = options || {}, _ref$noTrailing = _ref.noTrailing, noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing, _ref$noLeading = _ref.noLeading, noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading, _ref$debounceMode = _ref.debounceMode, debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false;
    // Keep track of the last time `callback` was executed.
    var lastExec = 0;
    // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    }
    // Function to cancel next exec
    function cancel(options) {
        var _ref2 = options || {}, _ref2$upcomingOnly = _ref2.upcomingOnly, upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
        clearExistingTimeout();
        cancelled = !upcomingOnly;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
        // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (!noLeading && debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) {
            if (noLeading) {
                /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */ lastExec = Date.now();
                if (!noTrailing) timeoutID = setTimeout(debounceMode ? clear : exec, delay);
            } else /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */ exec();
        } else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel;
    // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */ function $d9010ee870d463b5$export$61fc7d43ac8f84b0(delay, callback, options) {
    var _ref = options || {}, _ref$atBegin = _ref.atBegin, atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
    return $d9010ee870d463b5$export$de363e709c412c8a(delay, callback, {
        debounceMode: atBegin !== false
    });
}

});

parcelRegister("3k97u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $df384d8b8858a68a$var$NewTabIcon;
function $df384d8b8858a68a$var$NewTabIcon({ className: className = '' }) {
    return /*#__PURE__*/ React.createElement("svg", {
        className: className,
        height: "1.25em",
        width: "1.25em",
        fill: "currentColor",
        viewBox: "0 -960 960 960"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M160-160v-640h289.23v40H200v560h560v-249.23h40V-160H160Zm229.54-201.23-28.31-28.31L731.69-760H560v-40h240v240h-40v-171.69L389.54-361.23Z"
    }));
}

});


parcelRegister("6OqqF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a05b109efce65974$var$LogoAdw;
const $a05b109efce65974$var$React = window.React || null;
const { useEffect: $a05b109efce65974$var$useEffect } = $a05b109efce65974$var$React;
function $a05b109efce65974$var$LogoAdw() {
    const ref = $a05b109efce65974$var$React.createRef();
    // Always use SVG logo for mobile menu (never use GIF)
    const elLogoIconMarkup = $a05b109efce65974$var$React.useMemo(()=>{
        // Always use the SVG logo for mobile menu
        const svgElement = document.getElementById('aw-logo-svg');
        if (svgElement) {
            // Clone SVG and ensure it's visible in modal
            const cloned = svgElement.cloneNode(true);
            cloned.classList.remove('d-none', 'd-lg-none');
            cloned.style.display = 'block';
            cloned.style.visibility = 'visible';
            cloned.removeAttribute('id'); // Remove ID to prevent conflicts
            return cloned.outerHTML;
        }
        return '';
    }, []);
    // Copy the Icon markup from page DOM and insert it into this React component
    $a05b109efce65974$var$useEffect(()=>{
        if (ref?.current && typeof window?.anime === 'function') {
            const paths = ref.current?.querySelectorAll('path');
            // Only animate if it's an SVG (has paths), not an image
            if (paths && paths.length > 0) {
                ref.current.style.visibility = 'visible';
                anime.timeline().add({
                    targets: paths,
                    opacity: [
                        1,
                        0
                    ],
                    // translateX: [0, -5],
                    duration: 400,
                    easing: 'easeInOutQuad',
                    delay: anime.stagger(35)
                }).add({
                    targets: paths,
                    opacity: [
                        0,
                        1
                    ],
                    // translateX: [-5, 0],
                    duration: 500,
                    easing: 'easeInOutQuad',
                    delay: anime.stagger(35)
                }, '-=150');
            } else // For images (GIF), just make visible
            ref.current.style.visibility = 'visible';
        }
    }, [
        ref
    ]);
    return /*#__PURE__*/ $a05b109efce65974$var$React.createElement("div", null, /*#__PURE__*/ $a05b109efce65974$var$React.createElement("div", {
        id: "modal-adw-logo",
        ref: ref,
        dangerouslySetInnerHTML: {
            __html: elLogoIconMarkup
        },
        style: {
            visibility: 'hidden',
            position: 'relative',
            zIndex: 100005
        }
    }));
}

});

parcelRegister("fTar7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $92a8ca3adb1c6794$var$React = window.React || null;
const $92a8ca3adb1c6794$var$MainMenu = $92a8ca3adb1c6794$var$React.memo(function MainMenu() {
    if (window?.adw && window.adw.nav_main?.items?.length === 0) return null;
    return /*#__PURE__*/ $92a8ca3adb1c6794$var$React.createElement("ul", {
        className: "main-menu d-flex flex-column flex-grow-1 justify-content-center align-items-start gap-3 px-0 mb-0"
    }, window.adw.nav_main.items.map((item, index)=>{
        return /*#__PURE__*/ $92a8ca3adb1c6794$var$React.createElement("li", {
            className: "list-unstyled lh-1 ",
            key: `main-menu-item-${index}`
        }, /*#__PURE__*/ $92a8ca3adb1c6794$var$React.createElement($92a8ca3adb1c6794$var$LinkItem, {
            item: item,
            index: index
        }));
    }));
});
const $92a8ca3adb1c6794$var$LinkItem = ({ item: item, index: index })=>{
    const ref = $92a8ca3adb1c6794$var$React.useRef(null);
    return /*#__PURE__*/ $92a8ca3adb1c6794$var$React.createElement("a", {
        key: index,
        ref: ref,
        className: "font-pre-heading text-hover-primary h2 lh-1 mb-0 text-decoration-none text-uppercase d-inline-block",
        href: item.url
    }, item.title);
};
var $92a8ca3adb1c6794$var$_default = module.exports.default = $92a8ca3adb1c6794$var$MainMenu;

});

parcelRegister("3LfrR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $exYeM = parcelRequire("exYeM");
function $8a8491a2d7f1c541$var$_extends() {
    return $8a8491a2d7f1c541$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8a8491a2d7f1c541$var$_extends.apply(null, arguments);
}
const $8a8491a2d7f1c541$var$React = window.React;
function $8a8491a2d7f1c541$var$ThemeSwitcher() {
    const refWrapper = (0, $exYeM.useRef)(null);
    const refList = (0, $exYeM.useRef)(null);
    const refButton = (0, $exYeM.useRef)(null);
    const themeFromLocalStorage = localStorage.getItem('aw-theme');
    const [theme, setTheme] = (0, $exYeM.useState)(themeFromLocalStorage || 'auto');
    const [showThemeList, setShowThemeList] = (0, $exYeM.useState)(false);
    const themes = [
        {
            name: 'Light',
            value: 'light',
            Icon: $8a8491a2d7f1c541$var$LightIcon
        },
        {
            name: 'Dark',
            value: 'dark',
            Icon: $8a8491a2d7f1c541$var$DarkIcon
        },
        {
            name: 'Default',
            value: 'auto',
            Icon: $8a8491a2d7f1c541$var$AutoIcon
        }
    ];
    (0, $exYeM.useEffect)(()=>{
        localStorage.setItem('aw-theme', theme);
        if ('function' === typeof window?.adw?.setTheme) window.adw.setTheme(theme);
    }, [
        theme
    ]);
    // Register click away event to close the theme list
    (0, $exYeM.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            // If click is inside refWrapper, do nothing
            if (refWrapper.current && refWrapper.current.contains(event.target)) return;
            if (showThemeList == true) setShowThemeList(false);
        };
        document.addEventListener('click', handleClickOutside);
        return ()=>{
            document.removeEventListener('click', handleClickOutside);
        };
    }, [
        showThemeList
    ]);
    const hoverAnimation = (el, action)=>{
        if (el && 'function' === typeof anime) {
            if (action === 'mouseEnter') anime({
                targets: el,
                scale: 1.2,
                duration: 200,
                easing: 'easeOutQuad'
            });
            else if (action === 'mouseLeave') anime({
                targets: el,
                scale: 1,
                duration: 200,
                easing: 'easeOutQuad'
            });
        }
    };
    return /*#__PURE__*/ $8a8491a2d7f1c541$var$React.createElement("div", {
        ref: refWrapper,
        className: "d-inline-flex flex-column justify-content-start  position-relative "
    }, /*#__PURE__*/ $8a8491a2d7f1c541$var$React.createElement("button", {
        onClick: ()=>setShowThemeList(!showThemeList),
        className: "btn btn-link text-decoration-none",
        style: {
            transformOrigin: 'center'
        },
        ref: refButton,
        onMouseEnter: ()=>hoverAnimation(refButton?.current, 'mouseEnter'),
        onMouseLeave: ()=>hoverAnimation(refButton?.current, 'mouseLeave')
    }, /*#__PURE__*/ $8a8491a2d7f1c541$var$React.createElement("span", {
        className: `mb-0`
    }, themes.find((item)=>item.value === theme)?.Icon())), /*#__PURE__*/ $8a8491a2d7f1c541$var$React.createElement("div", {
        className: "position-absolute top-0 end-0 mt-5 z-3 "
    }, showThemeList && /*#__PURE__*/ $8a8491a2d7f1c541$var$React.createElement("ul", $8a8491a2d7f1c541$var$_extends({
        ref: refList
    }, theme !== 'auto' ? {
        'data-bs-theme': theme
    } : {}, {
        className: "list-unstyled d-flex flex-column border rounded-4 top-0 mb-0 shadow-sm overflow-hidden",
        style: {
            color: 'var(--bs-body-color)',
            background: 'var(--bs-body-bg)'
        }
    }), themes.map((item, i)=>{
        return /*#__PURE__*/ $8a8491a2d7f1c541$var$React.createElement("li", {
            key: item.value,
            className: `${item.value === theme ? '  ' : ' bg-light-subtle '}  ${i === themes.length - 1 ? '' : 'border-bottom'}`
        }, /*#__PURE__*/ $8a8491a2d7f1c541$var$React.createElement("button", {
            className: `btn btn-link d-flex align-items-center gap-3 px-4 text-decoration-none ${item.value === theme ? 'active text-primary ' : ''}`,
            onClick: ()=>setTheme(item.value)
        }, /*#__PURE__*/ $8a8491a2d7f1c541$var$React.createElement("span", {
            className: `d-inline-flex align-items-center h5 mb-0`
        }, /*#__PURE__*/ $8a8491a2d7f1c541$var$React.createElement(item.Icon, null)), item.name));
    }))));
}
var $8a8491a2d7f1c541$var$_default = module.exports.default = $8a8491a2d7f1c541$var$ThemeSwitcher;
const $8a8491a2d7f1c541$var$AutoIcon = ()=>{
    return /*#__PURE__*/ $8a8491a2d7f1c541$var$React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.25em",
        height: "1.25em",
        fill: "currentColor",
        className: "bi bi-circle-half",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ $8a8491a2d7f1c541$var$React.createElement("path", {
        d: "M8 15A7 7 0 1 0 8 1zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16"
    }));
};
const $8a8491a2d7f1c541$var$LightIcon = ()=>{
    return /*#__PURE__*/ $8a8491a2d7f1c541$var$React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.25em",
        height: "1.25em",
        fill: "currentColor",
        className: "bi bi-sun",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ $8a8491a2d7f1c541$var$React.createElement("path", {
        d: "M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8M8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0m0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13m8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5M3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8m10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0m-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0m9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707M4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708"
    }));
};
const $8a8491a2d7f1c541$var$DarkIcon = ()=>{
    return /*#__PURE__*/ $8a8491a2d7f1c541$var$React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.25em",
        height: "1.25em",
        fill: "currentColor",
        className: "bi bi-moon-stars",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ $8a8491a2d7f1c541$var$React.createElement("path", {
        d: "M6 .278a.77.77 0 0 1 .08.858 7.2 7.2 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277q.792-.001 1.533-.16a.79.79 0 0 1 .81.316.73.73 0 0 1-.031.893A8.35 8.35 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.75.75 0 0 1 6 .278M4.858 1.311A7.27 7.27 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.32 7.32 0 0 0 5.205-2.162q-.506.063-1.029.063c-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286"
    }), /*#__PURE__*/ $8a8491a2d7f1c541$var$React.createElement("path", {
        d: "M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.73 1.73 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.73 1.73 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.73 1.73 0 0 0 1.097-1.097zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.16 1.16 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.16 1.16 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732z"
    }));
};

});
parcelRegister("exYeM", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gfHYB"));

});
parcelRegister("gfHYB", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $bd5028e33dce7343$export$9c16c1426311996d; }, function (v) { return $bd5028e33dce7343$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $bd5028e33dce7343$export$dca3b0875bd9a954; }, function (v) { return $bd5028e33dce7343$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $bd5028e33dce7343$export$16fa2f45be04daa8; }, function (v) { return $bd5028e33dce7343$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $bd5028e33dce7343$export$ffb0004e005737fa; }, function (v) { return $bd5028e33dce7343$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $bd5028e33dce7343$export$e2c29f18771995cb; }, function (v) { return $bd5028e33dce7343$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $bd5028e33dce7343$export$221d75b3f55bb0bd; }, function (v) { return $bd5028e33dce7343$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bd5028e33dce7343$export$5f8d39834fd61797; }, function (v) { return $bd5028e33dce7343$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $bd5028e33dce7343$export$74bf444e3cd11ea5; }, function (v) { return $bd5028e33dce7343$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $bd5028e33dce7343$export$1ced07cd6b1985ce; }, function (v) { return $bd5028e33dce7343$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $bd5028e33dce7343$export$abd8e32b826d7ea7; }, function (v) { return $bd5028e33dce7343$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $bd5028e33dce7343$export$69a3209f1a06c04d; }, function (v) { return $bd5028e33dce7343$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $bd5028e33dce7343$export$8c538325882c7eec; }, function (v) { return $bd5028e33dce7343$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $bd5028e33dce7343$export$e530037191fcd5d7; }, function (v) { return $bd5028e33dce7343$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $bd5028e33dce7343$export$fd42f52fd3ae1109; }, function (v) { return $bd5028e33dce7343$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $bd5028e33dce7343$export$c8a8987d4410bf2d; }, function (v) { return $bd5028e33dce7343$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $bd5028e33dce7343$export$7d1e3a5e95ceca43; }, function (v) { return $bd5028e33dce7343$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $bd5028e33dce7343$export$257a8862b851cb5b; }, function (v) { return $bd5028e33dce7343$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $bd5028e33dce7343$export$a8257692ac88316c; }, function (v) { return $bd5028e33dce7343$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $bd5028e33dce7343$export$488013bae63b21da; }, function (v) { return $bd5028e33dce7343$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $bd5028e33dce7343$export$7c73462e0d25e514; }, function (v) { return $bd5028e33dce7343$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $bd5028e33dce7343$export$7568632d0d33d16d; }, function (v) { return $bd5028e33dce7343$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $bd5028e33dce7343$export$f93f40ac0ca7e3a8; }, function (v) { return $bd5028e33dce7343$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $bd5028e33dce7343$export$1f96ae73734a86cc; }, function (v) { return $bd5028e33dce7343$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $bd5028e33dce7343$export$9a47ced3238df325; }, function (v) { return $bd5028e33dce7343$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $bd5028e33dce7343$export$35808ee640e87ca7; }, function (v) { return $bd5028e33dce7343$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $bd5028e33dce7343$export$fae74005e78b1a27; }, function (v) { return $bd5028e33dce7343$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $bd5028e33dce7343$export$dc8fbce3eb94dc1e; }, function (v) { return $bd5028e33dce7343$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $bd5028e33dce7343$export$6a7bc4e911dc01cf; }, function (v) { return $bd5028e33dce7343$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $bd5028e33dce7343$export$6d9c69b0de29b591; }, function (v) { return $bd5028e33dce7343$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $bd5028e33dce7343$export$7f54fc3180508a52; }, function (v) { return $bd5028e33dce7343$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $bd5028e33dce7343$export$f680877a34711e37; }, function (v) { return $bd5028e33dce7343$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $bd5028e33dce7343$export$d5a552a76deda3c2; }, function (v) { return $bd5028e33dce7343$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $bd5028e33dce7343$export$aaabe4eda9ed9969; }, function (v) { return $bd5028e33dce7343$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $bd5028e33dce7343$export$e5c5a5f917a5871c; }, function (v) { return $bd5028e33dce7343$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $bd5028e33dce7343$export$1538c33de8887b59; }, function (v) { return $bd5028e33dce7343$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $bd5028e33dce7343$export$fca7f784ae7a249a; }, function (v) { return $bd5028e33dce7343$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $bd5028e33dce7343$export$13e3392192263954; }, function (v) { return $bd5028e33dce7343$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $bd5028e33dce7343$export$b8f5890fc79d6aca; }, function (v) { return $bd5028e33dce7343$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $bd5028e33dce7343$export$60241385465d0a34; }, function (v) { return $bd5028e33dce7343$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $bd5028e33dce7343$export$306c0aa65ff9ec16; }, function (v) { return $bd5028e33dce7343$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $bd5028e33dce7343$export$7b286972b8d8ccbf; }, function (v) { return $bd5028e33dce7343$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $bd5028e33dce7343$export$83d89fbfd8236492; }, function (v) { return $bd5028e33dce7343$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bd5028e33dce7343$export$9c16c1426311996d;
var $bd5028e33dce7343$export$dca3b0875bd9a954;
var $bd5028e33dce7343$export$16fa2f45be04daa8;
var $bd5028e33dce7343$export$ffb0004e005737fa;
var $bd5028e33dce7343$export$e2c29f18771995cb;
var $bd5028e33dce7343$export$221d75b3f55bb0bd;
var $bd5028e33dce7343$export$5f8d39834fd61797;
var $bd5028e33dce7343$export$74bf444e3cd11ea5;
var $bd5028e33dce7343$export$1ced07cd6b1985ce;
var $bd5028e33dce7343$export$abd8e32b826d7ea7;
var $bd5028e33dce7343$export$69a3209f1a06c04d;
var $bd5028e33dce7343$export$8c538325882c7eec;
var $bd5028e33dce7343$export$e530037191fcd5d7;
var $bd5028e33dce7343$export$fd42f52fd3ae1109;
var $bd5028e33dce7343$export$c8a8987d4410bf2d;
var $bd5028e33dce7343$export$7d1e3a5e95ceca43;
var $bd5028e33dce7343$export$257a8862b851cb5b;
var $bd5028e33dce7343$export$a8257692ac88316c;
var $bd5028e33dce7343$export$488013bae63b21da;
var $bd5028e33dce7343$export$7c73462e0d25e514;
var $bd5028e33dce7343$export$7568632d0d33d16d;
var $bd5028e33dce7343$export$f93f40ac0ca7e3a8;
var $bd5028e33dce7343$export$1f96ae73734a86cc;
var $bd5028e33dce7343$export$9a47ced3238df325;
var $bd5028e33dce7343$export$35808ee640e87ca7;
var $bd5028e33dce7343$export$fae74005e78b1a27;
var $bd5028e33dce7343$export$dc8fbce3eb94dc1e;
var $bd5028e33dce7343$export$6a7bc4e911dc01cf;
var $bd5028e33dce7343$export$6d9c69b0de29b591;
var $bd5028e33dce7343$export$7f54fc3180508a52;
var $bd5028e33dce7343$export$f680877a34711e37;
var $bd5028e33dce7343$export$d5a552a76deda3c2;
var $bd5028e33dce7343$export$aaabe4eda9ed9969;
var $bd5028e33dce7343$export$e5c5a5f917a5871c;
var $bd5028e33dce7343$export$1538c33de8887b59;
var $bd5028e33dce7343$export$fca7f784ae7a249a;
var $bd5028e33dce7343$export$13e3392192263954;
var $bd5028e33dce7343$export$b8f5890fc79d6aca;
var $bd5028e33dce7343$export$60241385465d0a34;
var $bd5028e33dce7343$export$306c0aa65ff9ec16;
var $bd5028e33dce7343$export$7b286972b8d8ccbf;
var $bd5028e33dce7343$export$83d89fbfd8236492;
"use strict";
var $bd5028e33dce7343$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $bd5028e33dce7343$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $bd5028e33dce7343$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $bd5028e33dce7343$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $bd5028e33dce7343$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $bd5028e33dce7343$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $bd5028e33dce7343$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $bd5028e33dce7343$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $bd5028e33dce7343$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $bd5028e33dce7343$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $bd5028e33dce7343$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $bd5028e33dce7343$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $bd5028e33dce7343$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $bd5028e33dce7343$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $bd5028e33dce7343$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$bd5028e33dce7343$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $bd5028e33dce7343$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $bd5028e33dce7343$var$assign = Object.assign, $bd5028e33dce7343$var$emptyObject = {};
function $bd5028e33dce7343$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $bd5028e33dce7343$var$emptyObject;
    this.updater = updater || $bd5028e33dce7343$var$ReactNoopUpdateQueue;
}
$bd5028e33dce7343$var$Component.prototype.isReactComponent = {};
$bd5028e33dce7343$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$bd5028e33dce7343$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $bd5028e33dce7343$var$ComponentDummy() {}
$bd5028e33dce7343$var$ComponentDummy.prototype = $bd5028e33dce7343$var$Component.prototype;
function $bd5028e33dce7343$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $bd5028e33dce7343$var$emptyObject;
    this.updater = updater || $bd5028e33dce7343$var$ReactNoopUpdateQueue;
}
var $bd5028e33dce7343$var$pureComponentPrototype = $bd5028e33dce7343$var$PureComponent.prototype = new $bd5028e33dce7343$var$ComponentDummy();
$bd5028e33dce7343$var$pureComponentPrototype.constructor = $bd5028e33dce7343$var$PureComponent;
$bd5028e33dce7343$var$assign($bd5028e33dce7343$var$pureComponentPrototype, $bd5028e33dce7343$var$Component.prototype);
$bd5028e33dce7343$var$pureComponentPrototype.isPureReactComponent = !0;
var $bd5028e33dce7343$var$isArrayImpl = Array.isArray;
function $bd5028e33dce7343$var$noop() {}
var $bd5028e33dce7343$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $bd5028e33dce7343$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $bd5028e33dce7343$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $bd5028e33dce7343$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $bd5028e33dce7343$var$cloneAndReplaceKey(oldElement, newKey) {
    return $bd5028e33dce7343$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $bd5028e33dce7343$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $bd5028e33dce7343$var$REACT_ELEMENT_TYPE;
}
function $bd5028e33dce7343$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $bd5028e33dce7343$var$userProvidedKeyEscapeRegex = /\/+/g;
function $bd5028e33dce7343$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $bd5028e33dce7343$var$escape("" + element.key) : index.toString(36);
}
function $bd5028e33dce7343$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($bd5028e33dce7343$var$noop, $bd5028e33dce7343$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $bd5028e33dce7343$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $bd5028e33dce7343$var$REACT_ELEMENT_TYPE:
                case $bd5028e33dce7343$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $bd5028e33dce7343$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $bd5028e33dce7343$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $bd5028e33dce7343$var$getElementKey(children, 0) : nameSoFar, $bd5028e33dce7343$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($bd5028e33dce7343$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $bd5028e33dce7343$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($bd5028e33dce7343$var$isValidElement(callback) && (callback = $bd5028e33dce7343$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($bd5028e33dce7343$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($bd5028e33dce7343$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $bd5028e33dce7343$var$getElementKey(nameSoFar, i), invokeCallback += $bd5028e33dce7343$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $bd5028e33dce7343$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $bd5028e33dce7343$var$getElementKey(nameSoFar, i++), invokeCallback += $bd5028e33dce7343$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $bd5028e33dce7343$var$mapIntoArray($bd5028e33dce7343$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $bd5028e33dce7343$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $bd5028e33dce7343$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $bd5028e33dce7343$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $bd5028e33dce7343$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $bd5028e33dce7343$var$Children = {
    map: $bd5028e33dce7343$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $bd5028e33dce7343$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $bd5028e33dce7343$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $bd5028e33dce7343$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$bd5028e33dce7343$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$bd5028e33dce7343$export$9c16c1426311996d = $bd5028e33dce7343$var$REACT_ACTIVITY_TYPE;
$bd5028e33dce7343$export$dca3b0875bd9a954 = $bd5028e33dce7343$var$Children;
$bd5028e33dce7343$export$16fa2f45be04daa8 = $bd5028e33dce7343$var$Component;
$bd5028e33dce7343$export$ffb0004e005737fa = $bd5028e33dce7343$var$REACT_FRAGMENT_TYPE;
$bd5028e33dce7343$export$e2c29f18771995cb = $bd5028e33dce7343$var$REACT_PROFILER_TYPE;
$bd5028e33dce7343$export$221d75b3f55bb0bd = $bd5028e33dce7343$var$PureComponent;
$bd5028e33dce7343$export$5f8d39834fd61797 = $bd5028e33dce7343$var$REACT_STRICT_MODE_TYPE;
$bd5028e33dce7343$export$74bf444e3cd11ea5 = $bd5028e33dce7343$var$REACT_SUSPENSE_TYPE;
$bd5028e33dce7343$export$1ced07cd6b1985ce = $bd5028e33dce7343$var$ReactSharedInternals;
$bd5028e33dce7343$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $bd5028e33dce7343$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$bd5028e33dce7343$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$bd5028e33dce7343$export$8c538325882c7eec = function() {
    return null;
};
$bd5028e33dce7343$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $bd5028e33dce7343$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$bd5028e33dce7343$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $bd5028e33dce7343$var$ReactElement(element.type, key, props);
};
$bd5028e33dce7343$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $bd5028e33dce7343$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $bd5028e33dce7343$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$bd5028e33dce7343$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$bd5028e33dce7343$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $bd5028e33dce7343$var$ReactElement(type, key, props);
};
$bd5028e33dce7343$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$bd5028e33dce7343$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $bd5028e33dce7343$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$bd5028e33dce7343$export$a8257692ac88316c = $bd5028e33dce7343$var$isValidElement;
$bd5028e33dce7343$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $bd5028e33dce7343$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $bd5028e33dce7343$var$lazyInitializer
    };
};
$bd5028e33dce7343$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $bd5028e33dce7343$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$bd5028e33dce7343$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $bd5028e33dce7343$var$ReactSharedInternals.T, currentTransition = {};
    $bd5028e33dce7343$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $bd5028e33dce7343$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($bd5028e33dce7343$var$noop, $bd5028e33dce7343$var$reportGlobalError);
    } catch (error) {
        $bd5028e33dce7343$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $bd5028e33dce7343$var$ReactSharedInternals.T = prevTransition;
    }
};
$bd5028e33dce7343$export$f93f40ac0ca7e3a8 = function() {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useCacheRefresh();
};
$bd5028e33dce7343$export$1f96ae73734a86cc = function(usable) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.use(usable);
};
$bd5028e33dce7343$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$bd5028e33dce7343$export$35808ee640e87ca7 = function(callback, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$bd5028e33dce7343$export$fae74005e78b1a27 = function(Context) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useContext(Context);
};
$bd5028e33dce7343$export$dc8fbce3eb94dc1e = function() {};
$bd5028e33dce7343$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$bd5028e33dce7343$export$6d9c69b0de29b591 = function(create, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useEffect(create, deps);
};
$bd5028e33dce7343$export$7f54fc3180508a52 = function(callback) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$bd5028e33dce7343$export$f680877a34711e37 = function() {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useId();
};
$bd5028e33dce7343$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$bd5028e33dce7343$export$aaabe4eda9ed9969 = function(create, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$bd5028e33dce7343$export$e5c5a5f917a5871c = function(create, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$bd5028e33dce7343$export$1538c33de8887b59 = function(create, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useMemo(create, deps);
};
$bd5028e33dce7343$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$bd5028e33dce7343$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$bd5028e33dce7343$export$b8f5890fc79d6aca = function(initialValue) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useRef(initialValue);
};
$bd5028e33dce7343$export$60241385465d0a34 = function(initialState) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useState(initialState);
};
$bd5028e33dce7343$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$bd5028e33dce7343$export$7b286972b8d8ccbf = function() {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useTransition();
};
$bd5028e33dce7343$export$83d89fbfd8236492 = "19.2.8";

});



parcelRegister("f3KQH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dcfe93d9935fbf6d$var$_ProfileIcon = $dcfe93d9935fbf6d$var$_interopRequireDefault((parcelRequire("aI9XX")));

var $dcfe93d9935fbf6d$var$_UserNavDropdown = $dcfe93d9935fbf6d$var$_interopRequireDefault((parcelRequire("b3Hi0")));
function $dcfe93d9935fbf6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dcfe93d9935fbf6d$var$React = window.React || null;
const { useEffect: $dcfe93d9935fbf6d$var$useEffect, useState: $dcfe93d9935fbf6d$var$useState, useMemo: $dcfe93d9935fbf6d$var$useMemo, useRef: $dcfe93d9935fbf6d$var$useRef } = $dcfe93d9935fbf6d$var$React;
const $dcfe93d9935fbf6d$var$user_type_and_css_class_map = {
    'anonymous': 'anonymous-link',
    'registered': 'registered-link',
    'subscriber': 'subscriber-link',
    'corp-subscriber': 'corp-subscriber-link',
    'corp-admin': 'corp-admin-link'
};
function $dcfe93d9935fbf6d$var$UserNav() {
    const DESKTOP_HOVER_MIN_WIDTH = 992;
    const [isDropdownOpen, setIsDropdownOpen] = $dcfe93d9935fbf6d$var$useState(false);
    const [hoverEnabled, setHoverEnabled] = $dcfe93d9935fbf6d$var$useState(false);
    const [isClickPinnedOpen, setIsClickPinnedOpen] = $dcfe93d9935fbf6d$var$useState(false);
    const refDropdownWrapper = $dcfe93d9935fbf6d$var$useRef(null);
    const isAuthenticated = window?.Zephr?.accessDetails?.isAuthenticated || false;
    const eventRef = $dcfe93d9935fbf6d$var$useRef(new AbortController());
    const [isCorpAdmin, setIsCorpAdmin] = $dcfe93d9935fbf6d$var$useState(()=>window.Cookies?.get('aw_user_is_corp_admin') === 'true');
    const currentUserType = $dcfe93d9935fbf6d$var$useMemo(()=>{
        if (!isAuthenticated) return 'anonymous';
        if (isCorpAdmin) return 'corp-admin';
        const activeProducts = Zephr?.accessDetails?.activeProducts || [];
        if (activeProducts.some((p)=>p.toLowerCase().includes('corp'))) return 'corp-subscriber';
        if (activeProducts.length > 0) return 'subscriber';
        return 'registered';
    }, [
        isCorpAdmin
    ]);
    const userNavItems = $dcfe93d9935fbf6d$var$useMemo(()=>{
        const typeClasses = new Set(Object.values($dcfe93d9935fbf6d$var$user_type_and_css_class_map));
        const currentTypeClass = $dcfe93d9935fbf6d$var$user_type_and_css_class_map[currentUserType];
        return window?.adw?.nav_user_context?.items?.filter((item)=>{
            if (!Boolean(item?.title && item?.url)) return false;
            const itemTypeClasses = item?.classes?.filter((cls)=>typeClasses.has(cls)) ?? [];
            if (itemTypeClasses.length === 0) return true;
            return itemTypeClasses.includes(currentTypeClass);
        }).map((item)=>({
                ...item,
                classes: item?.classes?.filter((cls)=>cls !== 'd-none')
            })) || [];
    }, [
        currentUserType
    ]);
    $dcfe93d9935fbf6d$var$useEffect(()=>{
        const typeClasses = Object.values($dcfe93d9935fbf6d$var$user_type_and_css_class_map);
        const currentTypeClass = $dcfe93d9935fbf6d$var$user_type_and_css_class_map[currentUserType];
        const selector = typeClasses.map((c)=>`.${c}`).join(',');
        document.querySelectorAll(selector).forEach((el)=>{
            const elTypeClasses = typeClasses.filter((c)=>el.classList.contains(c));
            const shouldShow = elTypeClasses.some((c)=>c === currentTypeClass);
            el.classList.toggle('d-none', !shouldShow);
        });
    }, [
        currentUserType
    ]);
    $dcfe93d9935fbf6d$var$useEffect(()=>{
        const signal = eventRef.current.signal;
        const hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
        const updateHoverEnabled = ()=>{
            const nextHoverEnabled = window.innerWidth >= DESKTOP_HOVER_MIN_WIDTH && hoverMedia.matches;
            setHoverEnabled(nextHoverEnabled);
            if (!nextHoverEnabled) setIsClickPinnedOpen(false);
        };
        updateHoverEnabled();
        window.addEventListener('resize', updateHoverEnabled, {
            signal: signal
        });
        hoverMedia.addEventListener('change', updateHoverEnabled, {
            signal: signal
        });
        document.addEventListener('click', (event)=>{
            if (refDropdownWrapper.current && !refDropdownWrapper.current.contains(event.target)) {
                setIsDropdownOpen(false);
                setIsClickPinnedOpen(false);
            }
        }, {
            signal: signal
        });
        document.addEventListener('adw:corpAdminResolved', (event)=>{
            const { isCorpAdmin: resolved } = event.detail;
            setIsCorpAdmin(resolved);
        }, {
            signal: signal
        });
        const elUserNav = document.querySelector('.user-nav');
        if (elUserNav) {
            elUserNav.classList.remove('opacity-0');
            if ('function' === typeof anime) anime({
                targets: elUserNav,
                opacity: [
                    0,
                    1
                ],
                duration: 300,
                easing: 'easeOutQuad',
                delay: 100
            });
        }
        const controller = eventRef.current;
        return ()=>controller.abort();
    }, []);
    const loginUrl = $dcfe93d9935fbf6d$var$useMemo(()=>{
        let url = window?.adw?.account_login_url || null;
        if (url) {
            // If url already has query params, append with &, otherwise with ?
            const separator = url.includes('?') ? '&' : '?';
            url = `${url}${separator}rdt=${window.location.href}`;
        }
        return url;
    }, []);
    return /*#__PURE__*/ $dcfe93d9935fbf6d$var$React.createElement($dcfe93d9935fbf6d$var$React.Fragment, null, isAuthenticated ? /*#__PURE__*/ $dcfe93d9935fbf6d$var$React.createElement("div", {
        className: "position-relative",
        ref: refDropdownWrapper,
        onMouseEnter: ()=>{
            if (hoverEnabled && userNavItems.length > 0) setIsDropdownOpen(true);
        },
        onMouseLeave: ()=>{
            if (hoverEnabled && !isClickPinnedOpen) setIsDropdownOpen(false);
        }
    }, /*#__PURE__*/ $dcfe93d9935fbf6d$var$React.createElement("button", {
        type: "button",
        className: `btn btn-link rounded-pill ${isClickPinnedOpen ? '' : 'border'} ps-3 pe-2 lh-1 text-decoration-none align-self-end d-inline-flex align-items-center px-0 fw-bold gap-1 ${isDropdownOpen ? 'bg-light-subtle text-primary' : ''}`,
        onClick: ()=>{
            if (hoverEnabled) {
                if (isDropdownOpen && isClickPinnedOpen) {
                    setIsDropdownOpen(false);
                    setIsClickPinnedOpen(false);
                } else {
                    setIsDropdownOpen(true);
                    setIsClickPinnedOpen(true);
                }
                return;
            }
            setIsDropdownOpen((prevState)=>!prevState);
        },
        "aria-expanded": isDropdownOpen,
        "aria-haspopup": "menu",
        style: {
            background: 'var(--bs-body-bg)',
            boxShadow: isClickPinnedOpen ? 'inset 0 0 3px var(--bs-primary)' : 'none'
        }
    }, window.awZephrUserData?.firstName ? /*#__PURE__*/ $dcfe93d9935fbf6d$var$React.createElement("span", null, `Hey, ${window.awZephrUserData.firstName}`) : /*#__PURE__*/ $dcfe93d9935fbf6d$var$React.createElement("span", null, "Hello"), /*#__PURE__*/ $dcfe93d9935fbf6d$var$React.createElement("span", {
        className: "position-relative"
    }, /*#__PURE__*/ $dcfe93d9935fbf6d$var$React.createElement($dcfe93d9935fbf6d$var$_ProfileIcon.default, {
        className: "fs-4"
    }))), /*#__PURE__*/ $dcfe93d9935fbf6d$var$React.createElement($dcfe93d9935fbf6d$var$_UserNavDropdown.default, {
        items: userNavItems,
        isOpen: isDropdownOpen
    })) : /*#__PURE__*/ $dcfe93d9935fbf6d$var$React.createElement("div", {
        className: "user-nav d-flex align-items-center gap-2 flex-shrink-0 "
    }, /*#__PURE__*/ $dcfe93d9935fbf6d$var$React.createElement("div", {
        className: "d-flex gap-3"
    }, /*#__PURE__*/ $dcfe93d9935fbf6d$var$React.createElement("a", {
        href: window.adw?.account_subscribe_url ?? '#',
        className: "btn btn-link text-decoration-none align-self-end d-inline-block px-0"
    }, "Subscribe"), /*#__PURE__*/ $dcfe93d9935fbf6d$var$React.createElement("a", {
        href: loginUrl ? loginUrl : '#',
        className: "btn-signin btn btn-link text-decoration-none align-self-end d-inline-block px-0"
    }, "Sign In"))));
}
var $dcfe93d9935fbf6d$var$_default = module.exports.default = $dcfe93d9935fbf6d$var$UserNav;

});
parcelRegister("aI9XX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7d1cc8d2ea023988$var$ProfileIcon;
function $7d1cc8d2ea023988$var$ProfileIcon({ className: className = '' }) {
    return /*#__PURE__*/ React.createElement("svg", {
        className: className,
        height: "1.25em",
        width: "1.25em",
        viewBox: "0 -960 960 960",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M250.85-269.62q54-35.69 109.73-53.03Q416.31-340 480-340q63.69 0 119.42 17.35 55.73 17.34 109.73 53.03 39.62-41 61.23-94.84Q792-418.31 792-480q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 61.69 21.62 115.54 21.61 53.84 61.23 94.84Zm141.38-194.61Q356-500.46 356-552t36.23-87.77Q428.46-676 480-676t87.77 36.23Q604-603.54 604-552t-36.23 87.77Q531.54-428 480-428t-87.77-36.23ZM480-136q-71.31 0-134-26.54t-109.81-73.65Q189.08-283.31 162.54-346 136-408.69 136-480q0-72.31 26.54-134.5t73.65-109.31q47.12-47.11 109.81-73.65Q408.69-824 480-824q72.31 0 134.5 26.54t109.31 73.65q47.11 47.12 73.65 109.31Q824-552.31 824-480q0 71.31-26.54 134t-73.65 109.81q-47.12 47.11-109.31 73.65Q552.31-136 480-136Zm108.85-52.35q54.53-20.34 96.53-56.96-43-29.31-95.23-46Q537.92-308 480-308q-57.92 0-111.04 15.81-53.11 15.81-94.34 46.88 42 36.62 96.53 56.96Q425.69-168 480-168q54.31 0 108.85-20.35Zm-44-298.8Q572-514.31 572-552t-27.15-64.85Q517.69-644 480-644t-64.85 27.15Q388-589.69 388-552t27.15 64.85Q442.31-460 480-460t64.85-27.15ZM480-552Zm0 309Z"
    }));
}

});

parcelRegister("b3Hi0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a826eb0449d7304f$var$_NewTabIcon = $a826eb0449d7304f$var$_interopRequireDefault((parcelRequire("3k97u")));

var $a826eb0449d7304f$var$_SignOutIcon = $a826eb0449d7304f$var$_interopRequireDefault((parcelRequire("kL4g4")));
function $a826eb0449d7304f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a826eb0449d7304f$var$React = window.React || null;
const { useEffect: $a826eb0449d7304f$var$useEffect, useRef: $a826eb0449d7304f$var$useRef } = $a826eb0449d7304f$var$React;
function $a826eb0449d7304f$var$UserNavDropdown({ items: items, isOpen: isOpen }) {
    const refDropdownMenu = $a826eb0449d7304f$var$useRef(null);
    $a826eb0449d7304f$var$useEffect(()=>{
        const elDropdownMenu = refDropdownMenu.current;
        if (!elDropdownMenu) return;
        if ('function' === typeof anime) {
            anime.remove(elDropdownMenu);
            if (isOpen) {
                elDropdownMenu.style.visibility = 'visible';
                elDropdownMenu.style.pointerEvents = 'auto';
                anime({
                    targets: elDropdownMenu,
                    opacity: [
                        0,
                        1
                    ],
                    translateY: [
                        -10,
                        0
                    ],
                    duration: 300,
                    easing: 'easeOutQuad'
                });
                return;
            }
            anime({
                targets: elDropdownMenu,
                opacity: [
                    1,
                    0
                ],
                translateY: [
                    0,
                    -10
                ],
                duration: 220,
                easing: 'easeInQuad',
                complete: ()=>{
                    elDropdownMenu.style.visibility = 'hidden';
                    elDropdownMenu.style.pointerEvents = 'none';
                }
            });
            return;
        }
        if (isOpen) {
            elDropdownMenu.style.opacity = '1';
            elDropdownMenu.style.transform = 'translateY(0)';
            elDropdownMenu.style.visibility = 'visible';
            elDropdownMenu.style.pointerEvents = 'auto';
        } else {
            elDropdownMenu.style.opacity = '0';
            elDropdownMenu.style.transform = 'translateY(-10px)';
            elDropdownMenu.style.visibility = 'hidden';
            elDropdownMenu.style.pointerEvents = 'none';
        }
    }, [
        isOpen
    ]);
    if (items.length === 0) return null;
    return /*#__PURE__*/ $a826eb0449d7304f$var$React.createElement("div", {
        ref: refDropdownMenu,
        className: "position-absolute end-0 pt-2",
        style: {
            zIndex: 1000,
            minWidth: '230px',
            opacity: 0,
            transform: 'translateY(-10px)',
            visibility: 'hidden',
            pointerEvents: 'none'
        },
        "aria-hidden": !isOpen
    }, /*#__PURE__*/ $a826eb0449d7304f$var$React.createElement("ul", {
        className: "list-group rounded-4 shadow-sm mb-0 ",
        role: "menu"
    }, items.map((item, index)=>{
        const itemClasses = item?.classes?.filter(Boolean).join(' ') || '';
        const resolvedTarget = itemClasses.includes('new-tab') ? '_blank' : item.target;
        const isNewTabItem = resolvedTarget === '_blank';
        const titleWords = (item?.title || '').trim().split(/\s+/).filter(Boolean);
        const lastWord = titleWords.length > 0 ? titleWords[titleWords.length - 1] : '';
        const leadingWords = titleWords.length > 1 ? titleWords.slice(0, -1).join(' ') : '';
        const isSignOutItem = item?.title?.toLowerCase?.().includes?.('sign out') || item?.title?.toLowerCase?.().includes?.('logout');
        const trimmedUrl = item?.url?.trim() ?? '';
        const itemPath = trimmedUrl && !trimmedUrl.startsWith('#') && !trimmedUrl.startsWith('?') ? new URL(trimmedUrl, location.href).pathname : '';
        const isActiveItem = Boolean(itemPath) && itemPath === location.pathname;
        return /*#__PURE__*/ $a826eb0449d7304f$var$React.createElement("li", {
            className: `list-group-item p-0 overflow-hidden ${itemClasses} ${isActiveItem ? ' active' : ''}`,
            key: `user-nav-item-${item.ID || index}`,
            role: "none"
        }, /*#__PURE__*/ $a826eb0449d7304f$var$React.createElement("a", {
            href: item.url,
            target: resolvedTarget || undefined,
            rel: isNewTabItem ? 'noopener noreferrer' : undefined,
            className: `d-inline-flex w-100 fs-6 py-2 px-3 align-items-center flex-wrap gap-1 text-decoration-none ${isActiveItem ? '' : 'text-hover-primary'} ${isSignOutItem ? 'text-danger zephr-logout' : ''}`,
            onMouseEnter: (event)=>!isActiveItem && event.currentTarget.classList.add('bg-light-subtle'),
            onMouseLeave: (event)=>!isActiveItem && event.currentTarget.classList.remove('bg-light-subtle'),
            role: "menuitem"
        }, isNewTabItem ? /*#__PURE__*/ $a826eb0449d7304f$var$React.createElement($a826eb0449d7304f$var$React.Fragment, null, leadingWords && /*#__PURE__*/ $a826eb0449d7304f$var$React.createElement("span", null, leadingWords), /*#__PURE__*/ $a826eb0449d7304f$var$React.createElement("span", {
            className: "d-inline-flex align-items-center gap-1 text-nowrap"
        }, /*#__PURE__*/ $a826eb0449d7304f$var$React.createElement("span", null, lastWord), /*#__PURE__*/ $a826eb0449d7304f$var$React.createElement($a826eb0449d7304f$var$_NewTabIcon.default, {
            className: "fs-8"
        }))) : /*#__PURE__*/ $a826eb0449d7304f$var$React.createElement("span", null, item.title), isSignOutItem && /*#__PURE__*/ $a826eb0449d7304f$var$React.createElement($a826eb0449d7304f$var$_SignOutIcon.default, {
            className: "fs-6"
        })));
    })));
}
var $a826eb0449d7304f$var$_default = module.exports.default = $a826eb0449d7304f$var$UserNavDropdown;

});
parcelRegister("kL4g4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e3438c044d868117$var$SignOutIcon;
function $e3438c044d868117$var$SignOutIcon({ className: className = '' }) {
    return /*#__PURE__*/ React.createElement("svg", {
        className: className,
        height: "1.25em",
        width: "1.25em",
        fill: "currentColor",
        viewBox: "0 -960 960 960"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M160-160v-640h320.77v40H200v560h280.77v40H160Zm498.46-178.46-28.08-28.77L723.15-460H367.69v-40h355.46l-92.77-92.77 28.08-28.77L800-480 658.46-338.46Z"
    }));
}

});



parcelRegister("bAqQo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $462b3a231bc9f237$var$NavAlertsApp;
const $462b3a231bc9f237$var$React = window.React || null;
const { useState: $462b3a231bc9f237$var$useState, useEffect: $462b3a231bc9f237$var$useEffect, useRef: $462b3a231bc9f237$var$useRef } = $462b3a231bc9f237$var$React || null;
const $462b3a231bc9f237$var$delay = 8000;
const $462b3a231bc9f237$var$duration = 400;
const $462b3a231bc9f237$var$transitionDuration = 300;
const $462b3a231bc9f237$var$mobileBreakpoint = 991;
function $462b3a231bc9f237$var$NavAlertsApp({ containerType: containerType = 'desktop' } = {}) {
    const [alerts, setAlerts] = $462b3a231bc9f237$var$useState([]);
    const [isMobile, setIsMobile] = $462b3a231bc9f237$var$useState(false);
    const fetchAlerts = ({ mobileOnly: mobileOnly = false } = {})=>{
        const elAlertBlocks = document.querySelectorAll('.adw-alert');
        if (elAlertBlocks.length > 0) {
            const alertsFromBlocks = [];
            elAlertBlocks.forEach((elBlock)=>{
                if (elBlock?.dataset?.attributes) {
                    const attributesAsStr = elBlock?.getAttribute?.('data-attributes') || '';
                    const attributes = JSON.parse(attributesAsStr);
                    // Skip if the block is not set to render in the nav
                    if (!attributes.renderInNav) return;
                    if (mobileOnly && !attributes.alertRichTextMobile) return;
                    // Skip if the block is already in the alerts array
                    if (alertsFromBlocks?.length && alertsFromBlocks.includes(attributes)) return;
                    alertsFromBlocks.push(attributes);
                }
            });
            return alertsFromBlocks;
        }
        return [];
    };
    $462b3a231bc9f237$var$useEffect(()=>{
        // Check if we're on mobile
        const checkMobile = ()=>{
            setIsMobile(window.innerWidth < $462b3a231bc9f237$var$mobileBreakpoint);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return ()=>window.removeEventListener('resize', checkMobile);
    }, []);
    $462b3a231bc9f237$var$useEffect(()=>{
        // Fetch alerts from the DOM
        const alerts = isMobile ? fetchAlerts({
            mobileOnly: true
        }) : fetchAlerts();
        setAlerts(alerts);
    }, [
        isMobile
    ]);
    // Re-fetch alerts on window resize,
    // and if mobile, exclude alerts that do not have the mobile text (alert.alertRichTextMobile)
    $462b3a231bc9f237$var$useEffect(()=>{
        const handleResize = (event)=>{
            let alerts = [];
            // If the screen width is less than mobileBreakpoint px, filter out alerts that do not have mobile text
            if (isMobile) alerts = fetchAlerts({
                mobileOnly: true
            });
            else // If the screen width is greater than mobileBreakpoint px, fetch all alerts
            alerts = fetchAlerts();
            setAlerts(alerts);
        };
        window.addEventListener('resize', handleResize, {
            passive: true
        });
        return ()=>{
            window.removeEventListener('resize', handleResize);
        };
    }, [
        isMobile
    ]);
    // Only render if the container type matches the current viewport
    // Mobile container should only render on mobile
    // Desktop container should only render on desktop
    if (containerType === 'mobile' && !isMobile || containerType === 'desktop' && isMobile) return null;
    return /*#__PURE__*/ $462b3a231bc9f237$var$React.createElement("div", {
        className: "adw-nav-alerts-app d-flex align-items-center justify-content-center justify-content-lg-start "
    }, /*#__PURE__*/ $462b3a231bc9f237$var$React.createElement($462b3a231bc9f237$var$Alerts, {
        alerts: alerts
    }));
}
function $462b3a231bc9f237$var$Alerts({ alerts: alerts }) {
    const [activeIndex, setActiveIndex] = $462b3a231bc9f237$var$useState(0);
    // Cycle active index through alerts
    $462b3a231bc9f237$var$useEffect(()=>{
        if (alerts.length <= 1) return;
        const interval = setInterval(()=>{
            setActiveIndex((prevIndex)=>(prevIndex + 1) % alerts.length);
        }, $462b3a231bc9f237$var$delay);
        return ()=>clearInterval(interval);
    }, [
        alerts.length
    ]);
    return /*#__PURE__*/ $462b3a231bc9f237$var$React.createElement("div", {
        className: "adw-alerts d-flex flex-column gap-3 overflow-hidden"
    }, alerts.map((alert, index)=>/*#__PURE__*/ $462b3a231bc9f237$var$React.createElement($462b3a231bc9f237$var$AlertItem, {
            key: index,
            index: index,
            alert: alert,
            activeIndex: activeIndex,
            hasMultipleAlerts: alerts.length > 1
        })));
}
function $462b3a231bc9f237$var$AlertItem({ alert: alert, activeIndex: activeIndex, index: index, hasMultipleAlerts: hasMultipleAlerts }) {
    const ref = $462b3a231bc9f237$var$useRef(null);
    // Apply animation if there are multiple alerts
    $462b3a231bc9f237$var$useEffect(()=>{
        if (alert && activeIndex === index && hasMultipleAlerts) {
            if ('function' === typeof anime) {
                const elAnchor = ref?.current?.querySelector('a');
                // Fade in the alert
                anime({
                    targets: elAnchor,
                    opacity: [
                        0,
                        1
                    ],
                    duration: $462b3a231bc9f237$var$duration,
                    easing: 'easeOutQuad'
                });
                const elProgress = ref?.current?.querySelector('.progress-nav-alert');
                anime?.set(elProgress, {
                    transformOrigin: '0 0'
                });
                anime({
                    targets: elProgress,
                    scaleX: [
                        '0%',
                        '100%'
                    ],
                    duration: $462b3a231bc9f237$var$delay - $462b3a231bc9f237$var$transitionDuration - 50,
                    delay: 50,
                    easing: 'linear'
                });
                anime({
                    targets: ref?.current,
                    opacity: [
                        1,
                        0
                    ],
                    duration: $462b3a231bc9f237$var$transitionDuration,
                    delay: $462b3a231bc9f237$var$delay - 300,
                    easing: 'easeOutQuad'
                });
            }
        }
    }, [
        alert,
        activeIndex
    ]);
    const AlertIcon = ()=>/*#__PURE__*/ $462b3a231bc9f237$var$React.createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ $462b3a231bc9f237$var$React.createElement("path", {
            d: "M15.9994 29C23.1745 29 29 23.1745 29 15.9993C29 8.82416 23.1745 3 15.9994 3C8.82546 3 3 8.82416 3 15.9993C3 23.1745 8.82546 29 15.9994 29ZM15.9994 27.0495C9.90083 27.0495 4.95049 22.0979 4.95049 15.9993C4.95049 9.90082 9.90083 4.95049 15.9994 4.95049C22.0979 4.95049 27.0495 9.90082 27.0495 15.9993C27.0495 22.0979 22.0979 27.0495 15.9994 27.0495ZM15.9994 18.5974C15.461 18.5974 15.0241 18.1605 15.0241 17.6222V10.4704C15.0241 9.93203 15.461 9.49512 15.9994 9.49512C16.5377 9.49512 16.9746 9.93203 16.9746 10.4704V17.6222C16.9746 18.1605 16.5377 18.5974 15.9994 18.5974ZM15.9967 22.4984C16.7145 22.4984 17.2971 21.9158 17.2971 21.198C17.2971 20.4803 16.7145 19.8977 15.9967 19.8977C15.279 19.8977 14.6964 20.4803 14.6964 21.198C14.6964 21.9158 15.279 22.4984 15.9967 22.4984Z",
            fill: "#F53C60"
        }));
    return /*#__PURE__*/ $462b3a231bc9f237$var$React.createElement($462b3a231bc9f237$var$React.Fragment, null, /*#__PURE__*/ $462b3a231bc9f237$var$React.createElement("div", {
        ref: ref,
        "data-is-active": activeIndex === index,
        className: `adw-nav-alert ${activeIndex === index ? 'd-flex' : 'd-none'} flex-column border border-primary rounded-end-top-3 `
    }, /*#__PURE__*/ $462b3a231bc9f237$var$React.createElement("div", {
        className: "py-2 py-lg-3 px-3 d-flex align-items-center"
    }, /*#__PURE__*/ $462b3a231bc9f237$var$React.createElement("a", {
        href: alert.alertUrl || '#',
        target: alert?.openInNewTab ? '_blank' : '_self',
        className: "text-decoration-none d-block d-md-none overflow-hidden fs-0 mobile-nav-alert"
    }, /*#__PURE__*/ $462b3a231bc9f237$var$React.createElement("div", {
        className: "mobile-alert-container d-flex align-items-center"
    }, /*#__PURE__*/ $462b3a231bc9f237$var$React.createElement("div", {
        className: "alert-icon me-3"
    }, /*#__PURE__*/ $462b3a231bc9f237$var$React.createElement(AlertIcon, null)), /*#__PURE__*/ $462b3a231bc9f237$var$React.createElement("div", {
        className: "alert-content"
    }, /*#__PURE__*/ $462b3a231bc9f237$var$React.createElement("div", {
        className: "alert-label"
    }, /*#__PURE__*/ $462b3a231bc9f237$var$React.createElement("span", {
        className: "alert-brand"
    }, "ADWEEK"), /*#__PURE__*/ $462b3a231bc9f237$var$React.createElement("span", {
        className: "alert-type"
    }, "ALERT:")), /*#__PURE__*/ $462b3a231bc9f237$var$React.createElement("div", {
        className: "alert-message",
        dangerouslySetInnerHTML: {
            __html: alert.alertRichTextMobile || alert.alertRichText
        }
    })))), /*#__PURE__*/ $462b3a231bc9f237$var$React.createElement("a", {
        href: alert.alertUrl || '#',
        target: alert?.openInNewTab ? '_blank' : '_self',
        className: "text-decoration-none d-none d-md-block overflow-hidden"
    }, /*#__PURE__*/ $462b3a231bc9f237$var$React.createElement("div", {
        style: {
            color: 'var(--bs-link-color)'
        },
        className: "nav-alert-content lh-sm",
        dangerouslySetInnerHTML: {
            __html: alert.alertRichText
        }
    }))), hasMultipleAlerts && /*#__PURE__*/ $462b3a231bc9f237$var$React.createElement("div", {
        className: "progress-nav-alert border-bottom border-primary",
        style: {
            height: '1px'
        }
    })));
}

});

parcelRegister("gDoZE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $877d1d830d3fd630$var$ArticleReadTime;

var $877d1d830d3fd630$var$_readingTime = $877d1d830d3fd630$var$_interopRequireDefault((parcelRequire("kDkk8")));
function $877d1d830d3fd630$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $877d1d830d3fd630$var$React = window.React || null;
const { useState: $877d1d830d3fd630$var$useState, useEffect: $877d1d830d3fd630$var$useEffect } = $877d1d830d3fd630$var$React || null;
function $877d1d830d3fd630$var$ArticleReadTime() {
    const [readTimeStr, setReadTimeStr] = $877d1d830d3fd630$var$useState('');
    $877d1d830d3fd630$var$useEffect(()=>{
        // Check if .non-paywall & .paywall are present in the DOM
        const elNonPaywall = document.querySelector('.aw-article-content>.non-paywall');
        const elPaywall = document.querySelector('.aw-article-content>.paywall');
        let elParagraphsAll = null;
        if (!elNonPaywall || !elPaywall) elParagraphsAll = document.querySelectorAll('.aw-article-content> p:not(.promo-insert p)');
        else elParagraphsAll = document.querySelectorAll('.aw-article-content>.non-paywall > p:not(.promo-insert p), .aw-article-content>.paywall > p:not(.promo-insert p)');
        let articleText = '';
        if (elParagraphsAll) elParagraphsAll.forEach((el)=>{
            articleText += el.innerText;
        });
        // Calculate read time
        const stats = (0, $877d1d830d3fd630$var$_readingTime.default)(articleText);
        if (stats?.text && stats?.words >= 200) setReadTimeStr(`${stats.text}`);
    });
    // Animate in read time
    $877d1d830d3fd630$var$useEffect(()=>{
        const elReadTime = document.querySelector('.read-time');
        if (elReadTime && 'function' === typeof anime) {
            elReadTime.style.visibility = 'visible';
            anime({
                targets: elReadTime,
                opacity: [
                    0,
                    1
                ],
                duration: 300,
                easing: 'easeOutQuad',
                delay: 200,
                loop: false
            });
        }
    }, [
        readTimeStr
    ]);
    return /*#__PURE__*/ $877d1d830d3fd630$var$React.createElement($877d1d830d3fd630$var$React.Fragment, null, readTimeStr?.length > 0 && /*#__PURE__*/ $877d1d830d3fd630$var$React.createElement($877d1d830d3fd630$var$React.Fragment, null, "|", /*#__PURE__*/ $877d1d830d3fd630$var$React.createElement("div", null, readTimeStr)));
}

});
parcelRegister("kDkk8", function(module, exports) {

module.exports.default = module.exports = (parcelRequire("3H8xj"));

module.exports.readingTimeStream = (parcelRequire("iKP8X"));

});
parcelRegister("3H8xj", function(module, exports) {
/*!
 * reading-time
 * Copyright (c) Nicolas Gryman <ngryman@gmail.com>
 * MIT Licensed
 */ 'use strict';
/**
 * @typedef {import('reading-time').Options['wordBound']} WordBoundFunction
 */ /**
 * @param {number} number
 * @param {number[][]} arrayOfRanges
 */ function $2b0c025cf7bfd10e$var$codeIsInRanges(number, arrayOfRanges) {
    return arrayOfRanges.some(([lowerBound, upperBound])=>lowerBound <= number && number <= upperBound);
}
/**
 * @type {WordBoundFunction}
 */ function $2b0c025cf7bfd10e$var$isCJK(c) {
    if ('string' !== typeof c) return false;
    const charCode = c.charCodeAt(0);
    // Help wanted!
    // This should be good for most cases, but if you find it unsatisfactory
    // (e.g. some other language where each character should be standalone words),
    // contributions welcome!
    return $2b0c025cf7bfd10e$var$codeIsInRanges(charCode, [
        // Hiragana (Katakana not included on purpose,
        // context: https://github.com/ngryman/reading-time/pull/35#issuecomment-853364526)
        // If you think Katakana should be included and have solid reasons, improvement is welcomed
        [
            0x3040,
            0x309f
        ],
        // CJK Unified ideographs
        [
            0x4e00,
            0x9fff
        ],
        // Hangul
        [
            0xac00,
            0xd7a3
        ],
        // CJK extensions
        [
            0x20000,
            0x2ebe0
        ]
    ]);
}
/**
 * @type {WordBoundFunction}
 */ function $2b0c025cf7bfd10e$var$isAnsiWordBound(c) {
    return ' \n\r\t'.includes(c);
}
/**
 * @type {WordBoundFunction}
 */ function $2b0c025cf7bfd10e$var$isPunctuation(c) {
    if ('string' !== typeof c) return false;
    const charCode = c.charCodeAt(0);
    return $2b0c025cf7bfd10e$var$codeIsInRanges(charCode, [
        [
            0x21,
            0x2f
        ],
        [
            0x3a,
            0x40
        ],
        [
            0x5b,
            0x60
        ],
        [
            0x7b,
            0x7e
        ],
        // CJK Symbols and Punctuation
        [
            0x3000,
            0x303f
        ],
        // Full-width ASCII punctuation variants
        [
            0xff00,
            0xffef
        ]
    ]);
}
/**
 * @type {import('reading-time').default}
 */ function $2b0c025cf7bfd10e$var$readingTime(text, options = {}) {
    let words = 0, start = 0, end = text.length - 1;
    // use provided value if available
    const wordsPerMinute = options.wordsPerMinute || 200;
    // use provided function if available
    const isWordBound = options.wordBound || $2b0c025cf7bfd10e$var$isAnsiWordBound;
    // fetch bounds
    while(isWordBound(text[start]))start++;
    while(isWordBound(text[end]))end--;
    // Add a trailing word bound to make handling edges more convenient
    const normalizedText = `${text}\n`;
    // calculate the number of words
    for(let i = start; i <= end; i++){
        // A CJK character is a always word;
        // A non-word bound followed by a word bound / CJK is the end of a word.
        if ($2b0c025cf7bfd10e$var$isCJK(normalizedText[i]) || !isWordBound(normalizedText[i]) && (isWordBound(normalizedText[i + 1]) || $2b0c025cf7bfd10e$var$isCJK(normalizedText[i + 1]))) words++;
        // In case of CJK followed by punctuations, those characters have to be eaten as well
        if ($2b0c025cf7bfd10e$var$isCJK(normalizedText[i])) while(i <= end && ($2b0c025cf7bfd10e$var$isPunctuation(normalizedText[i + 1]) || isWordBound(normalizedText[i + 1])))i++;
    }
    // reading time stats
    const minutes = words / wordsPerMinute;
    // Math.round used to resolve floating point funkyness
    //   http://docs.oracle.com/cd/E19957-01/806-3568/ncg_goldberg.html
    const time = Math.round(minutes * 60000);
    const displayed = Math.ceil(minutes.toFixed(2));
    return {
        text: displayed + ' min read',
        minutes: minutes,
        time: time,
        words: words
    };
}
/**
 * Export
 */ module.exports = $2b0c025cf7bfd10e$var$readingTime;

});

parcelRegister("iKP8X", function(module, exports) {
/*!
 * reading-time
 * Copyright (c) Nicolas Gryman <ngryman@gmail.com>
 * MIT Licensed
 */ 'use strict';

var $3H8xj = parcelRequire("3H8xj");

var $g5acy = parcelRequire("g5acy");
var $da7431e197fcb32b$require$Transform = $g5acy.Transform;

var $1emjU = parcelRequire("1emjU");
/**
 * @typedef {import('reading-time').Options} Options
 * @typedef {import('reading-time').Options['wordBound']} WordBoundFunction
 * @typedef {import('reading-time').readingTimeStream} ReadingTimeStream
 * @typedef {import('stream').TransformCallback} TransformCallback
 */ /**
 * @param {Options} options
 * @returns {ReadingTimeStream}
 */ function $da7431e197fcb32b$var$ReadingTimeStream(options) {
    // allow use without new
    if (!(this instanceof $da7431e197fcb32b$var$ReadingTimeStream)) return new $da7431e197fcb32b$var$ReadingTimeStream(options);
    $da7431e197fcb32b$require$Transform.call(this, {
        objectMode: true
    });
    this.options = options || {};
    this.stats = {
        minutes: 0,
        time: 0,
        words: 0
    };
}
$1emjU.inherits($da7431e197fcb32b$var$ReadingTimeStream, $da7431e197fcb32b$require$Transform);
/**
 * @param {Buffer} chunk
 * @param {BufferEncoding} encoding
 * @param {TransformCallback} callback
 */ $da7431e197fcb32b$var$ReadingTimeStream.prototype._transform = function(chunk, encoding, callback) {
    const stats = $3H8xj(chunk.toString(encoding), this.options);
    this.stats.minutes += stats.minutes;
    this.stats.time += stats.time;
    this.stats.words += stats.words;
    callback();
};
/**
 * @param {TransformCallback} callback
 */ $da7431e197fcb32b$var$ReadingTimeStream.prototype._flush = function(callback) {
    this.stats.text = Math.ceil(this.stats.minutes.toFixed(2)) + ' min read';
    this.push(this.stats);
    callback();
};
/**
 * Export
 */ module.exports = $da7431e197fcb32b$var$ReadingTimeStream;

});
parcelRegister("g5acy", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $bb5506cc58c54722$var$Stream;

var $dG33B = parcelRequire("dG33B");
var $bb5506cc58c54722$require$EE = $dG33B.EventEmitter;

var $9M38k = parcelRequire("9M38k");
$9M38k($bb5506cc58c54722$var$Stream, $bb5506cc58c54722$require$EE);

$bb5506cc58c54722$var$Stream.Readable = (parcelRequire("gI7KH"));

$bb5506cc58c54722$var$Stream.Writable = (parcelRequire("h57Ja"));

$bb5506cc58c54722$var$Stream.Duplex = (parcelRequire("djKha"));

$bb5506cc58c54722$var$Stream.Transform = (parcelRequire("jwvFo"));

$bb5506cc58c54722$var$Stream.PassThrough = (parcelRequire("dPjGZ"));

$bb5506cc58c54722$var$Stream.finished = (parcelRequire("8flRm"));

$bb5506cc58c54722$var$Stream.pipeline = (parcelRequire("1K5UB"));
// Backwards-compat with node 0.4.x
$bb5506cc58c54722$var$Stream.Stream = $bb5506cc58c54722$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $bb5506cc58c54722$var$Stream() {
    $bb5506cc58c54722$require$EE.call(this);
}
$bb5506cc58c54722$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($bb5506cc58c54722$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("dG33B", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $9f5191ad6e142a03$var$R = typeof Reflect === 'object' ? Reflect : null;
var $9f5191ad6e142a03$var$ReflectApply = $9f5191ad6e142a03$var$R && typeof $9f5191ad6e142a03$var$R.apply === 'function' ? $9f5191ad6e142a03$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $9f5191ad6e142a03$var$ReflectOwnKeys;
if ($9f5191ad6e142a03$var$R && typeof $9f5191ad6e142a03$var$R.ownKeys === 'function') $9f5191ad6e142a03$var$ReflectOwnKeys = $9f5191ad6e142a03$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $9f5191ad6e142a03$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $9f5191ad6e142a03$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $9f5191ad6e142a03$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $9f5191ad6e142a03$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $9f5191ad6e142a03$var$EventEmitter() {
    $9f5191ad6e142a03$var$EventEmitter.init.call(this);
}
module.exports = $9f5191ad6e142a03$var$EventEmitter;
module.exports.once = $9f5191ad6e142a03$var$once;
// Backwards-compat with node 0.10.x
$9f5191ad6e142a03$var$EventEmitter.EventEmitter = $9f5191ad6e142a03$var$EventEmitter;
$9f5191ad6e142a03$var$EventEmitter.prototype._events = undefined;
$9f5191ad6e142a03$var$EventEmitter.prototype._eventsCount = 0;
$9f5191ad6e142a03$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $9f5191ad6e142a03$var$defaultMaxListeners = 10;
function $9f5191ad6e142a03$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($9f5191ad6e142a03$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $9f5191ad6e142a03$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $9f5191ad6e142a03$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $9f5191ad6e142a03$var$defaultMaxListeners = arg;
    }
});
$9f5191ad6e142a03$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$9f5191ad6e142a03$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $9f5191ad6e142a03$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $9f5191ad6e142a03$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $9f5191ad6e142a03$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $9f5191ad6e142a03$var$_getMaxListeners(this);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $9f5191ad6e142a03$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $9f5191ad6e142a03$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$9f5191ad6e142a03$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $9f5191ad6e142a03$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $9f5191ad6e142a03$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $9f5191ad6e142a03$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $9f5191ad6e142a03$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $9f5191ad6e142a03$var$_addListener(this, type, listener, false);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.on = $9f5191ad6e142a03$var$EventEmitter.prototype.addListener;
$9f5191ad6e142a03$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $9f5191ad6e142a03$var$_addListener(this, type, listener, true);
};
function $9f5191ad6e142a03$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $9f5191ad6e142a03$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $9f5191ad6e142a03$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.once = function once(type, listener) {
    $9f5191ad6e142a03$var$checkListener(listener);
    this.on(type, $9f5191ad6e142a03$var$_onceWrap(this, type, listener));
    return this;
};
$9f5191ad6e142a03$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $9f5191ad6e142a03$var$checkListener(listener);
    this.prependListener(type, $9f5191ad6e142a03$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$9f5191ad6e142a03$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $9f5191ad6e142a03$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $9f5191ad6e142a03$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$9f5191ad6e142a03$var$EventEmitter.prototype.off = $9f5191ad6e142a03$var$EventEmitter.prototype.removeListener;
$9f5191ad6e142a03$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $9f5191ad6e142a03$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $9f5191ad6e142a03$var$unwrapListeners(evlistener) : $9f5191ad6e142a03$var$arrayClone(evlistener, evlistener.length);
}
$9f5191ad6e142a03$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $9f5191ad6e142a03$var$_listeners(this, type, true);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $9f5191ad6e142a03$var$_listeners(this, type, false);
};
$9f5191ad6e142a03$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $9f5191ad6e142a03$var$listenerCount.call(emitter, type);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.listenerCount = $9f5191ad6e142a03$var$listenerCount;
function $9f5191ad6e142a03$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $9f5191ad6e142a03$var$ReflectOwnKeys(this._events) : [];
};
function $9f5191ad6e142a03$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $9f5191ad6e142a03$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $9f5191ad6e142a03$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $9f5191ad6e142a03$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $9f5191ad6e142a03$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $9f5191ad6e142a03$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $9f5191ad6e142a03$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $9f5191ad6e142a03$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $9f5191ad6e142a03$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("9M38k", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("gI7KH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $6qd2L = parcelRequire("6qd2L");
'use strict';
module.exports = $c2a6c4da35c537b3$var$Readable;
/*<replacement>*/ var $c2a6c4da35c537b3$var$Duplex;
/*</replacement>*/ $c2a6c4da35c537b3$var$Readable.ReadableState = $c2a6c4da35c537b3$var$ReadableState;

var $dG33B = parcelRequire("dG33B");
var $c2a6c4da35c537b3$require$EE = $dG33B.EventEmitter;
var $c2a6c4da35c537b3$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jIePF = parcelRequire("jIePF");

var $3aNd6 = parcelRequire("3aNd6");
var $c2a6c4da35c537b3$require$Buffer = $3aNd6.Buffer;
var $c2a6c4da35c537b3$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $c2a6c4da35c537b3$var$_uint8ArrayToBuffer(chunk) {
    return $c2a6c4da35c537b3$require$Buffer.from(chunk);
}
function $c2a6c4da35c537b3$var$_isUint8Array(obj) {
    return $c2a6c4da35c537b3$require$Buffer.isBuffer(obj) || obj instanceof $c2a6c4da35c537b3$var$OurUint8Array;
}

var $1wVs5 = parcelRequire("1wVs5");
var $c2a6c4da35c537b3$var$debug;
if ($1wVs5 && $1wVs5.debuglog) $c2a6c4da35c537b3$var$debug = $1wVs5.debuglog('stream');
else $c2a6c4da35c537b3$var$debug = function debug() {};

var $aitIl = parcelRequire("aitIl");

var $ezAkG = parcelRequire("ezAkG");

var $gV8Xw = parcelRequire("gV8Xw");
var $c2a6c4da35c537b3$var$getHighWaterMark = $gV8Xw.getHighWaterMark;

var $h1zie = parcelRequire("h1zie");
var $c2a6c4da35c537b3$require$_require$codes = $h1zie.codes;
var $c2a6c4da35c537b3$var$ERR_INVALID_ARG_TYPE = $c2a6c4da35c537b3$require$_require$codes.ERR_INVALID_ARG_TYPE, $c2a6c4da35c537b3$var$ERR_STREAM_PUSH_AFTER_EOF = $c2a6c4da35c537b3$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $c2a6c4da35c537b3$var$ERR_METHOD_NOT_IMPLEMENTED = $c2a6c4da35c537b3$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $c2a6c4da35c537b3$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $c2a6c4da35c537b3$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $c2a6c4da35c537b3$var$StringDecoder;
var $c2a6c4da35c537b3$var$createReadableStreamAsyncIterator;
var $c2a6c4da35c537b3$var$from;

(parcelRequire("9M38k"))($c2a6c4da35c537b3$var$Readable, $jIePF);
var $c2a6c4da35c537b3$var$errorOrDestroy = $ezAkG.errorOrDestroy;
var $c2a6c4da35c537b3$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $c2a6c4da35c537b3$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $c2a6c4da35c537b3$var$ReadableState(options, stream, isDuplex) {
    $c2a6c4da35c537b3$var$Duplex = $c2a6c4da35c537b3$var$Duplex || (parcelRequire("djKha"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $c2a6c4da35c537b3$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $c2a6c4da35c537b3$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $aitIl();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$c2a6c4da35c537b3$var$StringDecoder) $c2a6c4da35c537b3$var$StringDecoder = (parcelRequire("g6ehz")).StringDecoder;
        this.decoder = new $c2a6c4da35c537b3$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $c2a6c4da35c537b3$var$Readable(options) {
    $c2a6c4da35c537b3$var$Duplex = $c2a6c4da35c537b3$var$Duplex || (parcelRequire("djKha"));
    if (!(this instanceof $c2a6c4da35c537b3$var$Readable)) return new $c2a6c4da35c537b3$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $c2a6c4da35c537b3$var$Duplex;
    this._readableState = new $c2a6c4da35c537b3$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $jIePF.call(this);
}
Object.defineProperty($c2a6c4da35c537b3$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$c2a6c4da35c537b3$var$Readable.prototype.destroy = $ezAkG.destroy;
$c2a6c4da35c537b3$var$Readable.prototype._undestroy = $ezAkG.undestroy;
$c2a6c4da35c537b3$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$c2a6c4da35c537b3$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $c2a6c4da35c537b3$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $c2a6c4da35c537b3$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$c2a6c4da35c537b3$var$Readable.prototype.unshift = function(chunk) {
    return $c2a6c4da35c537b3$var$readableAddChunk(this, chunk, null, true, false);
};
function $c2a6c4da35c537b3$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $c2a6c4da35c537b3$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $c2a6c4da35c537b3$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $c2a6c4da35c537b3$var$chunkInvalid(state, chunk);
        if (er) $c2a6c4da35c537b3$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $c2a6c4da35c537b3$require$Buffer.prototype) chunk = $c2a6c4da35c537b3$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $c2a6c4da35c537b3$var$errorOrDestroy(stream, new $c2a6c4da35c537b3$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $c2a6c4da35c537b3$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $c2a6c4da35c537b3$var$errorOrDestroy(stream, new $c2a6c4da35c537b3$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $c2a6c4da35c537b3$var$addChunk(stream, state, chunk, false);
                    else $c2a6c4da35c537b3$var$maybeReadMore(stream, state);
                } else $c2a6c4da35c537b3$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $c2a6c4da35c537b3$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $c2a6c4da35c537b3$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $c2a6c4da35c537b3$var$emitReadable(stream);
    }
    $c2a6c4da35c537b3$var$maybeReadMore(stream, state);
}
function $c2a6c4da35c537b3$var$chunkInvalid(state, chunk) {
    var er;
    if (!$c2a6c4da35c537b3$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $c2a6c4da35c537b3$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$c2a6c4da35c537b3$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$c2a6c4da35c537b3$var$Readable.prototype.setEncoding = function(enc) {
    if (!$c2a6c4da35c537b3$var$StringDecoder) $c2a6c4da35c537b3$var$StringDecoder = (parcelRequire("g6ehz")).StringDecoder;
    var decoder = new $c2a6c4da35c537b3$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $c2a6c4da35c537b3$var$MAX_HWM = 0x40000000;
function $c2a6c4da35c537b3$var$computeNewHighWaterMark(n) {
    if (n >= $c2a6c4da35c537b3$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $c2a6c4da35c537b3$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c2a6c4da35c537b3$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $c2a6c4da35c537b3$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$c2a6c4da35c537b3$var$Readable.prototype.read = function(n) {
    $c2a6c4da35c537b3$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $c2a6c4da35c537b3$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $c2a6c4da35c537b3$var$endReadable(this);
        else $c2a6c4da35c537b3$var$emitReadable(this);
        return null;
    }
    n = $c2a6c4da35c537b3$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $c2a6c4da35c537b3$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $c2a6c4da35c537b3$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $c2a6c4da35c537b3$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $c2a6c4da35c537b3$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $c2a6c4da35c537b3$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $c2a6c4da35c537b3$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $c2a6c4da35c537b3$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $c2a6c4da35c537b3$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $c2a6c4da35c537b3$var$onEofChunk(stream, state) {
    $c2a6c4da35c537b3$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $c2a6c4da35c537b3$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $c2a6c4da35c537b3$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $c2a6c4da35c537b3$var$emitReadable(stream) {
    var state = stream._readableState;
    $c2a6c4da35c537b3$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $c2a6c4da35c537b3$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $6qd2L.nextTick($c2a6c4da35c537b3$var$emitReadable_, stream);
    }
}
function $c2a6c4da35c537b3$var$emitReadable_(stream) {
    var state = stream._readableState;
    $c2a6c4da35c537b3$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $c2a6c4da35c537b3$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $c2a6c4da35c537b3$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $6qd2L.nextTick($c2a6c4da35c537b3$var$maybeReadMore_, stream, state);
    }
}
function $c2a6c4da35c537b3$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $c2a6c4da35c537b3$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$c2a6c4da35c537b3$var$Readable.prototype._read = function(n) {
    $c2a6c4da35c537b3$var$errorOrDestroy(this, new $c2a6c4da35c537b3$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$c2a6c4da35c537b3$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $c2a6c4da35c537b3$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $6qd2L.stdout && dest !== $6qd2L.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $6qd2L.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $c2a6c4da35c537b3$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $c2a6c4da35c537b3$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $c2a6c4da35c537b3$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $c2a6c4da35c537b3$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $c2a6c4da35c537b3$var$debug('ondata');
        var ret = dest.write(chunk);
        $c2a6c4da35c537b3$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $c2a6c4da35c537b3$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $c2a6c4da35c537b3$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $c2a6c4da35c537b3$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($c2a6c4da35c537b3$var$EElistenerCount(dest, 'error') === 0) $c2a6c4da35c537b3$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $c2a6c4da35c537b3$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $c2a6c4da35c537b3$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $c2a6c4da35c537b3$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $c2a6c4da35c537b3$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $c2a6c4da35c537b3$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $c2a6c4da35c537b3$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $c2a6c4da35c537b3$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $c2a6c4da35c537b3$var$flow(src);
        }
    };
}
$c2a6c4da35c537b3$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $c2a6c4da35c537b3$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$c2a6c4da35c537b3$var$Readable.prototype.on = function(ev, fn) {
    var res = $jIePF.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $c2a6c4da35c537b3$var$debug('on readable', state.length, state.reading);
            if (state.length) $c2a6c4da35c537b3$var$emitReadable(this);
            else if (!state.reading) $6qd2L.nextTick($c2a6c4da35c537b3$var$nReadingNextTick, this);
        }
    }
    return res;
};
$c2a6c4da35c537b3$var$Readable.prototype.addListener = $c2a6c4da35c537b3$var$Readable.prototype.on;
$c2a6c4da35c537b3$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jIePF.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $6qd2L.nextTick($c2a6c4da35c537b3$var$updateReadableListening, this);
    return res;
};
$c2a6c4da35c537b3$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jIePF.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $6qd2L.nextTick($c2a6c4da35c537b3$var$updateReadableListening, this);
    return res;
};
function $c2a6c4da35c537b3$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $c2a6c4da35c537b3$var$nReadingNextTick(self1) {
    $c2a6c4da35c537b3$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$c2a6c4da35c537b3$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $c2a6c4da35c537b3$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $c2a6c4da35c537b3$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $c2a6c4da35c537b3$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $6qd2L.nextTick($c2a6c4da35c537b3$var$resume_, stream, state);
    }
}
function $c2a6c4da35c537b3$var$resume_(stream, state) {
    $c2a6c4da35c537b3$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $c2a6c4da35c537b3$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$c2a6c4da35c537b3$var$Readable.prototype.pause = function() {
    $c2a6c4da35c537b3$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $c2a6c4da35c537b3$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $c2a6c4da35c537b3$var$flow(stream) {
    var state = stream._readableState;
    $c2a6c4da35c537b3$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$c2a6c4da35c537b3$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $c2a6c4da35c537b3$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $c2a6c4da35c537b3$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $c2a6c4da35c537b3$var$kProxyEvents.length; n++)stream.on($c2a6c4da35c537b3$var$kProxyEvents[n], this.emit.bind(this, $c2a6c4da35c537b3$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $c2a6c4da35c537b3$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $c2a6c4da35c537b3$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($c2a6c4da35c537b3$var$createReadableStreamAsyncIterator === undefined) $c2a6c4da35c537b3$var$createReadableStreamAsyncIterator = (parcelRequire("5QtK4"));
    return $c2a6c4da35c537b3$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($c2a6c4da35c537b3$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($c2a6c4da35c537b3$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($c2a6c4da35c537b3$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$c2a6c4da35c537b3$var$Readable._fromList = $c2a6c4da35c537b3$var$fromList;
Object.defineProperty($c2a6c4da35c537b3$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c2a6c4da35c537b3$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $c2a6c4da35c537b3$var$endReadable(stream) {
    var state = stream._readableState;
    $c2a6c4da35c537b3$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $6qd2L.nextTick($c2a6c4da35c537b3$var$endReadableNT, state, stream);
    }
}
function $c2a6c4da35c537b3$var$endReadableNT(state, stream) {
    $c2a6c4da35c537b3$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $c2a6c4da35c537b3$var$Readable.from = function(iterable, opts) {
    if ($c2a6c4da35c537b3$var$from === undefined) $c2a6c4da35c537b3$var$from = (parcelRequire("adKWq"));
    return $c2a6c4da35c537b3$var$from($c2a6c4da35c537b3$var$Readable, iterable, opts);
};
function $c2a6c4da35c537b3$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("6qd2L", function(module, exports) {
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = 'browser';
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ''; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return '/';
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};

});

parcelRegister("jIePF", function(module, exports) {

module.exports = (parcelRequire("dG33B")).EventEmitter;

});

parcelRegister("3aNd6", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $24f87a6f86a8996f$export$a143d493d941bafc; }, function (v) { return $24f87a6f86a8996f$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a; }, function (v) { return $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $24f87a6f86a8996f$export$f99ded8fe4b79145; }, function (v) { return $24f87a6f86a8996f$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $24f87a6f86a8996f$export$599f31c3813fae4d; }, function (v) { return $24f87a6f86a8996f$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $24f87a6f86a8996f$export$a143d493d941bafc;
var $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a;
var $24f87a6f86a8996f$export$f99ded8fe4b79145;
var $24f87a6f86a8996f$export$599f31c3813fae4d;
'use strict';

var $5d11t = parcelRequire("5d11t");

var $7rddL = parcelRequire("7rddL");
const $24f87a6f86a8996f$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$24f87a6f86a8996f$export$a143d493d941bafc = $24f87a6f86a8996f$var$Buffer;
$24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = $24f87a6f86a8996f$var$SlowBuffer;
$24f87a6f86a8996f$export$f99ded8fe4b79145 = 50;
const $24f87a6f86a8996f$var$K_MAX_LENGTH = 0x7fffffff;
$24f87a6f86a8996f$export$599f31c3813fae4d = $24f87a6f86a8996f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT = $24f87a6f86a8996f$var$typedArraySupport();
if (!$24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $24f87a6f86a8996f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $24f87a6f86a8996f$var$createBuffer(length) {
    if (length > $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $24f87a6f86a8996f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $24f87a6f86a8996f$var$allocUnsafe(arg);
    }
    return $24f87a6f86a8996f$var$from(arg, encodingOrOffset, length);
}
$24f87a6f86a8996f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $24f87a6f86a8996f$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $24f87a6f86a8996f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $24f87a6f86a8996f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($24f87a6f86a8996f$var$isInstance(value, ArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, ArrayBuffer)) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($24f87a6f86a8996f$var$isInstance(value, SharedArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, SharedArrayBuffer))) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $24f87a6f86a8996f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $24f87a6f86a8996f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $24f87a6f86a8996f$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $24f87a6f86a8996f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $24f87a6f86a8996f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer, Uint8Array);
function $24f87a6f86a8996f$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $24f87a6f86a8996f$var$alloc(size, fill, encoding) {
    $24f87a6f86a8996f$var$assertSize(size);
    if (size <= 0) return $24f87a6f86a8996f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $24f87a6f86a8996f$var$createBuffer(size).fill(fill, encoding) : $24f87a6f86a8996f$var$createBuffer(size).fill(fill);
    return $24f87a6f86a8996f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $24f87a6f86a8996f$var$Buffer.alloc = function(size, fill, encoding) {
    return $24f87a6f86a8996f$var$alloc(size, fill, encoding);
};
function $24f87a6f86a8996f$var$allocUnsafe(size) {
    $24f87a6f86a8996f$var$assertSize(size);
    return $24f87a6f86a8996f$var$createBuffer(size < 0 ? 0 : $24f87a6f86a8996f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $24f87a6f86a8996f$var$Buffer.allocUnsafe = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $24f87a6f86a8996f$var$Buffer.allocUnsafeSlow = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
function $24f87a6f86a8996f$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $24f87a6f86a8996f$var$byteLength(string, encoding) | 0;
    let buf = $24f87a6f86a8996f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $24f87a6f86a8996f$var$checked(array.length) | 0;
    const buf = $24f87a6f86a8996f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayView(arrayView) {
    if ($24f87a6f86a8996f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $24f87a6f86a8996f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $24f87a6f86a8996f$var$fromArrayLike(arrayView);
}
function $24f87a6f86a8996f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
function $24f87a6f86a8996f$var$fromObject(obj) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(obj)) {
        const len = $24f87a6f86a8996f$var$checked(obj.length) | 0;
        const buf = $24f87a6f86a8996f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $24f87a6f86a8996f$var$numberIsNaN(obj.length)) return $24f87a6f86a8996f$var$createBuffer(0);
        return $24f87a6f86a8996f$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $24f87a6f86a8996f$var$fromArrayLike(obj.data);
}
function $24f87a6f86a8996f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $24f87a6f86a8996f$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $24f87a6f86a8996f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $24f87a6f86a8996f$var$Buffer.alloc(+length);
}
$24f87a6f86a8996f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $24f87a6f86a8996f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$24f87a6f86a8996f$var$Buffer.compare = function compare(a, b) {
    if ($24f87a6f86a8996f$var$isInstance(a, Uint8Array)) a = $24f87a6f86a8996f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($24f87a6f86a8996f$var$isInstance(b, Uint8Array)) b = $24f87a6f86a8996f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(a) || !$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$24f87a6f86a8996f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$24f87a6f86a8996f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $24f87a6f86a8996f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $24f87a6f86a8996f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($24f87a6f86a8996f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) buf = $24f87a6f86a8996f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $24f87a6f86a8996f$var$byteLength(string, encoding) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $24f87a6f86a8996f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $24f87a6f86a8996f$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $24f87a6f86a8996f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $24f87a6f86a8996f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$24f87a6f86a8996f$var$Buffer.byteLength = $24f87a6f86a8996f$var$byteLength;
function $24f87a6f86a8996f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $24f87a6f86a8996f$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $24f87a6f86a8996f$var$utf8Slice(this, start, end);
        case 'ascii':
            return $24f87a6f86a8996f$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $24f87a6f86a8996f$var$latin1Slice(this, start, end);
        case 'base64':
            return $24f87a6f86a8996f$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $24f87a6f86a8996f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$24f87a6f86a8996f$var$Buffer.prototype._isBuffer = true;
function $24f87a6f86a8996f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$24f87a6f86a8996f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$24f87a6f86a8996f$var$swap(this, i, i + 1);
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $24f87a6f86a8996f$var$swap(this, i, i + 3);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $24f87a6f86a8996f$var$swap(this, i, i + 7);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 6);
        $24f87a6f86a8996f$var$swap(this, i + 2, i + 5);
        $24f87a6f86a8996f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $24f87a6f86a8996f$var$utf8Slice(this, 0, length);
    return $24f87a6f86a8996f$var$slowToString.apply(this, arguments);
};
$24f87a6f86a8996f$var$Buffer.prototype.toLocaleString = $24f87a6f86a8996f$var$Buffer.prototype.toString;
$24f87a6f86a8996f$var$Buffer.prototype.equals = function equals(b) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $24f87a6f86a8996f$var$Buffer.compare(this, b) === 0;
};
$24f87a6f86a8996f$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $24f87a6f86a8996f$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($24f87a6f86a8996f$var$customInspectSymbol) $24f87a6f86a8996f$var$Buffer.prototype[$24f87a6f86a8996f$var$customInspectSymbol] = $24f87a6f86a8996f$var$Buffer.prototype.inspect;
$24f87a6f86a8996f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($24f87a6f86a8996f$var$isInstance(target, Uint8Array)) target = $24f87a6f86a8996f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $24f87a6f86a8996f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($24f87a6f86a8996f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $24f87a6f86a8996f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $24f87a6f86a8996f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$24f87a6f86a8996f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$24f87a6f86a8996f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $24f87a6f86a8996f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($24f87a6f86a8996f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $24f87a6f86a8996f$var$utf8Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $24f87a6f86a8996f$var$asciiWrite(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$asciiToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$base64Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$base64ToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$ucs2Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$24f87a6f86a8996f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $24f87a6f86a8996f$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $24f87a6f86a8996f$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $24f87a6f86a8996f$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $24f87a6f86a8996f$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $24f87a6f86a8996f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$24f87a6f86a8996f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $24f87a6f86a8996f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5d11t.fromByteArray(buf);
    else return $5d11t.fromByteArray(buf.slice(start, end));
}
function $24f87a6f86a8996f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $24f87a6f86a8996f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $24f87a6f86a8996f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $24f87a6f86a8996f$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $24f87a6f86a8996f$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $24f87a6f86a8996f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $24f87a6f86a8996f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $24f87a6f86a8996f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$24f87a6f86a8996f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $24f87a6f86a8996f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $24f87a6f86a8996f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$24f87a6f86a8996f$var$Buffer.prototype.readUintLE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUintBE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint8 = $24f87a6f86a8996f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$24f87a6f86a8996f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$24f87a6f86a8996f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, true, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, false, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, true, 52, 8);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, false, 52, 8);
};
function $24f87a6f86a8996f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$24f87a6f86a8996f$var$Buffer.prototype.writeUintLE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUintBE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint8 = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $24f87a6f86a8996f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $24f87a6f86a8996f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $24f87a6f86a8996f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, false, noAssert);
};
function $24f87a6f86a8996f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$24f87a6f86a8996f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$24f87a6f86a8996f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $24f87a6f86a8996f$var$Buffer.isBuffer(val) ? val : $24f87a6f86a8996f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $24f87a6f86a8996f$var$errors = {};
function $24f87a6f86a8996f$var$E(sym, getMessage, Base) {
    $24f87a6f86a8996f$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$24f87a6f86a8996f$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$24f87a6f86a8996f$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$24f87a6f86a8996f$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $24f87a6f86a8996f$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $24f87a6f86a8996f$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $24f87a6f86a8996f$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength) {
    $24f87a6f86a8996f$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $24f87a6f86a8996f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength);
}
function $24f87a6f86a8996f$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $24f87a6f86a8996f$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $24f87a6f86a8996f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $24f87a6f86a8996f$var$validateNumber(value, type);
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $24f87a6f86a8996f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $24f87a6f86a8996f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $24f87a6f86a8996f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($24f87a6f86a8996f$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $24f87a6f86a8996f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $24f87a6f86a8996f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $24f87a6f86a8996f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $24f87a6f86a8996f$var$base64ToBytes(str) {
    return $5d11t.toByteArray($24f87a6f86a8996f$var$base64clean(str));
}
function $24f87a6f86a8996f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $24f87a6f86a8996f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $24f87a6f86a8996f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $24f87a6f86a8996f$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $24f87a6f86a8996f$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $24f87a6f86a8996f$var$BufferBigIntNotDefined : fn;
}
function $24f87a6f86a8996f$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("5d11t", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $3caef5c332c7293f$export$d622b2ad8d90c771; }, function (v) { return $3caef5c332c7293f$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $3caef5c332c7293f$export$6100ba28696e12de; }, function (v) { return $3caef5c332c7293f$export$6100ba28696e12de = v; });
var $3caef5c332c7293f$export$a48f0734ac7c2329;
var $3caef5c332c7293f$export$d622b2ad8d90c771;
var $3caef5c332c7293f$export$6100ba28696e12de;
'use strict';
$3caef5c332c7293f$export$a48f0734ac7c2329 = $3caef5c332c7293f$var$byteLength;
$3caef5c332c7293f$export$d622b2ad8d90c771 = $3caef5c332c7293f$var$toByteArray;
$3caef5c332c7293f$export$6100ba28696e12de = $3caef5c332c7293f$var$fromByteArray;
var $3caef5c332c7293f$var$lookup = [];
var $3caef5c332c7293f$var$revLookup = [];
var $3caef5c332c7293f$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $3caef5c332c7293f$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $3caef5c332c7293f$var$i = 0, $3caef5c332c7293f$var$len = $3caef5c332c7293f$var$code.length; $3caef5c332c7293f$var$i < $3caef5c332c7293f$var$len; ++$3caef5c332c7293f$var$i){
    $3caef5c332c7293f$var$lookup[$3caef5c332c7293f$var$i] = $3caef5c332c7293f$var$code[$3caef5c332c7293f$var$i];
    $3caef5c332c7293f$var$revLookup[$3caef5c332c7293f$var$code.charCodeAt($3caef5c332c7293f$var$i)] = $3caef5c332c7293f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3caef5c332c7293f$var$revLookup['-'.charCodeAt(0)] = 62;
$3caef5c332c7293f$var$revLookup['_'.charCodeAt(0)] = 63;
function $3caef5c332c7293f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3caef5c332c7293f$var$byteLength(b64) {
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$toByteArray(b64) {
    var tmp;
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3caef5c332c7293f$var$Arr($3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 18 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 2 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 10 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3caef5c332c7293f$var$tripletToBase64(num) {
    return $3caef5c332c7293f$var$lookup[num >> 18 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 12 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 6 & 0x3F] + $3caef5c332c7293f$var$lookup[num & 0x3F];
}
function $3caef5c332c7293f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3caef5c332c7293f$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $3caef5c332c7293f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3caef5c332c7293f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 2] + $3caef5c332c7293f$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 10] + $3caef5c332c7293f$var$lookup[tmp >> 4 & 0x3F] + $3caef5c332c7293f$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("7rddL", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $56a54f6ebabce67d$export$aafa59e2e03f2942; }, function (v) { return $56a54f6ebabce67d$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $56a54f6ebabce67d$export$68d8715fc104d294; }, function (v) { return $56a54f6ebabce67d$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $56a54f6ebabce67d$export$aafa59e2e03f2942;
var $56a54f6ebabce67d$export$68d8715fc104d294;
$56a54f6ebabce67d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$56a54f6ebabce67d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("1wVs5", function(module, exports) {
"use strict";

});

parcelRegister("aitIl", function(module, exports) {
'use strict';
function $77f2a2759da6e934$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $77f2a2759da6e934$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $77f2a2759da6e934$var$ownKeys(Object(source), !0).forEach(function(key) {
            $77f2a2759da6e934$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $77f2a2759da6e934$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $77f2a2759da6e934$var$_defineProperty(obj, key, value) {
    key = $77f2a2759da6e934$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $77f2a2759da6e934$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $77f2a2759da6e934$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $77f2a2759da6e934$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $77f2a2759da6e934$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $77f2a2759da6e934$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $77f2a2759da6e934$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $77f2a2759da6e934$var$_toPropertyKey(arg) {
    var key = $77f2a2759da6e934$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $77f2a2759da6e934$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $3aNd6 = parcelRequire("3aNd6");
var $77f2a2759da6e934$var$Buffer = $3aNd6.Buffer;

var $1wVs5 = parcelRequire("1wVs5");
var $77f2a2759da6e934$var$inspect = $1wVs5.inspect;
var $77f2a2759da6e934$var$custom = $77f2a2759da6e934$var$inspect && $77f2a2759da6e934$var$inspect.custom || 'inspect';
function $77f2a2759da6e934$var$copyBuffer(src, target, offset) {
    $77f2a2759da6e934$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $77f2a2759da6e934$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $77f2a2759da6e934$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $77f2a2759da6e934$var$Buffer.alloc(0);
                var ret = $77f2a2759da6e934$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $77f2a2759da6e934$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $77f2a2759da6e934$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $77f2a2759da6e934$var$custom,
            value: function value(_, options) {
                return $77f2a2759da6e934$var$inspect(this, $77f2a2759da6e934$var$_objectSpread($77f2a2759da6e934$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("ezAkG", function(module, exports) {

var $6qd2L = parcelRequire("6qd2L");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $a9c0847d6e89179a$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $6qd2L.nextTick($a9c0847d6e89179a$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $6qd2L.nextTick($a9c0847d6e89179a$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $6qd2L.nextTick($a9c0847d6e89179a$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $6qd2L.nextTick($a9c0847d6e89179a$var$emitErrorAndCloseNT, _this, err);
            } else $6qd2L.nextTick($a9c0847d6e89179a$var$emitCloseNT, _this);
        } else if (cb) {
            $6qd2L.nextTick($a9c0847d6e89179a$var$emitCloseNT, _this);
            cb(err);
        } else $6qd2L.nextTick($a9c0847d6e89179a$var$emitCloseNT, _this);
    });
    return this;
}
function $a9c0847d6e89179a$var$emitErrorAndCloseNT(self, err) {
    $a9c0847d6e89179a$var$emitErrorNT(self, err);
    $a9c0847d6e89179a$var$emitCloseNT(self);
}
function $a9c0847d6e89179a$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $a9c0847d6e89179a$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $a9c0847d6e89179a$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $a9c0847d6e89179a$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $a9c0847d6e89179a$var$destroy,
    undestroy: $a9c0847d6e89179a$var$undestroy,
    errorOrDestroy: $a9c0847d6e89179a$var$errorOrDestroy
};

});

parcelRegister("gV8Xw", function(module, exports) {
'use strict';

var $c518eb45148d8890$var$ERR_INVALID_OPT_VALUE = (parcelRequire("h1zie")).codes.ERR_INVALID_OPT_VALUE;
function $c518eb45148d8890$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $c518eb45148d8890$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $c518eb45148d8890$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $c518eb45148d8890$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $c518eb45148d8890$var$getHighWaterMark
};

});
parcelRegister("h1zie", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $c64de81e4e97ea9e$export$e45cb6485273080e; }, function (v) { return $c64de81e4e97ea9e$export$e45cb6485273080e = v; });
var $c64de81e4e97ea9e$export$e45cb6485273080e;
'use strict';
function $c64de81e4e97ea9e$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $c64de81e4e97ea9e$var$codes = {};
function $c64de81e4e97ea9e$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $c64de81e4e97ea9e$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $c64de81e4e97ea9e$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $c64de81e4e97ea9e$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $c64de81e4e97ea9e$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $c64de81e4e97ea9e$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $c64de81e4e97ea9e$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$c64de81e4e97ea9e$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$c64de81e4e97ea9e$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $c64de81e4e97ea9e$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($c64de81e4e97ea9e$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($c64de81e4e97ea9e$var$oneOf(expected, 'type'));
    else {
        var type = $c64de81e4e97ea9e$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($c64de81e4e97ea9e$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$c64de81e4e97ea9e$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$c64de81e4e97ea9e$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$c64de81e4e97ea9e$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$c64de81e4e97ea9e$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$c64de81e4e97ea9e$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$c64de81e4e97ea9e$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$c64de81e4e97ea9e$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$c64de81e4e97ea9e$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$c64de81e4e97ea9e$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$c64de81e4e97ea9e$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$c64de81e4e97ea9e$export$e45cb6485273080e = $c64de81e4e97ea9e$var$codes;

});


parcelRegister("djKha", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $6qd2L = parcelRequire("6qd2L");
'use strict';
/*<replacement>*/ var $9b20f226c17442c8$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $9b20f226c17442c8$var$Duplex;

var $gI7KH = parcelRequire("gI7KH");

var $h57Ja = parcelRequire("h57Ja");

(parcelRequire("9M38k"))($9b20f226c17442c8$var$Duplex, $gI7KH);
// Allow the keys array to be GC'ed.
var $9b20f226c17442c8$var$keys = $9b20f226c17442c8$var$objectKeys($h57Ja.prototype);
for(var $9b20f226c17442c8$var$v = 0; $9b20f226c17442c8$var$v < $9b20f226c17442c8$var$keys.length; $9b20f226c17442c8$var$v++){
    var $9b20f226c17442c8$var$method = $9b20f226c17442c8$var$keys[$9b20f226c17442c8$var$v];
    if (!$9b20f226c17442c8$var$Duplex.prototype[$9b20f226c17442c8$var$method]) $9b20f226c17442c8$var$Duplex.prototype[$9b20f226c17442c8$var$method] = $h57Ja.prototype[$9b20f226c17442c8$var$method];
}
function $9b20f226c17442c8$var$Duplex(options) {
    if (!(this instanceof $9b20f226c17442c8$var$Duplex)) return new $9b20f226c17442c8$var$Duplex(options);
    $gI7KH.call(this, options);
    $h57Ja.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $9b20f226c17442c8$var$onend);
        }
    }
}
Object.defineProperty($9b20f226c17442c8$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($9b20f226c17442c8$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($9b20f226c17442c8$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $9b20f226c17442c8$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $6qd2L.nextTick($9b20f226c17442c8$var$onEndNT, this);
}
function $9b20f226c17442c8$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($9b20f226c17442c8$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("h57Ja", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $6qd2L = parcelRequire("6qd2L");
'use strict';
module.exports = $c6f8e5d76a81e4c1$var$Writable;
/* <replacement> */ function $c6f8e5d76a81e4c1$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $c6f8e5d76a81e4c1$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $c6f8e5d76a81e4c1$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $c6f8e5d76a81e4c1$var$Duplex;
/*</replacement>*/ $c6f8e5d76a81e4c1$var$Writable.WritableState = $c6f8e5d76a81e4c1$var$WritableState;

/*<replacement>*/ var $c6f8e5d76a81e4c1$var$internalUtil = {
    deprecate: (parcelRequire("3ZPxO"))
};

var $jIePF = parcelRequire("jIePF");

var $3aNd6 = parcelRequire("3aNd6");
var $c6f8e5d76a81e4c1$require$Buffer = $3aNd6.Buffer;
var $c6f8e5d76a81e4c1$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $c6f8e5d76a81e4c1$var$_uint8ArrayToBuffer(chunk) {
    return $c6f8e5d76a81e4c1$require$Buffer.from(chunk);
}
function $c6f8e5d76a81e4c1$var$_isUint8Array(obj) {
    return $c6f8e5d76a81e4c1$require$Buffer.isBuffer(obj) || obj instanceof $c6f8e5d76a81e4c1$var$OurUint8Array;
}

var $ezAkG = parcelRequire("ezAkG");

var $gV8Xw = parcelRequire("gV8Xw");
var $c6f8e5d76a81e4c1$var$getHighWaterMark = $gV8Xw.getHighWaterMark;

var $h1zie = parcelRequire("h1zie");
var $c6f8e5d76a81e4c1$require$_require$codes = $h1zie.codes;
var $c6f8e5d76a81e4c1$var$ERR_INVALID_ARG_TYPE = $c6f8e5d76a81e4c1$require$_require$codes.ERR_INVALID_ARG_TYPE, $c6f8e5d76a81e4c1$var$ERR_METHOD_NOT_IMPLEMENTED = $c6f8e5d76a81e4c1$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $c6f8e5d76a81e4c1$var$ERR_MULTIPLE_CALLBACK = $c6f8e5d76a81e4c1$require$_require$codes.ERR_MULTIPLE_CALLBACK, $c6f8e5d76a81e4c1$var$ERR_STREAM_CANNOT_PIPE = $c6f8e5d76a81e4c1$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $c6f8e5d76a81e4c1$var$ERR_STREAM_DESTROYED = $c6f8e5d76a81e4c1$require$_require$codes.ERR_STREAM_DESTROYED, $c6f8e5d76a81e4c1$var$ERR_STREAM_NULL_VALUES = $c6f8e5d76a81e4c1$require$_require$codes.ERR_STREAM_NULL_VALUES, $c6f8e5d76a81e4c1$var$ERR_STREAM_WRITE_AFTER_END = $c6f8e5d76a81e4c1$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $c6f8e5d76a81e4c1$var$ERR_UNKNOWN_ENCODING = $c6f8e5d76a81e4c1$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $c6f8e5d76a81e4c1$var$errorOrDestroy = $ezAkG.errorOrDestroy;

(parcelRequire("9M38k"))($c6f8e5d76a81e4c1$var$Writable, $jIePF);
function $c6f8e5d76a81e4c1$var$nop() {}

function $c6f8e5d76a81e4c1$var$WritableState(options, stream, isDuplex) {
    $c6f8e5d76a81e4c1$var$Duplex = $c6f8e5d76a81e4c1$var$Duplex || (parcelRequire("djKha"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $c6f8e5d76a81e4c1$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $c6f8e5d76a81e4c1$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $c6f8e5d76a81e4c1$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $c6f8e5d76a81e4c1$var$CorkedRequest(this);
}
$c6f8e5d76a81e4c1$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($c6f8e5d76a81e4c1$var$WritableState.prototype, 'buffer', {
            get: $c6f8e5d76a81e4c1$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $c6f8e5d76a81e4c1$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $c6f8e5d76a81e4c1$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($c6f8e5d76a81e4c1$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($c6f8e5d76a81e4c1$var$realHasInstance.call(this, object)) return true;
            if (this !== $c6f8e5d76a81e4c1$var$Writable) return false;
            return object && object._writableState instanceof $c6f8e5d76a81e4c1$var$WritableState;
        }
    });
} else $c6f8e5d76a81e4c1$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $c6f8e5d76a81e4c1$var$Writable(options) {
    $c6f8e5d76a81e4c1$var$Duplex = $c6f8e5d76a81e4c1$var$Duplex || (parcelRequire("djKha"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $c6f8e5d76a81e4c1$var$Duplex;
    if (!isDuplex && !$c6f8e5d76a81e4c1$var$realHasInstance.call($c6f8e5d76a81e4c1$var$Writable, this)) return new $c6f8e5d76a81e4c1$var$Writable(options);
    this._writableState = new $c6f8e5d76a81e4c1$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $jIePF.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$c6f8e5d76a81e4c1$var$Writable.prototype.pipe = function() {
    $c6f8e5d76a81e4c1$var$errorOrDestroy(this, new $c6f8e5d76a81e4c1$var$ERR_STREAM_CANNOT_PIPE());
};
function $c6f8e5d76a81e4c1$var$writeAfterEnd(stream, cb) {
    var er = new $c6f8e5d76a81e4c1$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $c6f8e5d76a81e4c1$var$errorOrDestroy(stream, er);
    $6qd2L.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $c6f8e5d76a81e4c1$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $c6f8e5d76a81e4c1$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $c6f8e5d76a81e4c1$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $c6f8e5d76a81e4c1$var$errorOrDestroy(stream, er);
        $6qd2L.nextTick(cb, er);
        return false;
    }
    return true;
}
$c6f8e5d76a81e4c1$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $c6f8e5d76a81e4c1$var$_isUint8Array(chunk);
    if (isBuf && !$c6f8e5d76a81e4c1$require$Buffer.isBuffer(chunk)) chunk = $c6f8e5d76a81e4c1$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $c6f8e5d76a81e4c1$var$nop;
    if (state.ending) $c6f8e5d76a81e4c1$var$writeAfterEnd(this, cb);
    else if (isBuf || $c6f8e5d76a81e4c1$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $c6f8e5d76a81e4c1$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$c6f8e5d76a81e4c1$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$c6f8e5d76a81e4c1$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $c6f8e5d76a81e4c1$var$clearBuffer(this, state);
    }
};
$c6f8e5d76a81e4c1$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $c6f8e5d76a81e4c1$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($c6f8e5d76a81e4c1$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $c6f8e5d76a81e4c1$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $c6f8e5d76a81e4c1$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($c6f8e5d76a81e4c1$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $c6f8e5d76a81e4c1$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $c6f8e5d76a81e4c1$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $c6f8e5d76a81e4c1$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $c6f8e5d76a81e4c1$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $c6f8e5d76a81e4c1$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $c6f8e5d76a81e4c1$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $6qd2L.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $6qd2L.nextTick($c6f8e5d76a81e4c1$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $c6f8e5d76a81e4c1$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $c6f8e5d76a81e4c1$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $c6f8e5d76a81e4c1$var$finishMaybe(stream, state);
    }
}
function $c6f8e5d76a81e4c1$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $c6f8e5d76a81e4c1$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $c6f8e5d76a81e4c1$var$ERR_MULTIPLE_CALLBACK();
    $c6f8e5d76a81e4c1$var$onwriteStateUpdate(state);
    if (er) $c6f8e5d76a81e4c1$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $c6f8e5d76a81e4c1$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $c6f8e5d76a81e4c1$var$clearBuffer(stream, state);
        if (sync) $6qd2L.nextTick($c6f8e5d76a81e4c1$var$afterWrite, stream, state, finished, cb);
        else $c6f8e5d76a81e4c1$var$afterWrite(stream, state, finished, cb);
    }
}
function $c6f8e5d76a81e4c1$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $c6f8e5d76a81e4c1$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $c6f8e5d76a81e4c1$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $c6f8e5d76a81e4c1$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $c6f8e5d76a81e4c1$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $c6f8e5d76a81e4c1$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $c6f8e5d76a81e4c1$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $c6f8e5d76a81e4c1$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$c6f8e5d76a81e4c1$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $c6f8e5d76a81e4c1$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$c6f8e5d76a81e4c1$var$Writable.prototype._writev = null;
$c6f8e5d76a81e4c1$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $c6f8e5d76a81e4c1$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($c6f8e5d76a81e4c1$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $c6f8e5d76a81e4c1$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $c6f8e5d76a81e4c1$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $c6f8e5d76a81e4c1$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $c6f8e5d76a81e4c1$var$finishMaybe(stream, state);
    });
}
function $c6f8e5d76a81e4c1$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $6qd2L.nextTick($c6f8e5d76a81e4c1$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $c6f8e5d76a81e4c1$var$finishMaybe(stream, state) {
    var need = $c6f8e5d76a81e4c1$var$needFinish(state);
    if (need) {
        $c6f8e5d76a81e4c1$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $c6f8e5d76a81e4c1$var$endWritable(stream, state, cb) {
    state.ending = true;
    $c6f8e5d76a81e4c1$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $6qd2L.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $c6f8e5d76a81e4c1$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($c6f8e5d76a81e4c1$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$c6f8e5d76a81e4c1$var$Writable.prototype.destroy = $ezAkG.destroy;
$c6f8e5d76a81e4c1$var$Writable.prototype._undestroy = $ezAkG.undestroy;
$c6f8e5d76a81e4c1$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("3ZPxO", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $2e8f0d3e23525401$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $2e8f0d3e23525401$var$deprecate(fn, msg) {
    if ($2e8f0d3e23525401$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($2e8f0d3e23525401$var$config('throwDeprecation')) throw new Error(msg);
            else if ($2e8f0d3e23525401$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $2e8f0d3e23525401$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("g6ehz", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $bb88490a7c25ef82$export$63a7aa211a91ed69; }, function (v) { return $bb88490a7c25ef82$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $bb88490a7c25ef82$export$63a7aa211a91ed69;
'use strict';

var $iyBuk = parcelRequire("iyBuk");
var $bb88490a7c25ef82$require$Buffer = $iyBuk.Buffer;
/*</replacement>*/ var $bb88490a7c25ef82$var$isEncoding = $bb88490a7c25ef82$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $bb88490a7c25ef82$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $bb88490a7c25ef82$var$normalizeEncoding(enc) {
    var nenc = $bb88490a7c25ef82$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($bb88490a7c25ef82$require$Buffer.isEncoding === $bb88490a7c25ef82$var$isEncoding || !$bb88490a7c25ef82$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$bb88490a7c25ef82$export$63a7aa211a91ed69 = $bb88490a7c25ef82$var$StringDecoder;
function $bb88490a7c25ef82$var$StringDecoder(encoding) {
    this.encoding = $bb88490a7c25ef82$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $bb88490a7c25ef82$var$utf16Text;
            this.end = $bb88490a7c25ef82$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $bb88490a7c25ef82$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $bb88490a7c25ef82$var$base64Text;
            this.end = $bb88490a7c25ef82$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $bb88490a7c25ef82$var$simpleWrite;
            this.end = $bb88490a7c25ef82$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $bb88490a7c25ef82$require$Buffer.allocUnsafe(nb);
}
$bb88490a7c25ef82$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$bb88490a7c25ef82$var$StringDecoder.prototype.end = $bb88490a7c25ef82$var$utf8End;
// Returns only complete characters in a Buffer
$bb88490a7c25ef82$var$StringDecoder.prototype.text = $bb88490a7c25ef82$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$bb88490a7c25ef82$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $bb88490a7c25ef82$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $bb88490a7c25ef82$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $bb88490a7c25ef82$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $bb88490a7c25ef82$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $bb88490a7c25ef82$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $bb88490a7c25ef82$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $bb88490a7c25ef82$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $bb88490a7c25ef82$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $bb88490a7c25ef82$var$utf8Text(buf, i) {
    var total = $bb88490a7c25ef82$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $bb88490a7c25ef82$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $bb88490a7c25ef82$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $bb88490a7c25ef82$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $bb88490a7c25ef82$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $bb88490a7c25ef82$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $bb88490a7c25ef82$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $bb88490a7c25ef82$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("iyBuk", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $3aNd6 = parcelRequire("3aNd6");
var $d8287b583eb4c9ec$var$Buffer = $3aNd6.Buffer;
// alternative to using Object.keys for old browsers
function $d8287b583eb4c9ec$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($d8287b583eb4c9ec$var$Buffer.from && $d8287b583eb4c9ec$var$Buffer.alloc && $d8287b583eb4c9ec$var$Buffer.allocUnsafe && $d8287b583eb4c9ec$var$Buffer.allocUnsafeSlow) module.exports = $3aNd6;
else {
    // Copy properties from require('buffer')
    $d8287b583eb4c9ec$var$copyProps($3aNd6, module.exports);
    module.exports.Buffer = $d8287b583eb4c9ec$var$SafeBuffer;
}
function $d8287b583eb4c9ec$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $d8287b583eb4c9ec$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$d8287b583eb4c9ec$var$copyProps($d8287b583eb4c9ec$var$Buffer, $d8287b583eb4c9ec$var$SafeBuffer);
$d8287b583eb4c9ec$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $d8287b583eb4c9ec$var$Buffer(arg, encodingOrOffset, length);
};
$d8287b583eb4c9ec$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $d8287b583eb4c9ec$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$d8287b583eb4c9ec$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $d8287b583eb4c9ec$var$Buffer(size);
};
$d8287b583eb4c9ec$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $3aNd6.SlowBuffer(size);
};

});


parcelRegister("5QtK4", function(module, exports) {

var $6qd2L = parcelRequire("6qd2L");
'use strict';
var $4418e13c55ec201d$var$_Object$setPrototypeO;
function $4418e13c55ec201d$var$_defineProperty(obj, key, value) {
    key = $4418e13c55ec201d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4418e13c55ec201d$var$_toPropertyKey(arg) {
    var key = $4418e13c55ec201d$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $4418e13c55ec201d$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $8flRm = parcelRequire("8flRm");
var $4418e13c55ec201d$var$kLastResolve = Symbol('lastResolve');
var $4418e13c55ec201d$var$kLastReject = Symbol('lastReject');
var $4418e13c55ec201d$var$kError = Symbol('error');
var $4418e13c55ec201d$var$kEnded = Symbol('ended');
var $4418e13c55ec201d$var$kLastPromise = Symbol('lastPromise');
var $4418e13c55ec201d$var$kHandlePromise = Symbol('handlePromise');
var $4418e13c55ec201d$var$kStream = Symbol('stream');
function $4418e13c55ec201d$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $4418e13c55ec201d$var$readAndResolve(iter) {
    var resolve = iter[$4418e13c55ec201d$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$4418e13c55ec201d$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$4418e13c55ec201d$var$kLastPromise] = null;
            iter[$4418e13c55ec201d$var$kLastResolve] = null;
            iter[$4418e13c55ec201d$var$kLastReject] = null;
            resolve($4418e13c55ec201d$var$createIterResult(data, false));
        }
    }
}
function $4418e13c55ec201d$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $6qd2L.nextTick($4418e13c55ec201d$var$readAndResolve, iter);
}
function $4418e13c55ec201d$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$4418e13c55ec201d$var$kEnded]) {
                resolve($4418e13c55ec201d$var$createIterResult(undefined, true));
                return;
            }
            iter[$4418e13c55ec201d$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $4418e13c55ec201d$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $4418e13c55ec201d$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($4418e13c55ec201d$var$_Object$setPrototypeO = {
    get stream () {
        return this[$4418e13c55ec201d$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$4418e13c55ec201d$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$4418e13c55ec201d$var$kEnded]) return Promise.resolve($4418e13c55ec201d$var$createIterResult(undefined, true));
        if (this[$4418e13c55ec201d$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $6qd2L.nextTick(function() {
                if (_this[$4418e13c55ec201d$var$kError]) reject(_this[$4418e13c55ec201d$var$kError]);
                else resolve($4418e13c55ec201d$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$4418e13c55ec201d$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($4418e13c55ec201d$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$4418e13c55ec201d$var$kStream].read();
            if (data !== null) return Promise.resolve($4418e13c55ec201d$var$createIterResult(data, false));
            promise = new Promise(this[$4418e13c55ec201d$var$kHandlePromise]);
        }
        this[$4418e13c55ec201d$var$kLastPromise] = promise;
        return promise;
    }
}, $4418e13c55ec201d$var$_defineProperty($4418e13c55ec201d$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $4418e13c55ec201d$var$_defineProperty($4418e13c55ec201d$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$4418e13c55ec201d$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($4418e13c55ec201d$var$createIterResult(undefined, true));
        });
    });
}), $4418e13c55ec201d$var$_Object$setPrototypeO), $4418e13c55ec201d$var$AsyncIteratorPrototype);
var $4418e13c55ec201d$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($4418e13c55ec201d$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $4418e13c55ec201d$var$_defineProperty(_Object$create, $4418e13c55ec201d$var$kStream, {
        value: stream,
        writable: true
    }), $4418e13c55ec201d$var$_defineProperty(_Object$create, $4418e13c55ec201d$var$kLastResolve, {
        value: null,
        writable: true
    }), $4418e13c55ec201d$var$_defineProperty(_Object$create, $4418e13c55ec201d$var$kLastReject, {
        value: null,
        writable: true
    }), $4418e13c55ec201d$var$_defineProperty(_Object$create, $4418e13c55ec201d$var$kError, {
        value: null,
        writable: true
    }), $4418e13c55ec201d$var$_defineProperty(_Object$create, $4418e13c55ec201d$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $4418e13c55ec201d$var$_defineProperty(_Object$create, $4418e13c55ec201d$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$4418e13c55ec201d$var$kStream].read();
            if (data) {
                iterator[$4418e13c55ec201d$var$kLastPromise] = null;
                iterator[$4418e13c55ec201d$var$kLastResolve] = null;
                iterator[$4418e13c55ec201d$var$kLastReject] = null;
                resolve($4418e13c55ec201d$var$createIterResult(data, false));
            } else {
                iterator[$4418e13c55ec201d$var$kLastResolve] = resolve;
                iterator[$4418e13c55ec201d$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$4418e13c55ec201d$var$kLastPromise] = null;
    $8flRm(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$4418e13c55ec201d$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$4418e13c55ec201d$var$kLastPromise] = null;
                iterator[$4418e13c55ec201d$var$kLastResolve] = null;
                iterator[$4418e13c55ec201d$var$kLastReject] = null;
                reject(err);
            }
            iterator[$4418e13c55ec201d$var$kError] = err;
            return;
        }
        var resolve = iterator[$4418e13c55ec201d$var$kLastResolve];
        if (resolve !== null) {
            iterator[$4418e13c55ec201d$var$kLastPromise] = null;
            iterator[$4418e13c55ec201d$var$kLastResolve] = null;
            iterator[$4418e13c55ec201d$var$kLastReject] = null;
            resolve($4418e13c55ec201d$var$createIterResult(undefined, true));
        }
        iterator[$4418e13c55ec201d$var$kEnded] = true;
    });
    stream.on('readable', $4418e13c55ec201d$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $4418e13c55ec201d$var$createReadableStreamAsyncIterator;

});
parcelRegister("8flRm", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $6010ae4e937bace6$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("h1zie")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $6010ae4e937bace6$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $6010ae4e937bace6$var$noop() {}
function $6010ae4e937bace6$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $6010ae4e937bace6$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $6010ae4e937bace6$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $6010ae4e937bace6$var$once(callback || $6010ae4e937bace6$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $6010ae4e937bace6$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $6010ae4e937bace6$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($6010ae4e937bace6$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $6010ae4e937bace6$var$eos;

});


parcelRegister("adKWq", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("jwvFo", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $e36991d36e78d746$var$Transform;

var $h1zie = parcelRequire("h1zie");
var $e36991d36e78d746$require$_require$codes = $h1zie.codes;
var $e36991d36e78d746$var$ERR_METHOD_NOT_IMPLEMENTED = $e36991d36e78d746$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $e36991d36e78d746$var$ERR_MULTIPLE_CALLBACK = $e36991d36e78d746$require$_require$codes.ERR_MULTIPLE_CALLBACK, $e36991d36e78d746$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $e36991d36e78d746$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $e36991d36e78d746$var$ERR_TRANSFORM_WITH_LENGTH_0 = $e36991d36e78d746$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $djKha = parcelRequire("djKha");

(parcelRequire("9M38k"))($e36991d36e78d746$var$Transform, $djKha);
function $e36991d36e78d746$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $e36991d36e78d746$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $e36991d36e78d746$var$Transform(options) {
    if (!(this instanceof $e36991d36e78d746$var$Transform)) return new $e36991d36e78d746$var$Transform(options);
    $djKha.call(this, options);
    this._transformState = {
        afterTransform: $e36991d36e78d746$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $e36991d36e78d746$var$prefinish);
}
function $e36991d36e78d746$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $e36991d36e78d746$var$done(_this, er, data);
    });
    else $e36991d36e78d746$var$done(this, null, null);
}
$e36991d36e78d746$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $djKha.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$e36991d36e78d746$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $e36991d36e78d746$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$e36991d36e78d746$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$e36991d36e78d746$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$e36991d36e78d746$var$Transform.prototype._destroy = function(err, cb) {
    $djKha.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $e36991d36e78d746$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $e36991d36e78d746$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $e36991d36e78d746$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("dPjGZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $a10f5046fdfbdcc7$var$PassThrough;

var $jwvFo = parcelRequire("jwvFo");

(parcelRequire("9M38k"))($a10f5046fdfbdcc7$var$PassThrough, $jwvFo);
function $a10f5046fdfbdcc7$var$PassThrough(options) {
    if (!(this instanceof $a10f5046fdfbdcc7$var$PassThrough)) return new $a10f5046fdfbdcc7$var$PassThrough(options);
    $jwvFo.call(this, options);
}
$a10f5046fdfbdcc7$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("1K5UB", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $144eac4f31149060$var$eos;
function $144eac4f31149060$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $h1zie = parcelRequire("h1zie");
var $144eac4f31149060$require$_require$codes = $h1zie.codes;
var $144eac4f31149060$var$ERR_MISSING_ARGS = $144eac4f31149060$require$_require$codes.ERR_MISSING_ARGS, $144eac4f31149060$var$ERR_STREAM_DESTROYED = $144eac4f31149060$require$_require$codes.ERR_STREAM_DESTROYED;
function $144eac4f31149060$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $144eac4f31149060$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $144eac4f31149060$var$destroyer(stream, reading, writing, callback) {
    callback = $144eac4f31149060$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($144eac4f31149060$var$eos === undefined) $144eac4f31149060$var$eos = (parcelRequire("8flRm"));
    $144eac4f31149060$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($144eac4f31149060$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $144eac4f31149060$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $144eac4f31149060$var$call(fn) {
    fn();
}
function $144eac4f31149060$var$pipe(from, to) {
    return from.pipe(to);
}
function $144eac4f31149060$var$popCallback(streams) {
    if (!streams.length) return $144eac4f31149060$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $144eac4f31149060$var$noop;
    return streams.pop();
}
function $144eac4f31149060$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $144eac4f31149060$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $144eac4f31149060$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $144eac4f31149060$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($144eac4f31149060$var$call);
            if (reading) return;
            destroys.forEach($144eac4f31149060$var$call);
            callback(error);
        });
    });
    return streams.reduce($144eac4f31149060$var$pipe);
}
module.exports = $144eac4f31149060$var$pipeline;

});


parcelRegister("1emjU", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $6qd2L = parcelRequire("6qd2L");
var $0e58699405760943$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $0e58699405760943$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$0e58699405760943$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($0e58699405760943$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($0e58699405760943$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($0e58699405760943$var$isNull(x) || !$0e58699405760943$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $0e58699405760943$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($6qd2L.throwDeprecation) throw new Error(msg);
            else if ($6qd2L.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $0e58699405760943$var$debugs = {};
var $0e58699405760943$var$debugEnvRegex = /^$/;
var $0e58699405760943$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$0e58699405760943$var$debugs[set]) {
        if ($0e58699405760943$var$debugEnvRegex.test(set)) {
            var pid = $6qd2L.pid;
            $0e58699405760943$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $0e58699405760943$var$debugs[set] = function() {};
    }
    return $0e58699405760943$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $0e58699405760943$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $0e58699405760943$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($0e58699405760943$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($0e58699405760943$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($0e58699405760943$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($0e58699405760943$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($0e58699405760943$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $0e58699405760943$var$stylizeWithColor;
    return $0e58699405760943$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $0e58699405760943$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$0e58699405760943$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$0e58699405760943$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $0e58699405760943$var$stylizeWithColor(str, styleType) {
    var style = $0e58699405760943$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $0e58699405760943$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $0e58699405760943$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $0e58699405760943$var$stylizeNoColor(str, styleType) {
    return str;
}
function $0e58699405760943$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $0e58699405760943$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $0e58699405760943$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$0e58699405760943$var$isString(ret)) ret = $0e58699405760943$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $0e58699405760943$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $0e58699405760943$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($0e58699405760943$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $0e58699405760943$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($0e58699405760943$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($0e58699405760943$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($0e58699405760943$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($0e58699405760943$var$isError(value)) return $0e58699405760943$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($0e58699405760943$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($0e58699405760943$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($0e58699405760943$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($0e58699405760943$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($0e58699405760943$var$isError(value)) base = ' ' + $0e58699405760943$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($0e58699405760943$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $0e58699405760943$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $0e58699405760943$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $0e58699405760943$var$reduceToSingleString(output, base, braces);
}
function $0e58699405760943$var$formatPrimitive(ctx, value) {
    if ($0e58699405760943$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($0e58699405760943$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($0e58699405760943$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($0e58699405760943$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($0e58699405760943$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $0e58699405760943$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $0e58699405760943$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($0e58699405760943$var$hasOwnProperty(value, String(i))) output.push($0e58699405760943$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($0e58699405760943$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $0e58699405760943$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$0e58699405760943$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($0e58699405760943$var$isNull(recurseTimes)) str = $0e58699405760943$var$formatValue(ctx, desc.value, null);
            else str = $0e58699405760943$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($0e58699405760943$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $0e58699405760943$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("4sa5r"));
function $0e58699405760943$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $0e58699405760943$var$isArray;
function $0e58699405760943$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $0e58699405760943$var$isBoolean;
function $0e58699405760943$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $0e58699405760943$var$isNull;
function $0e58699405760943$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $0e58699405760943$var$isNullOrUndefined;
function $0e58699405760943$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $0e58699405760943$var$isNumber;
function $0e58699405760943$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $0e58699405760943$var$isString;
function $0e58699405760943$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $0e58699405760943$var$isSymbol;
function $0e58699405760943$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $0e58699405760943$var$isUndefined;
function $0e58699405760943$var$isRegExp(re) {
    return $0e58699405760943$var$isObject(re) && $0e58699405760943$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $0e58699405760943$var$isRegExp;
module.exports.types.isRegExp = $0e58699405760943$var$isRegExp;
function $0e58699405760943$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $0e58699405760943$var$isObject;
function $0e58699405760943$var$isDate(d) {
    return $0e58699405760943$var$isObject(d) && $0e58699405760943$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $0e58699405760943$var$isDate;
module.exports.types.isDate = $0e58699405760943$var$isDate;
function $0e58699405760943$var$isError(e) {
    return $0e58699405760943$var$isObject(e) && ($0e58699405760943$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $0e58699405760943$var$isError;
module.exports.types.isNativeError = $0e58699405760943$var$isError;
function $0e58699405760943$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $0e58699405760943$var$isFunction;
function $0e58699405760943$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $0e58699405760943$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("7Tl5t"));
function $0e58699405760943$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $0e58699405760943$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $0e58699405760943$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $0e58699405760943$var$timestamp() {
    var d = new Date();
    var time = [
        $0e58699405760943$var$pad(d.getHours()),
        $0e58699405760943$var$pad(d.getMinutes()),
        $0e58699405760943$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $0e58699405760943$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $0e58699405760943$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("9M38k"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$0e58699405760943$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $0e58699405760943$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $0e58699405760943$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($0e58699405760943$var$kCustomPromisifiedSymbol && original[$0e58699405760943$var$kCustomPromisifiedSymbol]) {
        var fn = original[$0e58699405760943$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $0e58699405760943$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($0e58699405760943$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $0e58699405760943$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $0e58699405760943$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $0e58699405760943$var$kCustomPromisifiedSymbol;
function $0e58699405760943$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $0e58699405760943$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $6qd2L.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $6qd2L.nextTick($0e58699405760943$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $0e58699405760943$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $0e58699405760943$var$callbackify;

});
parcelRegister("4sa5r", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $25lfa = parcelRequire("25lfa");

var $jaL9i = parcelRequire("jaL9i");

var $bw8Od = parcelRequire("bw8Od");

var $4fFEF = parcelRequire("4fFEF");
function $33e199f976d0aeaa$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $33e199f976d0aeaa$var$BigIntSupported = typeof BigInt !== 'undefined';
var $33e199f976d0aeaa$var$SymbolSupported = typeof Symbol !== 'undefined';
var $33e199f976d0aeaa$var$ObjectToString = $33e199f976d0aeaa$var$uncurryThis(Object.prototype.toString);
var $33e199f976d0aeaa$var$numberValue = $33e199f976d0aeaa$var$uncurryThis(Number.prototype.valueOf);
var $33e199f976d0aeaa$var$stringValue = $33e199f976d0aeaa$var$uncurryThis(String.prototype.valueOf);
var $33e199f976d0aeaa$var$booleanValue = $33e199f976d0aeaa$var$uncurryThis(Boolean.prototype.valueOf);
if ($33e199f976d0aeaa$var$BigIntSupported) var $33e199f976d0aeaa$var$bigIntValue = $33e199f976d0aeaa$var$uncurryThis(BigInt.prototype.valueOf);
if ($33e199f976d0aeaa$var$SymbolSupported) var $33e199f976d0aeaa$var$symbolValue = $33e199f976d0aeaa$var$uncurryThis(Symbol.prototype.valueOf);
function $33e199f976d0aeaa$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $25lfa;
module.exports.isGeneratorFunction = $jaL9i;
module.exports.isTypedArray = $4fFEF;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $33e199f976d0aeaa$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $33e199f976d0aeaa$var$isPromise;
function $33e199f976d0aeaa$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $4fFEF(value) || $33e199f976d0aeaa$var$isDataView(value);
}
module.exports.isArrayBufferView = $33e199f976d0aeaa$var$isArrayBufferView;
function $33e199f976d0aeaa$var$isUint8Array(value) {
    return $bw8Od(value) === 'Uint8Array';
}
module.exports.isUint8Array = $33e199f976d0aeaa$var$isUint8Array;
function $33e199f976d0aeaa$var$isUint8ClampedArray(value) {
    return $bw8Od(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $33e199f976d0aeaa$var$isUint8ClampedArray;
function $33e199f976d0aeaa$var$isUint16Array(value) {
    return $bw8Od(value) === 'Uint16Array';
}
module.exports.isUint16Array = $33e199f976d0aeaa$var$isUint16Array;
function $33e199f976d0aeaa$var$isUint32Array(value) {
    return $bw8Od(value) === 'Uint32Array';
}
module.exports.isUint32Array = $33e199f976d0aeaa$var$isUint32Array;
function $33e199f976d0aeaa$var$isInt8Array(value) {
    return $bw8Od(value) === 'Int8Array';
}
module.exports.isInt8Array = $33e199f976d0aeaa$var$isInt8Array;
function $33e199f976d0aeaa$var$isInt16Array(value) {
    return $bw8Od(value) === 'Int16Array';
}
module.exports.isInt16Array = $33e199f976d0aeaa$var$isInt16Array;
function $33e199f976d0aeaa$var$isInt32Array(value) {
    return $bw8Od(value) === 'Int32Array';
}
module.exports.isInt32Array = $33e199f976d0aeaa$var$isInt32Array;
function $33e199f976d0aeaa$var$isFloat32Array(value) {
    return $bw8Od(value) === 'Float32Array';
}
module.exports.isFloat32Array = $33e199f976d0aeaa$var$isFloat32Array;
function $33e199f976d0aeaa$var$isFloat64Array(value) {
    return $bw8Od(value) === 'Float64Array';
}
module.exports.isFloat64Array = $33e199f976d0aeaa$var$isFloat64Array;
function $33e199f976d0aeaa$var$isBigInt64Array(value) {
    return $bw8Od(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $33e199f976d0aeaa$var$isBigInt64Array;
function $33e199f976d0aeaa$var$isBigUint64Array(value) {
    return $bw8Od(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $33e199f976d0aeaa$var$isBigUint64Array;
function $33e199f976d0aeaa$var$isMapToString(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === '[object Map]';
}
$33e199f976d0aeaa$var$isMapToString.working = typeof Map !== 'undefined' && $33e199f976d0aeaa$var$isMapToString(new Map());
function $33e199f976d0aeaa$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $33e199f976d0aeaa$var$isMapToString.working ? $33e199f976d0aeaa$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $33e199f976d0aeaa$var$isMap;
function $33e199f976d0aeaa$var$isSetToString(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === '[object Set]';
}
$33e199f976d0aeaa$var$isSetToString.working = typeof Set !== 'undefined' && $33e199f976d0aeaa$var$isSetToString(new Set());
function $33e199f976d0aeaa$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $33e199f976d0aeaa$var$isSetToString.working ? $33e199f976d0aeaa$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $33e199f976d0aeaa$var$isSet;
function $33e199f976d0aeaa$var$isWeakMapToString(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === '[object WeakMap]';
}
$33e199f976d0aeaa$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $33e199f976d0aeaa$var$isWeakMapToString(new WeakMap());
function $33e199f976d0aeaa$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $33e199f976d0aeaa$var$isWeakMapToString.working ? $33e199f976d0aeaa$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $33e199f976d0aeaa$var$isWeakMap;
function $33e199f976d0aeaa$var$isWeakSetToString(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === '[object WeakSet]';
}
$33e199f976d0aeaa$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $33e199f976d0aeaa$var$isWeakSetToString(new WeakSet());
function $33e199f976d0aeaa$var$isWeakSet(value) {
    return $33e199f976d0aeaa$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $33e199f976d0aeaa$var$isWeakSet;
function $33e199f976d0aeaa$var$isArrayBufferToString(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$33e199f976d0aeaa$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $33e199f976d0aeaa$var$isArrayBufferToString(new ArrayBuffer());
function $33e199f976d0aeaa$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $33e199f976d0aeaa$var$isArrayBufferToString.working ? $33e199f976d0aeaa$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $33e199f976d0aeaa$var$isArrayBuffer;
function $33e199f976d0aeaa$var$isDataViewToString(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === '[object DataView]';
}
$33e199f976d0aeaa$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $33e199f976d0aeaa$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $33e199f976d0aeaa$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $33e199f976d0aeaa$var$isDataViewToString.working ? $33e199f976d0aeaa$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $33e199f976d0aeaa$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $33e199f976d0aeaa$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $33e199f976d0aeaa$var$isSharedArrayBufferToString(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $33e199f976d0aeaa$var$isSharedArrayBuffer(value) {
    if (typeof $33e199f976d0aeaa$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $33e199f976d0aeaa$var$isSharedArrayBufferToString.working === 'undefined') $33e199f976d0aeaa$var$isSharedArrayBufferToString.working = $33e199f976d0aeaa$var$isSharedArrayBufferToString(new $33e199f976d0aeaa$var$SharedArrayBufferCopy());
    return $33e199f976d0aeaa$var$isSharedArrayBufferToString.working ? $33e199f976d0aeaa$var$isSharedArrayBufferToString(value) : value instanceof $33e199f976d0aeaa$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $33e199f976d0aeaa$var$isSharedArrayBuffer;
function $33e199f976d0aeaa$var$isAsyncFunction(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $33e199f976d0aeaa$var$isAsyncFunction;
function $33e199f976d0aeaa$var$isMapIterator(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $33e199f976d0aeaa$var$isMapIterator;
function $33e199f976d0aeaa$var$isSetIterator(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $33e199f976d0aeaa$var$isSetIterator;
function $33e199f976d0aeaa$var$isGeneratorObject(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $33e199f976d0aeaa$var$isGeneratorObject;
function $33e199f976d0aeaa$var$isWebAssemblyCompiledModule(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $33e199f976d0aeaa$var$isWebAssemblyCompiledModule;
function $33e199f976d0aeaa$var$isNumberObject(value) {
    return $33e199f976d0aeaa$var$checkBoxedPrimitive(value, $33e199f976d0aeaa$var$numberValue);
}
module.exports.isNumberObject = $33e199f976d0aeaa$var$isNumberObject;
function $33e199f976d0aeaa$var$isStringObject(value) {
    return $33e199f976d0aeaa$var$checkBoxedPrimitive(value, $33e199f976d0aeaa$var$stringValue);
}
module.exports.isStringObject = $33e199f976d0aeaa$var$isStringObject;
function $33e199f976d0aeaa$var$isBooleanObject(value) {
    return $33e199f976d0aeaa$var$checkBoxedPrimitive(value, $33e199f976d0aeaa$var$booleanValue);
}
module.exports.isBooleanObject = $33e199f976d0aeaa$var$isBooleanObject;
function $33e199f976d0aeaa$var$isBigIntObject(value) {
    return $33e199f976d0aeaa$var$BigIntSupported && $33e199f976d0aeaa$var$checkBoxedPrimitive(value, $33e199f976d0aeaa$var$bigIntValue);
}
module.exports.isBigIntObject = $33e199f976d0aeaa$var$isBigIntObject;
function $33e199f976d0aeaa$var$isSymbolObject(value) {
    return $33e199f976d0aeaa$var$SymbolSupported && $33e199f976d0aeaa$var$checkBoxedPrimitive(value, $33e199f976d0aeaa$var$symbolValue);
}
module.exports.isSymbolObject = $33e199f976d0aeaa$var$isSymbolObject;
function $33e199f976d0aeaa$var$isBoxedPrimitive(value) {
    return $33e199f976d0aeaa$var$isNumberObject(value) || $33e199f976d0aeaa$var$isStringObject(value) || $33e199f976d0aeaa$var$isBooleanObject(value) || $33e199f976d0aeaa$var$isBigIntObject(value) || $33e199f976d0aeaa$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $33e199f976d0aeaa$var$isBoxedPrimitive;
function $33e199f976d0aeaa$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($33e199f976d0aeaa$var$isArrayBuffer(value) || $33e199f976d0aeaa$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $33e199f976d0aeaa$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("25lfa", function(module, exports) {
'use strict';

var $184c86f118ab5653$var$hasToStringTag = (parcelRequire("4Yp5o"))();

var $gXmQa = parcelRequire("gXmQa");
var $184c86f118ab5653$var$$toString = $gXmQa('Object.prototype.toString');
/** @type {import('.')} */ var $184c86f118ab5653$var$isStandardArguments = function isArguments(value) {
    if ($184c86f118ab5653$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $184c86f118ab5653$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $184c86f118ab5653$var$isLegacyArguments = function isArguments(value) {
    if ($184c86f118ab5653$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $184c86f118ab5653$var$$toString(value) !== '[object Array]' && 'callee' in value && $184c86f118ab5653$var$$toString(value.callee) === '[object Function]';
};
var $184c86f118ab5653$var$supportsStandardArguments = function() {
    return $184c86f118ab5653$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$184c86f118ab5653$var$isStandardArguments.isLegacyArguments = $184c86f118ab5653$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $184c86f118ab5653$var$supportsStandardArguments ? $184c86f118ab5653$var$isStandardArguments : $184c86f118ab5653$var$isLegacyArguments;

});
parcelRegister("4Yp5o", function(module, exports) {
'use strict';

var $e6ibc = parcelRequire("e6ibc");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $e6ibc() && !!Symbol.toStringTag;
};

});
parcelRegister("e6ibc", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("gXmQa", function(module, exports) {
'use strict';

var $5XoKB = parcelRequire("5XoKB");

var $9XTQG = parcelRequire("9XTQG");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $c583dfac6bdc47c4$var$$indexOf = $9XTQG([
    $5XoKB('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $5XoKB(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $c583dfac6bdc47c4$var$$indexOf(name, '.prototype.') > -1) return $9XTQG(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("5XoKB", function(module, exports) {
'use strict';
var $4565a9698af8efed$var$undefined1;

var $5koM0 = parcelRequire("5koM0");

var $f6Akk = parcelRequire("f6Akk");

var $fpQns = parcelRequire("fpQns");

var $ag3DL = parcelRequire("ag3DL");

var $eFn1R = parcelRequire("eFn1R");

var $6TBlj = parcelRequire("6TBlj");

var $OG0Ue = parcelRequire("OG0Ue");

var $fK7Rv = parcelRequire("fK7Rv");

var $1r8xK = parcelRequire("1r8xK");

var $3U084 = parcelRequire("3U084");

var $4smBG = parcelRequire("4smBG");

var $kXYnx = parcelRequire("kXYnx");

var $5ZVK2 = parcelRequire("5ZVK2");

var $2gwEj = parcelRequire("2gwEj");

var $7JwSw = parcelRequire("7JwSw");
var $4565a9698af8efed$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $4565a9698af8efed$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $4565a9698af8efed$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $eJu2D = parcelRequire("eJu2D");

var $7dXGV = parcelRequire("7dXGV");
var $4565a9698af8efed$var$throwTypeError = function() {
    throw new $OG0Ue();
};
var $4565a9698af8efed$var$ThrowTypeError = $eJu2D ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $4565a9698af8efed$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $eJu2D(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $4565a9698af8efed$var$throwTypeError;
        }
    }
}() : $4565a9698af8efed$var$throwTypeError;

var $4565a9698af8efed$var$hasSymbols = (parcelRequire("1zrnp"))();

var $l6OwD = parcelRequire("l6OwD");

var $ihBW5 = parcelRequire("ihBW5");

var $9BidC = parcelRequire("9BidC");

var $irkS1 = parcelRequire("irkS1");

var $dwYm7 = parcelRequire("dwYm7");
var $4565a9698af8efed$var$needsEval = {};
var $4565a9698af8efed$var$TypedArray = typeof Uint8Array === 'undefined' || !$l6OwD ? undefined : $l6OwD(Uint8Array);
var $4565a9698af8efed$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $4565a9698af8efed$var$hasSymbols && $l6OwD ? $l6OwD([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $4565a9698af8efed$var$needsEval,
    '%AsyncGenerator%': $4565a9698af8efed$var$needsEval,
    '%AsyncGeneratorFunction%': $4565a9698af8efed$var$needsEval,
    '%AsyncIteratorPrototype%': $4565a9698af8efed$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $f6Akk,
    '%eval%': eval,
    '%EvalError%': $fpQns,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $4565a9698af8efed$var$$Function,
    '%GeneratorFunction%': $4565a9698af8efed$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $4565a9698af8efed$var$hasSymbols && $l6OwD ? $l6OwD($l6OwD([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$4565a9698af8efed$var$hasSymbols || !$l6OwD ? undefined : $l6OwD(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $5koM0,
    '%Object.getOwnPropertyDescriptor%': $eJu2D,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $ag3DL,
    '%ReferenceError%': $eFn1R,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$4565a9698af8efed$var$hasSymbols || !$l6OwD ? undefined : $l6OwD(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $4565a9698af8efed$var$hasSymbols && $l6OwD ? $l6OwD(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $4565a9698af8efed$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $6TBlj,
    '%ThrowTypeError%': $4565a9698af8efed$var$ThrowTypeError,
    '%TypedArray%': $4565a9698af8efed$var$TypedArray,
    '%TypeError%': $OG0Ue,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $fK7Rv,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $dwYm7,
    '%Function.prototype.apply%': $irkS1,
    '%Object.defineProperty%': $7dXGV,
    '%Object.getPrototypeOf%': $ihBW5,
    '%Math.abs%': $1r8xK,
    '%Math.floor%': $3U084,
    '%Math.max%': $4smBG,
    '%Math.min%': $kXYnx,
    '%Math.pow%': $5ZVK2,
    '%Math.round%': $2gwEj,
    '%Math.sign%': $7JwSw,
    '%Reflect.getPrototypeOf%': $9BidC
};
if ($l6OwD) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $4565a9698af8efed$var$errorProto = $l6OwD($l6OwD(e));
    $4565a9698af8efed$var$INTRINSICS['%Error.prototype%'] = $4565a9698af8efed$var$errorProto;
}
var $4565a9698af8efed$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $4565a9698af8efed$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $4565a9698af8efed$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $4565a9698af8efed$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $l6OwD) value = $l6OwD(gen.prototype);
    }
    $4565a9698af8efed$var$INTRINSICS[name] = value;
    return value;
};
var $4565a9698af8efed$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $dY0J9 = parcelRequire("dY0J9");

var $l8o8U = parcelRequire("l8o8U");
var $4565a9698af8efed$var$$concat = $dY0J9.call($dwYm7, Array.prototype.concat);
var $4565a9698af8efed$var$$spliceApply = $dY0J9.call($irkS1, Array.prototype.splice);
var $4565a9698af8efed$var$$replace = $dY0J9.call($dwYm7, String.prototype.replace);
var $4565a9698af8efed$var$$strSlice = $dY0J9.call($dwYm7, String.prototype.slice);
var $4565a9698af8efed$var$$exec = $dY0J9.call($dwYm7, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $4565a9698af8efed$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $4565a9698af8efed$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $4565a9698af8efed$var$stringToPath = function stringToPath(string) {
    var first = $4565a9698af8efed$var$$strSlice(string, 0, 1);
    var last = $4565a9698af8efed$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $6TBlj('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $6TBlj('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $4565a9698af8efed$var$$replace(string, $4565a9698af8efed$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $4565a9698af8efed$var$$replace(subString, $4565a9698af8efed$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $4565a9698af8efed$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($l8o8U($4565a9698af8efed$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $4565a9698af8efed$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($l8o8U($4565a9698af8efed$var$INTRINSICS, intrinsicName)) {
        var value = $4565a9698af8efed$var$INTRINSICS[intrinsicName];
        if (value === $4565a9698af8efed$var$needsEval) value = $4565a9698af8efed$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $OG0Ue('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $6TBlj('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $OG0Ue('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $OG0Ue('"allowMissing" argument must be a boolean');
    if ($4565a9698af8efed$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $6TBlj('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $4565a9698af8efed$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $4565a9698af8efed$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $4565a9698af8efed$var$$spliceApply(parts, $4565a9698af8efed$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $4565a9698af8efed$var$$strSlice(part, 0, 1);
        var last = $4565a9698af8efed$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $6TBlj('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($l8o8U($4565a9698af8efed$var$INTRINSICS, intrinsicRealName)) value = $4565a9698af8efed$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $OG0Ue('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($eJu2D && i + 1 >= parts.length) {
                var desc = $eJu2D(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $l8o8U(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $4565a9698af8efed$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("5koM0", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("f6Akk", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("fpQns", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("ag3DL", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("eFn1R", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("6TBlj", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("OG0Ue", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("fK7Rv", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("1r8xK", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("3U084", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("4smBG", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("kXYnx", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("5ZVK2", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("2gwEj", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("7JwSw", function(module, exports) {
'use strict';

var $cLte6 = parcelRequire("cLte6");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($cLte6(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("cLte6", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("eJu2D", function(module, exports) {
'use strict';

var $j4KH7 = parcelRequire("j4KH7");
var $ab9c92447e4858f1$require$$gOPD = $j4KH7;
if ($ab9c92447e4858f1$require$$gOPD) try {
    $ab9c92447e4858f1$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $ab9c92447e4858f1$require$$gOPD = null;
}
module.exports = $ab9c92447e4858f1$require$$gOPD;

});
parcelRegister("j4KH7", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("7dXGV", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $54280cbbb5bff3df$var$$defineProperty = Object.defineProperty || false;
if ($54280cbbb5bff3df$var$$defineProperty) try {
    $54280cbbb5bff3df$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $54280cbbb5bff3df$var$$defineProperty = false;
}
module.exports = $54280cbbb5bff3df$var$$defineProperty;

});

parcelRegister("1zrnp", function(module, exports) {
'use strict';
var $124e4bbb3f3c510d$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $e6ibc = parcelRequire("e6ibc");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $124e4bbb3f3c510d$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $124e4bbb3f3c510d$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $e6ibc();
};

});

parcelRegister("l6OwD", function(module, exports) {
'use strict';

var $9BidC = parcelRequire("9BidC");

var $ihBW5 = parcelRequire("ihBW5");

var $wFGxt = parcelRequire("wFGxt");
/** @type {import('.')} */ module.exports = $9BidC ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $9BidC(O);
} : $ihBW5 ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $ihBW5(O);
} : $wFGxt ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $wFGxt(O);
} : null;

});
parcelRegister("9BidC", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("ihBW5", function(module, exports) {
'use strict';

var $5koM0 = parcelRequire("5koM0");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $5koM0.getPrototypeOf || null;

});

parcelRegister("wFGxt", function(module, exports) {
'use strict';

var $9XTQG = parcelRequire("9XTQG");

var $eJu2D = parcelRequire("eJu2D");
var $0623531189ee5241$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $0623531189ee5241$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $0623531189ee5241$var$desc = !!$0623531189ee5241$var$hasProtoAccessor && $eJu2D && $eJu2D(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $0623531189ee5241$var$$Object = Object;
var $0623531189ee5241$var$$getPrototypeOf = $0623531189ee5241$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $0623531189ee5241$var$desc && typeof $0623531189ee5241$var$desc.get === 'function' ? $9XTQG([
    $0623531189ee5241$var$desc.get
]) : typeof $0623531189ee5241$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $0623531189ee5241$var$$getPrototypeOf(value == null ? value : $0623531189ee5241$var$$Object(value));
} : false;

});
parcelRegister("9XTQG", function(module, exports) {
'use strict';

var $dY0J9 = parcelRequire("dY0J9");

var $OG0Ue = parcelRequire("OG0Ue");

var $dwYm7 = parcelRequire("dwYm7");

var $irSVr = parcelRequire("irSVr");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $OG0Ue('a function is required');
    return $irSVr($dY0J9, $dwYm7, args);
};

});
parcelRegister("dY0J9", function(module, exports) {
'use strict';

var $a9gvA = parcelRequire("a9gvA");
module.exports = Function.prototype.bind || $a9gvA;

});
parcelRegister("a9gvA", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $76378ce80e32fd91$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $76378ce80e32fd91$var$toStr = Object.prototype.toString;
var $76378ce80e32fd91$var$max = Math.max;
var $76378ce80e32fd91$var$funcType = '[object Function]';
var $76378ce80e32fd91$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $76378ce80e32fd91$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $76378ce80e32fd91$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $76378ce80e32fd91$var$toStr.apply(target) !== $76378ce80e32fd91$var$funcType) throw new TypeError($76378ce80e32fd91$var$ERROR_MESSAGE + target);
    var args = $76378ce80e32fd91$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $76378ce80e32fd91$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $76378ce80e32fd91$var$concatty(args, arguments));
    };
    var boundLength = $76378ce80e32fd91$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $76378ce80e32fd91$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("dwYm7", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("irSVr", function(module, exports) {
'use strict';

var $dY0J9 = parcelRequire("dY0J9");

var $irkS1 = parcelRequire("irkS1");

var $dwYm7 = parcelRequire("dwYm7");

var $h70Yl = parcelRequire("h70Yl");
/** @type {import('./actualApply')} */ module.exports = $h70Yl || $dY0J9.call($dwYm7, $irkS1);

});
parcelRegister("irkS1", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("h70Yl", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("l8o8U", function(module, exports) {
'use strict';
var $f62d1296f319593b$var$call = Function.prototype.call;
var $f62d1296f319593b$var$$hasOwn = Object.prototype.hasOwnProperty;

var $dY0J9 = parcelRequire("dY0J9");
/** @type {import('.')} */ module.exports = $dY0J9.call($f62d1296f319593b$var$call, $f62d1296f319593b$var$$hasOwn);

});




parcelRegister("jaL9i", function(module, exports) {
'use strict';

var $gXmQa = parcelRequire("gXmQa");

var $6z7jv = parcelRequire("6z7jv");
var $df53864bd77edbcb$var$isFnRegex = $6z7jv(/^\s*(?:function)?\*/);

var $df53864bd77edbcb$var$hasToStringTag = (parcelRequire("4Yp5o"))();

var $l6OwD = parcelRequire("l6OwD");
var $df53864bd77edbcb$var$toStr = $gXmQa('Object.prototype.toString');
var $df53864bd77edbcb$var$fnToStr = $gXmQa('Function.prototype.toString');

var $iDahE = parcelRequire("iDahE");
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($df53864bd77edbcb$var$isFnRegex($df53864bd77edbcb$var$fnToStr(fn))) return true;
    if (!$df53864bd77edbcb$var$hasToStringTag) {
        var str = $df53864bd77edbcb$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$l6OwD) return false;
    var GeneratorFunction = $iDahE();
    return GeneratorFunction && $l6OwD(fn) === GeneratorFunction.prototype;
};

});
parcelRegister("6z7jv", function(module, exports) {
'use strict';

var $gXmQa = parcelRequire("gXmQa");

var $kaV19 = parcelRequire("kaV19");
var $4c7baf4a6b030cf8$var$$exec = $gXmQa('RegExp.prototype.exec');

var $OG0Ue = parcelRequire("OG0Ue");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$kaV19(regex)) throw new $OG0Ue('`regex` must be a RegExp');
    return function test(s) {
        return $4c7baf4a6b030cf8$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("kaV19", function(module, exports) {
'use strict';

var $gXmQa = parcelRequire("gXmQa");

var $eb00f84c977c845b$var$hasToStringTag = (parcelRequire("4Yp5o"))();

var $l8o8U = parcelRequire("l8o8U");

var $eJu2D = parcelRequire("eJu2D");
/** @type {import('.')} */ var $eb00f84c977c845b$var$fn;
if ($eb00f84c977c845b$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $eb00f84c977c845b$var$$exec = $gXmQa('RegExp.prototype.exec');
    /** @type {object} */ var $eb00f84c977c845b$var$isRegexMarker = {};
    var $eb00f84c977c845b$var$throwRegexMarker = function() {
        throw $eb00f84c977c845b$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $eb00f84c977c845b$var$badStringifier = {
        toString: $eb00f84c977c845b$var$throwRegexMarker,
        valueOf: $eb00f84c977c845b$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $eb00f84c977c845b$var$badStringifier[Symbol.toPrimitive] = $eb00f84c977c845b$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $eb00f84c977c845b$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $eJu2D(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $l8o8U(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $eb00f84c977c845b$var$$exec(value, /** @type {unknown} */ $eb00f84c977c845b$var$badStringifier);
        } catch (e) {
            return e === $eb00f84c977c845b$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $eb00f84c977c845b$var$$toString = $gXmQa('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $eb00f84c977c845b$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $eb00f84c977c845b$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $eb00f84c977c845b$var$$toString(value) === $eb00f84c977c845b$var$regexClass;
    };
}
module.exports = $eb00f84c977c845b$var$fn;

});


parcelRegister("iDahE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f4da39bed92afa61$export$2e2bcd8739ae039; });

var $lsQRz = parcelRequire("lsQRz");
var /** @type {import('./index.d.mts').default} */ $f4da39bed92afa61$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($lsQRz)));

});
parcelRegister("lsQRz", function(module, exports) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const $fa0538019f24f36f$var$cached = /** @type {GeneratorFunctionConstructor} */ (function*() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>$fa0538019f24f36f$var$cached;

});



parcelRegister("bw8Od", function(module, exports) {
'use strict';

var $9Y285 = parcelRequire("9Y285");

var $lsTls = parcelRequire("lsTls");

var $jS9v3 = parcelRequire("jS9v3");

var $gXmQa = parcelRequire("gXmQa");

var $eJu2D = parcelRequire("eJu2D");

var $l6OwD = parcelRequire("l6OwD");
var $862984235fa1b97b$var$$toString = $gXmQa('Object.prototype.toString');

var $862984235fa1b97b$var$hasToStringTag = (parcelRequire("4Yp5o"))();
var $862984235fa1b97b$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $862984235fa1b97b$var$typedArrays = $lsTls();
var $862984235fa1b97b$var$$slice = $gXmQa('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $862984235fa1b97b$var$$indexOf = $gXmQa('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $862984235fa1b97b$var$cache = {
    __proto__: null
};
if ($862984235fa1b97b$var$hasToStringTag && $eJu2D && $l6OwD) $9Y285($862984235fa1b97b$var$typedArrays, function(typedArray) {
    var arr = new $862984235fa1b97b$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $l6OwD) {
        var proto = $l6OwD(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $eJu2D(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $l6OwD(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $eJu2D(superProto, Symbol.toStringTag);
        }
        if (descriptor && descriptor.get) {
            var bound = $jS9v3(descriptor.get);
            $862984235fa1b97b$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
        }
    }
});
else $9Y285($862984235fa1b97b$var$typedArrays, function(typedArray) {
    var arr = new $862984235fa1b97b$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) {
        var bound = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
        $jS9v3(fn);
        $862984235fa1b97b$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
    }
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $862984235fa1b97b$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $9Y285(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $862984235fa1b97b$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $862984235fa1b97b$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $862984235fa1b97b$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $9Y285(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $862984235fa1b97b$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $862984235fa1b97b$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$862984235fa1b97b$var$hasToStringTag) {
        /** @type {string} */ var tag = $862984235fa1b97b$var$$slice($862984235fa1b97b$var$$toString(value), 8, -1);
        if ($862984235fa1b97b$var$$indexOf($862984235fa1b97b$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $862984235fa1b97b$var$trySlices(value);
    }
    if (!$eJu2D) return null;
     // unknown engine
    return $862984235fa1b97b$var$tryTypedArrays(value);
};

});
parcelRegister("9Y285", function(module, exports) {
'use strict';

var $3Jutl = parcelRequire("3Jutl");
var $741b5e87f77901ca$var$toStr = Object.prototype.toString;
var $741b5e87f77901ca$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $741b5e87f77901ca$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($741b5e87f77901ca$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $741b5e87f77901ca$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $741b5e87f77901ca$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($741b5e87f77901ca$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $741b5e87f77901ca$var$isArray(x) {
    return $741b5e87f77901ca$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$3Jutl(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($741b5e87f77901ca$var$isArray(list)) $741b5e87f77901ca$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $741b5e87f77901ca$var$forEachString(list, iterator, receiver);
    else $741b5e87f77901ca$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("3Jutl", function(module, exports) {
'use strict';
var $2b7d363d3364a494$var$fnToStr = Function.prototype.toString;
var $2b7d363d3364a494$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $2b7d363d3364a494$var$badArrayLike;
var $2b7d363d3364a494$var$isCallableMarker;
if (typeof $2b7d363d3364a494$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $2b7d363d3364a494$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $2b7d363d3364a494$var$isCallableMarker;
        }
    });
    $2b7d363d3364a494$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $2b7d363d3364a494$var$reflectApply(function() {
        throw 42;
    }, null, $2b7d363d3364a494$var$badArrayLike);
} catch (_) {
    if (_ !== $2b7d363d3364a494$var$isCallableMarker) $2b7d363d3364a494$var$reflectApply = null;
}
else $2b7d363d3364a494$var$reflectApply = null;
var $2b7d363d3364a494$var$constructorRegex = /^\s*class\b/;
var $2b7d363d3364a494$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $2b7d363d3364a494$var$fnToStr.call(value);
        return $2b7d363d3364a494$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $2b7d363d3364a494$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($2b7d363d3364a494$var$isES6ClassFn(value)) return false;
        $2b7d363d3364a494$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $2b7d363d3364a494$var$toStr = Object.prototype.toString;
var $2b7d363d3364a494$var$objectClass = '[object Object]';
var $2b7d363d3364a494$var$fnClass = '[object Function]';
var $2b7d363d3364a494$var$genClass = '[object GeneratorFunction]';
var $2b7d363d3364a494$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $2b7d363d3364a494$var$ddaClass2 = '[object HTML document.all class]';
var $2b7d363d3364a494$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $2b7d363d3364a494$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $2b7d363d3364a494$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $2b7d363d3364a494$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $2b7d363d3364a494$var$all = document.all;
    if ($2b7d363d3364a494$var$toStr.call($2b7d363d3364a494$var$all) === $2b7d363d3364a494$var$toStr.call(document.all)) $2b7d363d3364a494$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($2b7d363d3364a494$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $2b7d363d3364a494$var$toStr.call(value);
            return (str === $2b7d363d3364a494$var$ddaClass || str === $2b7d363d3364a494$var$ddaClass2 || str === $2b7d363d3364a494$var$ddaClass3 // opera 12.16
             || str === $2b7d363d3364a494$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $2b7d363d3364a494$var$reflectApply ? function isCallable(value) {
    if ($2b7d363d3364a494$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $2b7d363d3364a494$var$reflectApply(value, null, $2b7d363d3364a494$var$badArrayLike);
    } catch (e) {
        if (e !== $2b7d363d3364a494$var$isCallableMarker) return false;
    }
    return !$2b7d363d3364a494$var$isES6ClassFn(value) && $2b7d363d3364a494$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($2b7d363d3364a494$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($2b7d363d3364a494$var$hasToStringTag) return $2b7d363d3364a494$var$tryFunctionObject(value);
    if ($2b7d363d3364a494$var$isES6ClassFn(value)) return false;
    var strClass = $2b7d363d3364a494$var$toStr.call(value);
    if (strClass !== $2b7d363d3364a494$var$fnClass && strClass !== $2b7d363d3364a494$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $2b7d363d3364a494$var$tryFunctionObject(value);
};

});


parcelRegister("lsTls", function(module, exports) {
'use strict';

var $58y0d = parcelRequire("58y0d");
var $fa0724e4ad0d85ae$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $58y0d.length; i++)if (typeof $fa0724e4ad0d85ae$var$g[$58y0d[i]] === 'function') // @ts-expect-error
    out[out.length] = $58y0d[i];
    return out;
};

});
parcelRegister("58y0d", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("jS9v3", function(module, exports) {
'use strict';

var $8hAll = parcelRequire("8hAll");

var $7dXGV = parcelRequire("7dXGV");

var $9XTQG = parcelRequire("9XTQG");

var $b65VK = parcelRequire("b65VK");
module.exports = function callBind(originalFunction) {
    var func = $9XTQG(arguments);
    var adjustedLength = 1 + originalFunction.length - (arguments.length - 1);
    return $8hAll(func, adjustedLength > 0 ? adjustedLength : 0, true);
};
if ($7dXGV) $7dXGV(module.exports, 'apply', {
    value: $b65VK
});
else module.exports.apply = $b65VK;

});
parcelRegister("8hAll", function(module, exports) {
'use strict';

var $5XoKB = parcelRequire("5XoKB");

var $1FJER = parcelRequire("1FJER");

var $607c1a4d22289651$var$hasDescriptors = (parcelRequire("8CDym"))();

var $eJu2D = parcelRequire("eJu2D");

var $OG0Ue = parcelRequire("OG0Ue");
var $607c1a4d22289651$var$$floor = $5XoKB('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $OG0Ue('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $607c1a4d22289651$var$$floor(length) !== length) throw new $OG0Ue('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $eJu2D) {
        var desc = $eJu2D(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($607c1a4d22289651$var$hasDescriptors) $1FJER(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $1FJER(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("1FJER", function(module, exports) {
'use strict';

var $7dXGV = parcelRequire("7dXGV");

var $6TBlj = parcelRequire("6TBlj");

var $OG0Ue = parcelRequire("OG0Ue");

var $eJu2D = parcelRequire("eJu2D");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $OG0Ue('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $OG0Ue('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $OG0Ue('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $OG0Ue('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $OG0Ue('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $OG0Ue('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$eJu2D && $eJu2D(obj, property);
    if ($7dXGV) $7dXGV(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $6TBlj('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("8CDym", function(module, exports) {
'use strict';

var $7dXGV = parcelRequire("7dXGV");
var $64708dc9f5193715$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$7dXGV;
};
$64708dc9f5193715$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$7dXGV) return null;
    try {
        return $7dXGV([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $64708dc9f5193715$var$hasPropertyDescriptors;

});


parcelRegister("b65VK", function(module, exports) {
'use strict';

var $dY0J9 = parcelRequire("dY0J9");

var $irkS1 = parcelRequire("irkS1");

var $irSVr = parcelRequire("irSVr");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $irSVr($dY0J9, $irkS1, arguments);
};

});



parcelRegister("4fFEF", function(module, exports) {
'use strict';

var $bw8Od = parcelRequire("bw8Od");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$bw8Od(value);
};

});


parcelRegister("7Tl5t", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});





"use strict";
"use strict";
function $ddccf22a20667601$var$animateHamburgerIconOnHover({ target: elHamburger, reverse: reverse = false }) {
    if (!anime) return;
    if (!elHamburger) return;
// Animate svg line paths from right to left
// const hamburgerAnimation = anime.timeline({
//     easing: 'easeInOutQuad',
//     duration: 2500,
//     autoplay: false,
//     direction: reverse ? 'reverse' : 'normal'
// });
// hamburgerAnimation
// .add({
//     targets: '#aw-nav-menu-icon .line-1',
//     strokeDashoffset: [anime.setDashoffset, 0],
//     duration: 3500
// })
// .add({
//     targets: '#aw-nav-menu-icon .line-2',
//     strokeDashoffset: [anime.setDashoffset, 0],
//     duration: 1500
// }, '-=500')
}
function $ddccf22a20667601$var$animationInit() {
    const elHamburger = document.getElementById('aw-nav-menu-icon');
    elHamburger.addEventListener('mouseenter', ()=>$ddccf22a20667601$var$animateHamburgerIconOnHover({
            target: elHamburger
        }));
    elHamburger.addEventListener('mouseleave', ()=>$ddccf22a20667601$var$animateHamburgerIconOnHover({
            target: elHamburger,
            reverse: true
        }));
}
// Check if loaded event has already fired
// if( document.readyState === 'complete' || document.readyState === 'interactive' ){
//     animationInit();
// }
window.addEventListener('load', $ddccf22a20667601$var$animationInit);


"use strict";

var $iD6GO = parcelRequire("iD6GO");
function $7cd0362db039b3c3$var$animateNavOnScroll() {
    const elNavContainer = document.getElementById('aw-nav-wrapper');
    const elNavRoot = elNavContainer?.querySelector('#aw-nav-root');
    if (!elNavContainer || !anime) return;
    anime.set(elNavContainer, {
        background: 'var(--bs-body-bg)'
    });
    let lastScrollTop = 0;
    let isVisible = false;
    let isAnimating = false;
    let scrollUpDistance = 0;
    const SCROLL_UP_THRESHOLD = 50;
    function animateNavIn() {
        if (isAnimating || isVisible) return;
        isAnimating = true;
        elNavContainer?.classList.add('position-sticky');
        elNavRoot?.classList.add('border-bottom');
        anime({
            targets: elNavContainer,
            opacity: [
                0,
                1
            ],
            translateY: [
                '-20%',
                '0%'
            ],
            duration: 200,
            easing: 'easeOutQuad',
            complete: ()=>{
                isAnimating = false;
                isVisible = true;
            }
        });
    }
    function animateNavOut() {
        // If animateNavIn is mid-flight, cancel it and snap to hidden immediately
        if (isAnimating && !isVisible) {
            anime.remove(elNavContainer);
            isAnimating = false;
            elNavContainer?.classList.remove('position-sticky');
            elNavRoot?.classList.remove('border-bottom');
            anime({
                targets: elNavContainer,
                opacity: 0,
                translateY: '-20%',
                duration: 0
            });
            return;
        }
        if (isAnimating || !isVisible) return;
        isAnimating = true;
        anime({
            targets: elNavContainer,
            // opacity: [ 1, 0 ],
            translateY: [
                '0%',
                '-100%'
            ],
            duration: 200,
            easing: 'easeInQuad',
            complete: ()=>{
                isAnimating = false;
                isVisible = false;
                elNavContainer?.classList.remove('position-sticky');
                elNavRoot?.classList.remove('border-bottom');
            }
        });
    }
    function resetNav() {
        if (!isVisible && !isAnimating) return;
        anime.remove(elNavContainer);
        isAnimating = true;
        anime({
            targets: elNavContainer,
            opacity: 0,
            duration: 0,
            easing: 'linear',
            complete: ()=>{
                isAnimating = false;
                isVisible = false;
                elNavContainer?.classList.remove('position-sticky');
                elNavRoot?.classList.remove('border-bottom');
                anime({
                    targets: elNavContainer,
                    opacity: [
                        0,
                        1
                    ],
                    translateY: '0%',
                    background: 'none',
                    duration: 300
                });
            }
        });
    }
    function animateNav() {
        const currentY = window.scrollY;
        if (currentY <= 800) {
            scrollUpDistance = 0;
            resetNav();
        } else if (currentY < lastScrollTop) {
            scrollUpDistance += lastScrollTop - currentY;
            if (scrollUpDistance >= SCROLL_UP_THRESHOLD) animateNavIn();
        } else {
            scrollUpDistance = 0;
            animateNavOut();
        }
        lastScrollTop = currentY;
    }
    const throttleAnimate = (0, $iD6GO.throttle)(50, ()=>animateNav());
    window.addEventListener('scroll', throttleAnimate, {
        passive: true
    });
}
document.addEventListener('DOMContentLoaded', ()=>{
    // If body has class "nav-overlaps-content" or "home", don't animate the nav on scroll
    if (document.body.classList.contains('nav-overlaps-content') || document.body.classList.contains('home') || window?.noStickyNav === true // Add window.noStickyNav === true using a custom HTML block on pages that do not need sticky nav (e.g. homepage, landing pages, etc.)
    ) return;
    $7cd0362db039b3c3$var$animateNavOnScroll();
});


"use strict";
function $23c4d17ebd7f13b4$var$animateLogo() {
    const elLogoWrapper = document.querySelector('.aw-logo-wrapper');
    if (!elLogoWrapper || !anime) return;
// TO DO
}
document.addEventListener('DOMContentLoaded', $23c4d17ebd7f13b4$var$animateLogo);


var $38d9ac0b5bb493dd$exports = {};
"use strict";
Object.defineProperty($38d9ac0b5bb493dd$exports, "__esModule", {
    value: true
});
$38d9ac0b5bb493dd$exports.App = $38d9ac0b5bb493dd$var$App;

var $38d9ac0b5bb493dd$var$_Search = $38d9ac0b5bb493dd$var$_interopRequireDefault((parcelRequire("lPUkq")));

var $38d9ac0b5bb493dd$var$_LogoAdw = $38d9ac0b5bb493dd$var$_interopRequireDefault((parcelRequire("6OqqF")));

var $38d9ac0b5bb493dd$var$_MainMenu = $38d9ac0b5bb493dd$var$_interopRequireDefault((parcelRequire("fTar7")));

var $38d9ac0b5bb493dd$var$_ThemeSwitcher = $38d9ac0b5bb493dd$var$_interopRequireDefault((parcelRequire("3LfrR")));

var $38d9ac0b5bb493dd$var$_UserNav = $38d9ac0b5bb493dd$var$_interopRequireDefault((parcelRequire("f3KQH")));
function $38d9ac0b5bb493dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $38d9ac0b5bb493dd$var$_extends() {
    return $38d9ac0b5bb493dd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $38d9ac0b5bb493dd$var$_extends.apply(null, arguments);
}
const $38d9ac0b5bb493dd$var$React = window.React || null;
const { useState: $38d9ac0b5bb493dd$var$useState, useEffect: $38d9ac0b5bb493dd$var$useEffect } = $38d9ac0b5bb493dd$var$React;
const $38d9ac0b5bb493dd$var$ReactDOM = window.ReactDOM || null;
function $38d9ac0b5bb493dd$var$App() {
    // Insert App into the DOM immediately before end of body using react portal
    // ReactDOM.createPortal(<App />,
    return /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement($38d9ac0b5bb493dd$var$React.Fragment, null, /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement("div", null, $38d9ac0b5bb493dd$var$ReactDOM.createPortal(/*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement($38d9ac0b5bb493dd$var$NavModal, null), document.body)));
}
function $38d9ac0b5bb493dd$var$NavModal({ show: show = false }) {
    const [toggleVisibility, setToggleVisibility] = $38d9ac0b5bb493dd$var$useState(show || false);
    const refNavModal = $38d9ac0b5bb493dd$var$React.useRef(null);
    // Toggle visibility of modal menu
    $38d9ac0b5bb493dd$var$useEffect(()=>{
        const elHamburgerIcon = document.getElementById('aw-nav-menu-icon');
        elHamburgerIcon?.addEventListener('click', ()=>{
            setToggleVisibility(true);
        });
        // Close modal when esc key is pressed
        const handleKeyDownClose = (event)=>{
            if (event.key === 'Escape') setToggleVisibility(false);
        };
        document.addEventListener('keydown', handleKeyDownClose, {
            passive: true
        });
        return ()=>{
            // Clean up event listeners
            elHamburgerIcon?.removeEventListener('click', ()=>{
                setToggleVisibility(true);
            });
            document.removeEventListener('keydown', handleKeyDownClose);
        };
    }, []);
    const handleBodyScroll = (toggleVisibility)=>{
        if (toggleVisibility === true) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = 'auto';
    };
    // Open modal if `/` is pressed
    $38d9ac0b5bb493dd$var$useEffect(()=>{
        // If modal is already open, do not add event listener
        if (toggleVisibility) return;
        const elHamburgerIcon = document.getElementById('aw-nav-menu-icon');
        // Open modal when `/` key is pressed
        const handleKeyDownOpen = (event)=>{
            if (event.key === '/') {
                if (toggleVisibility === false) {
                    event.stopPropagation();
                    event.preventDefault();
                    elHamburgerIcon?.click();
                    const elSearch = document.querySelector('.adw-search');
                    if (elSearch) elSearch.value = '';
                }
            }
        };
        document.addEventListener('keydown', handleKeyDownOpen);
        return ()=>{
            // Clean up event listeners
            document.removeEventListener('keydown', handleKeyDownOpen);
        };
    }, [
        toggleVisibility
    ]);
    // Handle body scroll
    $38d9ac0b5bb493dd$var$useEffect(()=>{
        handleBodyScroll(toggleVisibility);
    }, [
        toggleVisibility
    ]);
    return /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement($38d9ac0b5bb493dd$var$React.Fragment, null, toggleVisibility && /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement("div", {
        className: "bg-light-subtle z-3 w-100 d-flex flex-column position-fixed top-0 bottom-0 left-0 right-0 overflow-auto ",
        style: {
            backgroundColor: "var(--bs-body-bg)",
            color: "var(--bs-body-color)"
        },
        ref: refNavModal,
        id: "nav-modal"
    }, /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement("div", {
        className: "container-xxl pb-5 px-4 px-xxl-0 d-flex h-100 flex-column gap-2 gap-lg-4 "
    }, /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement("div", {
        className: "d-flex w-100 py-3 py-lg-5 ps-0 pe-4 px-sm-4 px-xxl-0 justify-content-between align-items-center"
    }, /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement($38d9ac0b5bb493dd$var$_LogoAdw.default, null), /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement("div", {
        className: "d-flex align-items-center gap-3"
    }, /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement($38d9ac0b5bb493dd$var$UserNavPortal, {
        className: "d-none d-lg-flex"
    }), /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement("div", {
        className: ""
    }, /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement($38d9ac0b5bb493dd$var$_ThemeSwitcher.default, null)), /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement("button", {
        onClick: ()=>setToggleVisibility(!toggleVisibility),
        className: "btn-link border-0 align-self-center p-0"
    }, /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement($38d9ac0b5bb493dd$var$CloseIcon, null)))), /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement("div", {
        className: "flex-grow-1 d-flex flex-column gap-4 gap-lg-5 mt-lg-4 pb-5 border-bottom border-primary"
    }, /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement($38d9ac0b5bb493dd$var$UserNavPortal, {
        className: "d-flex d-lg-none justify-content-end justify-content-lg-start mb-4"
    }), /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement($38d9ac0b5bb493dd$var$_Search.default, {
        onClose: ()=>setToggleVisibility(false)
    }), /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement($38d9ac0b5bb493dd$var$_MainMenu.default, null)), /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement($38d9ac0b5bb493dd$var$FooterMenu, null))));
}
const $38d9ac0b5bb493dd$var$CloseIcon = (props)=>{
    return /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement("svg", $38d9ac0b5bb493dd$var$_extends({}, props, {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }), /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.6929 6.29289C25.0834 5.90237 25.7166 5.90237 26.1071 6.29289C26.4977 6.68342 26.4977 7.31658 26.1071 7.70711L17.8142 16L26.1071 24.2929C26.4977 24.6834 26.4977 25.3166 26.1071 25.7071C25.7166 26.0976 25.0834 26.0976 24.6929 25.7071L16.4 17.4142L8.10713 25.7071C7.71661 26.0976 7.08344 26.0976 6.69292 25.7071C6.30239 25.3166 6.30239 24.6834 6.69292 24.2929L14.9858 16L6.69292 7.70711C6.30239 7.31658 6.30239 6.68342 6.69292 6.29289C7.08344 5.90237 7.71661 5.90237 8.10713 6.29289L16.4 14.5858L24.6929 6.29289Z",
        fill: "currentColor"
    }));
};
const $38d9ac0b5bb493dd$var$UserNavPortal = ({ className: className = '' })=>{
    const ref = $38d9ac0b5bb493dd$var$React.useRef(null);
    const [portalNode, setPortalNode] = $38d9ac0b5bb493dd$var$useState(null);
    const [innerHtml, setInnerHtml] = $38d9ac0b5bb493dd$var$useState('');
    $38d9ac0b5bb493dd$var$useEffect(()=>{
        setPortalNode(ref.current);
        const elUserNav = document.querySelector('.user-nav');
        setInnerHtml(elUserNav?.innerHTML || '');
    }, []);
    return /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement("div", {
        className: className,
        ref: ref
    }, portalNode && $38d9ac0b5bb493dd$var$ReactDOM.createPortal(/*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement($38d9ac0b5bb493dd$var$_UserNav.default, {
        innerHtml: innerHtml
    }), portalNode));
};
const $38d9ac0b5bb493dd$var$FooterMenu = ()=>{
    const footerHtmlMarkup = document.querySelector('.footer-nav')?.outerHTML || '';
    return /*#__PURE__*/ $38d9ac0b5bb493dd$var$React.createElement("div", {
        className: "footer-nav-in-modal mb-5 mx-n4 ",
        dangerouslySetInnerHTML: {
            __html: footerHtmlMarkup
        }
    });
};



var $4ecc737a5d46b10a$var$_navAlertsApp = $4ecc737a5d46b10a$var$_interopRequireDefault((parcelRequire("bAqQo")));

var $4ecc737a5d46b10a$var$_UserNav = $4ecc737a5d46b10a$var$_interopRequireDefault((parcelRequire("f3KQH")));

var $4ecc737a5d46b10a$var$_ArticleReadTime = $4ecc737a5d46b10a$var$_interopRequireDefault((parcelRequire("gDoZE")));
function $4ecc737a5d46b10a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4ecc737a5d46b10a$var$React = window.React || null;
const $4ecc737a5d46b10a$var$ReactDOM = window.ReactDOM || null;
if (!$4ecc737a5d46b10a$var$React || !$4ecc737a5d46b10a$var$ReactDOM) throw new Error('React and ReactDOM are required for this plugin');
const { client: $4ecc737a5d46b10a$var$client } = $4ecc737a5d46b10a$var$ReactDOM;
const { createRoot: $4ecc737a5d46b10a$var$createRoot } = $4ecc737a5d46b10a$var$client;
// Conditionally load react component and render it on click of hamburger icon with id 'menu-icon'
function $4ecc737a5d46b10a$var$initNavigationApp() {
    const elNavRootEl = document.getElementById('nav-react-app');
    const elHamburgerIcon = document.getElementById('aw-nav-menu-icon');
    if (elHamburgerIcon && elNavRootEl) {
        const root = $4ecc737a5d46b10a$var$createRoot(elNavRootEl);
        root.render(/*#__PURE__*/ $4ecc737a5d46b10a$var$React.createElement($38d9ac0b5bb493dd$exports.App, null));
    }
}
document.addEventListener('DOMContentLoaded', $4ecc737a5d46b10a$var$initNavigationApp, {
    once: true,
    passive: true
});
function $4ecc737a5d46b10a$var$initNavAlertApp() {
    const root = document.getElementById('adw-nav-alerts');
    if (root) {
        const navAlertRoot = $4ecc737a5d46b10a$var$createRoot(root);
        navAlertRoot.render(/*#__PURE__*/ $4ecc737a5d46b10a$var$React.createElement($4ecc737a5d46b10a$var$_navAlertsApp.default, {
            containerType: "desktop"
        }));
    }
}
function $4ecc737a5d46b10a$var$initMobileNavAlertApp() {
    const mobileRoot = document.getElementById('adw-nav-alerts-mobile');
    if (mobileRoot) {
        const mobileNavAlertRoot = $4ecc737a5d46b10a$var$createRoot(mobileRoot);
        mobileNavAlertRoot.render(/*#__PURE__*/ $4ecc737a5d46b10a$var$React.createElement($4ecc737a5d46b10a$var$_navAlertsApp.default, {
            containerType: "mobile"
        }));
    }
}
document.addEventListener('DOMContentLoaded', $4ecc737a5d46b10a$var$initNavAlertApp, {
    once: true,
    passive: true
});
document.addEventListener('DOMContentLoaded', $4ecc737a5d46b10a$var$initMobileNavAlertApp, {
    once: true,
    passive: true
});
function $4ecc737a5d46b10a$var$createActiveNavItem() {
    // Get the current URL
    const currentUrl = window.location.href;
    // Check if adw.nav_main.items array has item.object === 'vertical'
    // If so, check if item.url's last path segment matches the first path segment of the current URL
    const path = currentUrl.split('/').filter(Boolean);
    const elsNavItems = document.querySelectorAll('.adw-nav-list a');
    if (!elsNavItems?.length) return;
    elsNavItems.forEach((elNavItem)=>{
        const elNavItemUrl = elNavItem.getAttribute('href');
        if (!elNavItemUrl) return;
        const navItemPath = elNavItemUrl.split('/').filter(Boolean);
        if (navItemPath?.[3] && navItemPath?.[2] === 'vertical') {
            const isActive = path[2] === navItemPath[3];
            if (isActive) elNavItem.classList.add('text-primary');
        }
    });
}
document.addEventListener('DOMContentLoaded', $4ecc737a5d46b10a$var$createActiveNavItem, {
    once: true,
    passive: true
});
// Create User Nav menu inside .user-nav
function $4ecc737a5d46b10a$var$renderUserNavMenu() {
    const elUserNav = document.querySelector('.user-nav');
    if (!elUserNav) return;
    const elRoot = $4ecc737a5d46b10a$var$ReactDOM.client.createRoot(elUserNav);
    const innerHtml = elUserNav.innerHTML;
    elRoot.render(/*#__PURE__*/ $4ecc737a5d46b10a$var$React.createElement($4ecc737a5d46b10a$var$_UserNav.default, null));
}
document.addEventListener('DOMContentLoaded', $4ecc737a5d46b10a$var$renderUserNavMenu, {
    once: true,
    passive: true
});
// Load Article Read Time
function $4ecc737a5d46b10a$var$renderArticleReadTime() {
    const elArticleReadTime = document.querySelector('.read-time');
    if (!elArticleReadTime) return;
    const elRoot = $4ecc737a5d46b10a$var$ReactDOM.client.createRoot(elArticleReadTime);
    elRoot.render(/*#__PURE__*/ $4ecc737a5d46b10a$var$React.createElement($4ecc737a5d46b10a$var$_ArticleReadTime.default, null));
}
document.addEventListener('DOMContentLoaded', $4ecc737a5d46b10a$var$renderArticleReadTime, {
    once: true,
    passive: true
});

})();
//# sourceMappingURL=index.js.map
